import type {
  BillingInfo,
  RetireResult,
  SearchConsoleProperty,
  SearchConsoleStatus,
  SearchReport,
  AdminSetting,
  AdminUser,
  AdminUserDeletionPreview,
  AdminUserDeletionResult,
  AdminUserStatusFilter,
  AgentSession,
  AmazonAffiliateSettings,
  AmazonAffiliateSettingsUpdate,
  BoardroomEmailSignup,
  BoardroomEmailSignupStart,
  BoardroomEmailSpyChoice,
  EmailSpyConnection,
  EmailSpyConnectionCreate,
  EmailSpyConnectionUpdate,
  Angle,
  AngleOption,
  ArtifactListResponse,
  AutocompleteResponse,
  BoardroomArchetype,
  BoardroomChat,
  BoardroomDecision,
  BoardroomDeliverables,
  BoardroomDetail,
  BoardroomNotice,
  BoardroomDismissedNotice,
  BoardroomObservation,
  BoardroomRecipe,
  BoardroomFacets,
  BoardroomFocus,
  AgentNote,
  BoardroomLeadBlock,
  BoardroomTagging,
  BoardroomLeadLens,
  BoardroomAnswer,
  BoardroomAnswering,
  BoardroomFrame,
  BoardroomProfile,
  BoardroomReconRun,
  BoardroomRunFindings,
  BoardroomFeatureTwins,
  BoardroomSheetPile,
  BoardroomRunScope,
  BoardroomFilterCount,
  BoardroomItem,
  BoardroomItemDetail,
  BoardroomItemPage,
  BoardroomPage,
  BoardroomPersona,
  BoardroomPromoteResult,
  BoardroomRun,
  BoardroomRunIntent,
  BoardroomTag,
  BoardroomTranscriptMessage,
  BrandProfile,
  BuildCandidateResult,
  BuildPhase,
  BuildStateResponse,
  BulkPageUpdateResult,
  Category,
  ContentVersionCompareResponse,
  ContentVersionDetail,
  ContentVersionListResponse,
  Conversation,
  CoverageScore,
  DashboardStats,
  DeleteVersionResponse,
  DeploymentPlan,
  DeploymentPlanCreate,
  DeploymentPlanPaginatedResponse,
  DeploymentPlanUpdate,
  DeploymentStartResponse,
  DeploymentValidationResponse,
  DiscoverKeywordsChatResponse,
  DiscoveryIdeaAcceptResponse,
  DiscoveryIdeaSort,
  DiscoveryIdeaStatusFilter,
  DocumentDetail,
  DocumentFact,
  DocumentInfo,
  CitationStyle,
  EditableBodyResponse,
  PageBodyPreviewResponse,
  EnsureExtractedResponse,
  ExternalPlacement,
  ExternalTarget,
  ExternalTargetInput,
  GitHubInstallation,
  GitHubInstallationDetail,
  GitHubRepo,
  GoogleAdsHouseGrant,
  GoogleAdsStatus,
  GrowthAgentConfig,
  GrowthAgentConfigUpdate,
  HeroImageState,
  IdeaSource,
  ImageInfo,
  ImageStorageSettings,
  ImageStorageSettingsCreate,
  ImageStorageSettingsListResponse,
  ImageStorageSettingsUpdate,
  ImageStorageTestResponse,
  Keyword,
  KeywordCreateResponse,
  KeywordMatchResponse,
  KnowledgeAgentScope,
  KnowledgeBrief,
  KnowledgeBriefVersionListResponse,
  KnowledgePlanApplyResponse,
  KnowledgePlanResponse,
  KnowledgeProposal,
  KnowledgeProposalStatus,
  KnowledgeProposalType,
  LLMProvider,
  LLMProviderCreate,
  LLMProviderListResponse,
  LLMProviderUpdate,
  LLMSettings,
  LLMSettingsCreate,
  LLMSettingsListResponse,
  LLMSettingsOption,
  LLMSettingsTestRequest,
  LLMSettingsTestResponse,
  LLMSettingsUpdate,
  LLMUsageCalls,
  LLMUsageReport,
  LLMUsageTimeseries,
  LinkClearResult,
  LinkedRoom,
  LinkEdge,
  LinkLockResult,
  LinkMap,
  LinkMapCandidate,
  LinkMapNodes,
  LinkMapScopeRemoved,
  LinkMapSnapshot,
  LinkMapUpdate,
  LinkRepoToSiteRequest,
  LoginResponse,
  ManagedPage,
  ManagedPageBulkCreate,
  ManagedPageBulkCreateByFilter,
  ManagedPageBulkCreateResponse,
  ManagedPageCreate,
  ManagedPagePaginatedResponse,
  ManagedPageUpdate,
  ManagedSite,
  ManagedSiteCreate,
  ManagedSiteGitHubRepo,
  ManagedSiteUpdate,
  MarkReadyResponse,
  MonthlyDataPoint,
  NetworkRequestReport,
  ApiUsageReport,
  ApiUsageTimeseries,
  ApiUsageCallsResponse,
  NetworkRequestRowsResponse,
  NetworkRequestTimeseries,
  NetworkSettings,
  NetworkSettingsUpdate,
  NewsBeatAttribute,
  NewsBeatChat,
  NewsBeatCreate,
  NewsBeatDetail,
  NewsBeatPromotePreview,
  NewsBeatSummary,
  NewsBeatSurface,
  NewsBeatUpdate,
  NewsBeatVerdict,
  NewsBriefingDetail,
  NewsBriefingSummary,
  NewsBriefingTags,
  NewsRunLog,
  NewsStoryThread,
  PageBuildStatus,
  PageBuilderChatResponse,
  PageDetail,
  PageExtractFactsResponse,
  PageKeywordSerpInfo,
  PagePaginatedResponse,
  PageStyle,
  PageStyleSpecOverridePayload,
  PageStyleSpecRow,
  ParserBacktestResult,
  ParserCandidate,
  ParserChat,
  SiteScaffold,
  SiteScaffoldChat,
  SiteScaffoldPreview,
  SiteScaffoldPublishPlan,
  SiteScaffoldSpecVersion,
  ParserOpportunity,
  PersonalAccessToken,
  PersonalAccessTokenCreated,
  PlaceExternalResult,
  SectionSeeds,
  SeedResult,
  ExtensionKind,
  PluginDevice,
  PluginV2Device,
  ProxyList,
  ProxyListBody,
  NetworkFetchersResponse,
  AdaptersResponse,
  FetchQueueResponse,
  ProtectionReport,
  TraceMeta,
  TracePageShow,
  TracePageText,
  TraceRun,
  TraceStartResponse,
  ThroughputResponse,
  NetworkStatus,
  EngineMatrix,
  ProfileUpdate,
  Project,
  ProvenanceResponse,
  ProxyBulkAddResponse,
  ProxyCreateRequest,
  ProxySettings,
  ProxySettingsListResponse,
  ProxyTestResponse,
  ProxyUpdateRequest,
  RecTopicKeywordPaginatedResponse,
  RecommendationApproveResponse,
  RecommendationDetail,
  RecommendationDismissResponse,
  RecommendationPaginatedResponse,
  RecommendationStatus,
  RegisterData,
  ResearchPoint,
  ResearchPointListResponse,
  ResearchSettingsOverridePayload,
  ResearchSettingsResponse,
  KeywordScoringResponse,
  SERPBulkRequestResponse,
  KeywordScoringValue,
  SEOAnalysisRequest,
  SEOAnalysisResponse,
  SERP,
  SERPCompetitionResponse,
  SERPDetailWithPages,
  SERPRequestResponse,
  ScopeUndo,
  SiteGraph,
  SiteGraphSegment,
  SeatListResponse,
  ShareLink,
  SiteParser,
  SiteParserDetail,
  SiteParserSpecVersion,
  StageDiffResponse,
  StageEnum,
  StageEnumListResponse,
  StageModelInfo,
  StructurePlanAcceptResponse,
  StructurePlanClearUnusedResponse,
  StructurePlanMergeDuplicatesResponse,
  StructurePlanResponse,
  StructurePlanSnapshotDetail,
  StructurePlanSnapshotSummary,
  SwitchVersionResponse,
  Topic,
  TopicKeyword,
  TopicKeywordPaginatedResponse,
  TopicLabelsResponse,
  TrendStoriesResponse,
  TrendBriefRequestResponse,
  CreatePageFromProposalResponse,
  TrackSpikingTermResponse,
  TrendTag,
  StartSubjectFromKeywordsResponse,
  BuildContextResponse,
  TrendingKeywordPaginatedResponse,
  UndoScopeRemovalResult,
  User,
  WebSocketTokenResponse,
  PathSegmentSuggestions,
  TopicPagePath,
  SiteStructure,
  SiteStructureMoveResult,
  SiteStructurePageOut,
  ReviewActionResponse,
  ReviewItem,
  ReviewQueueResponse,
  ReleaseDetail,
  ReleaseSummary,
  WatchCatalogue,
  WatchEvent,
  WatchFeedPage,
  WatchTimeline,
  WatchRunPages,
  WatchRunSearches,
  WatchObservation,
  WatchPreferences,
  WatchProbe,
  WatchRun,
  WatchSubject,
  WatchSubjectKind,
  WatchSubjectMember,
  WatchTrackResult,
  BoardroomBrand,
  BoardroomBrandStart,
  BoardroomBrandWatch,
  BoardroomFilings,
  BoardroomTagList,
  BoardroomAxisWrite,
  BoardroomAxisSkipped,
  SortingWaiting,
  WatchUnread,
  WatchVerdict,
} from '../types';

import { apiErrorMessage } from './errorMessage';
import { apiOriginFor } from './apiOrigin';
import { houseLoginUrl } from '../shell/houseLogin';
import type {
  AdminCatalogRow,
  AdminCredits,
  AdminEntitlement,
  AdminEntitlementGrant,
  AdminNetworkCosts,
  AdminPriceBooks,
  AdminPriceBookVersion,
  CreditLedgerRow,
  CreditsBalance,
  LLMRate,
  MarginReport,
  ProviderQuota,
  WhatIfResult,
  PipelineDiffRow,
  PipelineVersion,
  PipelineVersionList,
  StageModelRule,
  StageModelRuleIn,
  PoolCandidates,
  HouseModelName,
  StageModelResult,
  StageModelResultIn,
  BenchAdvice,
  BenchEntryStatus,
  BenchPreview,
  BenchResultsFile,
  CopiedPolicy,
  PastePreview,
  PlanKey,
  StripePriceInput,
  StripePriceRow,
  Product,
  ProductAvailability,
  SerpGapFilter,
} from '../types';

// Derived from where the app is served unless explicitly set — the session
// cookie is SameSite=Lax and will not cross to a different registrable domain,
// so `beats.lumnian.test` must call `api.lumnian.test`, not `localhost`. See
// services/apiOrigin.ts.
const API_BASE_URL = apiOriginFor(
  window.location.hostname,
  window.location.origin,
  process.env.REACT_APP_API_URL,
);
export const NULL_REF_ID = -1;

/**
 * A failed request, carrying the STATUS as well as the message.
 *
 * Not every 4xx is an error to show someone. "Nothing is running" on a Stop is the
 * server saying your view is stale — the burst had already ended — and the right
 * response is to refresh, not to print it and leave a dead Stop button on screen for
 * the user to click again. Callers can't tell those apart from a message string, so
 * the status travels with it.
 *
 * Extends Error, so every existing `e instanceof Error ? e.message` catch is unchanged.
 */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    /** The machine-readable `code` a structured detail carries (a login 403
     *  says `unverified` / `pending` / ...), so a caller can branch without
     *  grepping the sentence. Undefined when the detail was plain prose. */
    readonly code?: string,
    /** The structured detail itself, when there was one. A 402 carries
     *  `{error: 'credits_exhausted', balance}` / `{error: 'plan_limit', ...}`
     *  / `{error: 'product_required', product}` — enough to render an offer
     *  (`billing/credits.ts:paywallOf`) instead of a sentence. */
    readonly detail?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

function detailCode(detail: unknown): string | undefined {
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    const code = (detail as { code?: unknown }).code;
    if (typeof code === 'string') return code;
  }
  return undefined;
}

type BoardroomFrameBlock = { frame: BoardroomFrame | null; frame_proposals: BoardroomFrame[]; frame_history: BoardroomFrame[] };
/** The whiteboard: the answer on the board, every version, and the counters the
 *  line beside Stop is drawn from. Always travels whole — a client that got the
 *  answer without its counters would show a fresh stance under a stale "has not
 *  moved in N turns". */
type BoardroomAnswerBlock = { answer: BoardroomAnswer | null; answer_history: BoardroomAnswer[]; answering: BoardroomAnswering };

/** The open-position filters as the backend names them (keywords/serp_gap.py). */
function serpGapBody(f: SerpGapFilter | null | undefined): Record<string, string | number> {
  if (!f) return {};
  const out: Record<string, string | number> = {};
  if (f.minOpen != null) out.gap_min_open = f.minOpen;
  if (f.bestWithin != null) out.gap_best_within = f.bestWithin;
  if (f.engine) out.gap_engine = f.engine;
  return out;
}

function serpGapQuery(f: SerpGapFilter | null | undefined): string {
  return Object.entries(serpGapBody(f))
    .map(([k, v]) => `&${k}=${encodeURIComponent(String(v))}`)
    .join('');
}

/** The room's lens as query parameters: each tag, then the checks. */
function lensQuery(lens: { tags?: string[]; verified?: string | null; sourced?: string | null; by?: string | null }) {
  const qs = new URLSearchParams();
  for (const t of lens.tags ?? []) qs.append('tag', t);
  if (lens.verified) qs.set('verified', lens.verified);
  if (lens.sourced) qs.set('sourced', lens.sourced);
  if (lens.by) qs.set('by', lens.by);
  return qs;
}

class ApiService {
  private token: string | null;

  constructor() {
    this.token = localStorage.getItem('token');
  }

  setToken(token: string | null): void {
    this.token = token;
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }

  getToken(): string | null {
    return this.token;
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {},
    /** Whether a 401 should sign the user out and bounce to /login.
     *
     *  TRUE FOR EVERYTHING EXCEPT THE SESSION PROBE AND THE GOOGLE HANDOFF. `probeSession` runs on
     *  every page load including /login itself, where a 401 is the expected
     *  answer — redirecting there would reload the page, probe again, and loop
     *  forever. */
    redirectOn401 = true,
  ): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`;
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (this.token) {
      (headers as Record<string, string>)['Authorization'] = `Bearer ${this.token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers,
      // SEND THE SESSION COOKIE. The API is on api.lumnian.com and the apps are
      // on app/boardroom/beats/publish.lumnian.com, so every request is
      // cross-origin and the cookie is omitted unless asked for. Without this
      // the shells fall back to the header token and lose the single sign-on the
      // cookie exists to provide.
      credentials: 'include',
    });

    if (response.status === 401) {
      this.setToken(null);
      if (redirectOn401) {
        // Sign in at the house, and come back here afterwards. On the house
        // itself (or a single-label host) there is nowhere else to go, so it
        // is this host's own /login as before.
        window.location.href =
          houseLoginUrl(window.location.hostname, window.location.origin, window.location.href) ??
          '/login';
      }
      throw new ApiError('Unauthorized', 401);
    }

    // 402 IS NOT 401. "You have not bought this product" must not log anybody
    // out — that was the first thing to get wrong here, because the nearest
    // existing branch signs you out and redirects. It falls through to the
    // normal error path below, so the caller sees an ApiError with status 402
    // and a `product_required` detail it can turn into an offer.

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Request failed' }));
      const detail = error.detail;
      // A STRUCTURED detail is for the caller, not for the user: an endpoint that
      // refuses with a machine-readable fix (the cast a Run is missing, say) carries a
      // human sentence in `message`, and dumping the raw JSON at someone instead of
      // reading it is how "Nobody seated can record a pain — invite the Customer voice"
      // reaches them as {"message":"Nobody seated...","seat":["customer_voice"]}.
      // FastAPI 422s arrive as an ARRAY of validation errors and used to fall
      // through to JSON.stringify — see services/errorMessage.ts.
      const message = apiErrorMessage(detail);
      throw new ApiError(message, response.status, detailCode(detail), detail);
    }

    if (response.status === 204) {
      return null as T;
    }

    return response.json();
  }

  // Auth
  async login(username: string, password: string): Promise<LoginResponse> {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
      // THE MOST IMPORTANT `credentials` IN THE FILE. This is the response that
      // carries Set-Cookie, and on a cross-origin request the browser DISCARDS
      // it unless the request opted in — silently, with a 200 and a token in the
      // body, so the sign-in looks completely successful.
      //
      // Without it the session cookie is never stored at all: the shell you
      // logged in on works (its localStorage has the token) and every other
      // shell sends you back to /login, which reads as "single sign-on is
      // broken" rather than "the cookie was thrown away on arrival".
      //
      // This endpoint does not use `request()` because it posts form encoding,
      // which is exactly how it got missed when `credentials` was added there.
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Login failed' }));
      // An ApiError, not a bare Error: the login page branches on the status
      // and the code (an unverified account gets a resend button, a pending
      // one an amber notice) and neither is recoverable from the sentence.
      throw new ApiError(
        apiErrorMessage(error.detail ?? 'Login failed'),
        response.status,
        detailCode(error.detail),
      );
    }

    const data: LoginResponse = await response.json();
    this.setToken(data.access_token);
    return data;
  }

  // --- email links and Google sign-in -------------------------------------
  //
  // All through `request()`, so every one sends the cookie and throws ApiError.

  /** Always resolves with the same message whether or not the address exists. */
  async forgotPassword(email: string): Promise<{ message: string }> {
    return this.request('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    return this.request('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, new_password: newPassword }),
    });
  }

  async verifyEmail(token: string): Promise<{ message: string }> {
    return this.request('/auth/verify-email', {
      method: 'POST',
      body: JSON.stringify({ token }),
    });
  }

  async resendVerification(email: string): Promise<{ message: string }> {
    return this.request('/auth/resend-verification', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

  /** Where "Sign in with Google" sends the browser: a plain navigation to the
   *  API, which redirects on to Google. Not a fetch — the redirect chain has
   *  to happen in the top-level window. */
  googleSignInUrl(next: string | null): string {
    const base = `${API_BASE_URL}/auth/google/start`;
    return next ? `${base}?next=${encodeURIComponent(next)}` : base;
  }

  /** The last step of Google sign-in: trade the handoff the callback sent us
   *  back with for a session. Same response shape (and same token bookkeeping)
   *  as `login`. */
  async completeGoogleSignIn(handoff: string): Promise<LoginResponse> {
    // No 401 redirect: an expired handoff answers 401, and the generic bounce
    // to a bare login page would beat GoogleDone's own navigation to
    // /login?notice=google_failed, which is the one that says what happened.
    const data = await this.request<LoginResponse>(
      '/auth/google/complete',
      {
        method: 'POST',
        body: JSON.stringify({ handoff }),
      },
      false,
    );
    this.setToken(data.access_token);
    return data;
  }

  async logout(): Promise<void> {
    await this.request('/auth/logout', { method: 'POST' }).catch(() => {});
    this.setToken(null);
  }

  async getMe(): Promise<User> {
    return this.request<User>('/auth/me');
  }

  /**
   * Who am I, according to the session cookie?
   *
   * WHY THIS EXISTS. The app used to decide "am I signed in" from a token in
   * `localStorage`, which is ORIGIN-SCOPED — so opening beats.lumnian.com after
   * signing in at app.lumnian.com found nothing there and showed the login page,
   * even though the `.lumnian.com` session cookie was sitting right there and
   * valid. The server was answering; nobody was asking.
   *
   * So: always ask. Returns null instead of throwing, and never redirects, so
   * it is safe to call on every page load including /login.
   */
  async probeSession(): Promise<User | null> {
    try {
      return await this.request<User>('/auth/me', {}, false);
    } catch {
      return null;
    }
  }

  /** What this user has bought, plus the full catalog.
   *
   *  Deliberately NOT folded into `/auth/me`: entitlements change without the
   *  user changing (a grant, a lapse, a cancellation), and there are N of them
   *  rather than a field. Keeping them separate means a billing change does not
   *  have to invalidate the user object. */
  async getBilling(): Promise<BillingInfo> {
    return this.request<BillingInfo>('/billing/me');
  }

  /** The user's own credit movements, newest first. */
  async getCreditLedger(limit = 50): Promise<{ rows: CreditLedgerRow[] }> {
    return this.request<{ rows: CreditLedgerRow[] }>(`/billing/ledger?limit=${limit}`);
  }

  // --- stripe: all three hand back a URL to send the browser to ------------
  //
  // Checkout and the Portal are HOSTED by Stripe, so there is no card form
  // here and nothing sensitive passes through this client. The success and
  // cancel URLs are built on the SERVER from FRONTEND_URL — a caller-supplied
  // return address on a payments endpoint is an open redirect.

  /** Start a subscription. 400 when we do not sell that (product, plan) —
   *  which is how a product with no price rows stays unbuyable. */
  async createCheckoutSession(product: Product, plan: PlanKey): Promise<{ url: string }> {
    return this.request<{ url: string }>('/billing/checkout-session', {
      method: 'POST',
      body: JSON.stringify({ product, plan }),
    });
  }

  /** Buy a credit pack. The server looks the price up rather than trusting it,
   *  so naming another price here buys nothing. */
  async createTopupSession(stripePriceId: string): Promise<{ url: string }> {
    return this.request<{ url: string }>('/billing/topup-session', {
      method: 'POST',
      body: JSON.stringify({ stripe_price_id: stripePriceId }),
    });
  }

  /** The Customer Portal — one door to every subscription, invoices and cards. */
  async createPortalSession(): Promise<{ url: string }> {
    return this.request<{ url: string }>('/billing/portal-session', { method: 'POST' });
  }

  // --- admin: access + credits ---------------------------------------------

  async adminListEntitlements(userId: number): Promise<AdminEntitlement[]> {
    return this.request<AdminEntitlement[]>(`/admin/users/${userId}/entitlements`);
  }

  async adminGrantEntitlement(userId: number, body: AdminEntitlementGrant): Promise<AdminEntitlement> {
    return this.request<AdminEntitlement>(`/admin/users/${userId}/entitlements`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async adminSettleOverage(userId: number): Promise<{ credits: CreditsBalance; settled: number }> {
    return this.request<{ credits: CreditsBalance; settled: number }>(
      `/admin/users/${userId}/credits/settle-overage`,
      { method: 'POST' },
    );
  }

  async adminRevokeEntitlement(userId: number, product: Product): Promise<AdminEntitlement> {
    return this.request<AdminEntitlement>(`/admin/users/${userId}/entitlements/${product}`, {
      method: 'DELETE',
    });
  }

  async adminGetCredits(userId: number): Promise<AdminCredits> {
    return this.request<AdminCredits>(`/admin/users/${userId}/credits`);
  }

  async adminAdjustCredits(
    userId: number,
    credits: number,
    note: string,
  ): Promise<{ credits: CreditsBalance }> {
    return this.request<{ credits: CreditsBalance }>(`/admin/users/${userId}/credits`, {
      method: 'POST',
      body: JSON.stringify({ credits, note }),
    });
  }

  async adminGetPriceBook(): Promise<AdminPriceBooks> {
    return this.request<AdminPriceBooks>('/admin/billing/price-book');
  }

  async adminSavePriceBook(body: {
    usd_per_credit: number;
    llm_rates: Record<string, LLMRate>;
    network_rates: Record<string, number>;
    byok_llm_multiplier: number;
    byok_network_multiplier: number;
    note?: string;
  }): Promise<AdminPriceBookVersion> {
    return this.request<AdminPriceBookVersion>('/admin/billing/price-book', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async adminGetMargin(opts: {
    period: 'hour' | 'day' | 'month' | 'year';
    periodDate?: string;
    product?: string;
    userId?: number;
    providerId?: number;
  }): Promise<MarginReport> {
    const params = new URLSearchParams({ period: opts.period });
    if (opts.periodDate) params.set('period_date', opts.periodDate);
    if (opts.product) params.set('product', opts.product);
    if (opts.userId) params.set('user_id', String(opts.userId));
    if (opts.providerId) params.set('provider_id', String(opts.providerId));
    return this.request<MarginReport>(`/admin/billing/margin?${params}`);
  }

  async adminGetQuotas(): Promise<ProviderQuota[]> {
    return this.request<ProviderQuota[]>('/admin/billing/quotas');
  }

  async adminWhatIf(body: {
    usd_per_credit: number;
    llm_rates: Record<string, LLMRate>;
    network_rates: Record<string, number>;
    byok_llm_multiplier: number;
    byok_network_multiplier: number;
    days?: number;
  }): Promise<WhatIfResult> {
    return this.request<WhatIfResult>('/admin/billing/what-if', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async adminGetNetworkCosts(): Promise<AdminNetworkCosts> {
    return this.request<AdminNetworkCosts>('/admin/billing/network-costs');
  }

  async adminPutNetworkCost(kind: string, downloader: string, usdPerCall: number): Promise<void> {
    await this.request<unknown>('/admin/billing/network-costs', {
      method: 'PUT',
      body: JSON.stringify({ kind, downloader, usd_per_call: usdPerCall }),
    });
  }

  async adminGetCatalog(): Promise<AdminCatalogRow[]> {
    return this.request<AdminCatalogRow[]>('/admin/billing/catalog');
  }

  /** Every Stripe price we are willing to sell. */
  async adminGetStripePrices(): Promise<StripePriceRow[]> {
    return this.request<StripePriceRow[]>('/admin/billing/stripe-prices');
  }

  /** Add or update one. The dollar amount is NOT sent — the server reads it
   *  back from Stripe, so what the billing page shows is what is charged. */
  async adminPutStripePrice(body: StripePriceInput): Promise<StripePriceRow> {
    return this.request<StripePriceRow>('/admin/billing/stripe-prices', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** Take a price off sale. It is kept, not deleted: subscriptions created
   *  against it keep invoicing and the webhook must still resolve the id. */
  async adminRetireStripePrice(id: number): Promise<void> {
    await this.request<void>(`/admin/billing/stripe-prices/${id}`, { method: 'DELETE' });
  }

  async adminPutCatalog(
    product: Product,
    body: { availability: ProductAvailability; sunset_at?: string | null; note?: string | null },
  ): Promise<AdminCatalogRow> {
    return this.request<AdminCatalogRow>(`/admin/billing/catalog/${product}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  }

  // --- admin: the house pipeline's versions ---------------------------------

  async listPipelineVersions(): Promise<PipelineVersionList> {
    return this.request<PipelineVersionList>('/admin/pipeline/versions');
  }

  async createPipelineDraft(body: {
    name?: string;
    from_version_id?: number | null;
  }): Promise<PipelineVersion & { skipped: string[] }> {
    return this.request<PipelineVersion & { skipped: string[] }>('/admin/pipeline/versions', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async updatePipelineVersion(id: number, body: { name?: string; notes?: string }): Promise<PipelineVersion> {
    return this.request<PipelineVersion>(`/admin/pipeline/versions/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  async testPipelineVersion(id: number): Promise<void> {
    await this.request<null>(`/admin/pipeline/versions/${id}/test`, { method: 'POST' });
  }

  async stopTestingPipelineVersion(): Promise<void> {
    await this.request<null>('/admin/pipeline/versions/test/stop', { method: 'POST' });
  }

  async promotePipelineVersion(id: number): Promise<PipelineVersion> {
    return this.request<PipelineVersion>(`/admin/pipeline/versions/${id}/promote`, { method: 'POST' });
  }

  async diffPipelineVersion(id: number): Promise<PipelineDiffRow[]> {
    return this.request<PipelineDiffRow[]>(`/admin/pipeline/versions/${id}/diff`);
  }

  async deletePipelineVersion(id: number): Promise<void> {
    await this.request<null>(`/admin/pipeline/versions/${id}`, { method: 'DELETE' });
  }

  // A house version's RULES: which model names work for each stage.
  async listPipelineRules(versionId: number): Promise<StageModelRule[]> {
    return this.request<StageModelRule[]>(`/admin/pipeline/versions/${versionId}/rules`);
  }

  async putPipelineRule(versionId: number, body: StageModelRuleIn): Promise<StageModelRule> {
    return this.request<StageModelRule>(`/admin/pipeline/versions/${versionId}/rules`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  }

  async deletePipelineRule(versionId: number, ruleId: number): Promise<void> {
    await this.request<null>(`/admin/pipeline/versions/${versionId}/rules/${ruleId}`, { method: 'DELETE' });
  }

  async pipelineCandidates(versionId: number, stage: string, archetype?: string | null): Promise<PoolCandidates> {
    const q = new URLSearchParams({ stage });
    if (archetype) q.set('archetype', archetype);
    return this.request<PoolCandidates>(`/admin/pipeline/versions/${versionId}/candidates?${q.toString()}`);
  }

  async pipelineAdvice(versionId: number, stage: string, archetype?: string | null): Promise<BenchAdvice> {
    const q = new URLSearchParams({ stage });
    if (archetype) q.set('archetype', archetype);
    return this.request<BenchAdvice>(`/admin/pipeline/versions/${versionId}/advice?${q.toString()}`);
  }

  async exportPipelineVersion(id: number): Promise<CopiedPolicy> {
    return this.request<CopiedPolicy>(`/admin/pipeline/versions/${id}/export`);
  }

  async previewPastedPolicy(policy: CopiedPolicy): Promise<PastePreview> {
    return this.request<PastePreview>('/admin/pipeline/policy/preview', {
      method: 'POST',
      body: JSON.stringify(policy),
    });
  }

  async importPastedPolicy(policy: CopiedPolicy, name?: string): Promise<PipelineVersion> {
    return this.request<PipelineVersion>('/admin/pipeline/policy/import', {
      method: 'POST',
      body: JSON.stringify({ policy, name }),
    });
  }

  async exportBenchResults(): Promise<BenchResultsFile> {
    return this.request<BenchResultsFile>('/admin/pipeline/bench-results/export');
  }

  async previewBenchResults(file: BenchResultsFile): Promise<BenchPreview> {
    return this.request<BenchPreview>('/admin/pipeline/bench-results/preview', {
      method: 'POST',
      body: JSON.stringify(file),
    });
  }

  async importBenchResults(file: BenchResultsFile): Promise<{ counts: Partial<Record<BenchEntryStatus, number>> }> {
    return this.request<{ counts: Partial<Record<BenchEntryStatus, number>> }>('/admin/pipeline/bench-results/import', {
      method: 'POST',
      body: JSON.stringify(file),
    });
  }

  async pipelineModelNames(): Promise<HouseModelName[]> {
    return this.request<HouseModelName[]>('/admin/pipeline/model-names');
  }

  async pipelineResults(stage: string, archetype?: string | null): Promise<StageModelResult[]> {
    const q = new URLSearchParams({ stage });
    if (archetype) q.set('archetype', archetype);
    return this.request<StageModelResult[]>(`/admin/pipeline/results?${q.toString()}`);
  }

  async addPipelineResult(body: StageModelResultIn): Promise<StageModelResult> {
    return this.request<StageModelResult>('/admin/pipeline/results', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async deletePipelineResult(id: number): Promise<void> {
    await this.request<null>(`/admin/pipeline/results/${id}`, { method: 'DELETE' });
  }


  async changePassword(currentPassword: string, newPassword: string): Promise<{ message: string }> {
    const data = await this.request<{ message: string } & Partial<LoginResponse>>(
      '/auth/me/password',
      {
        method: 'PUT',
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
        }),
      },
    );
    // Changing the password ends every session, this one included; the
    // response starts a fresh one (the cookie arrives with it). Keep the header
    // copy in step, or the very next request would send the revoked token,
    // the header would win, and the person who just changed their password
    // would be signed out for it.
    if (data.access_token) this.setToken(data.access_token);
    return data;
  }

  async register(data: RegisterData): Promise<User> {
    const response = await fetch(`${API_BASE_URL}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      // Same-session as `request()` — see the note on login.
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Registration failed' }));
      throw new Error(error.detail || 'Registration failed');
    }

    return response.json();
  }

  async updateProfile(data: ProfileUpdate): Promise<User> {
    return this.request<User>('/auth/me/profile', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  // Admin: signup approvals + existing account management
  async listUsers(status: AdminUserStatusFilter = 'all'): Promise<AdminUser[]> {
    return this.request<AdminUser[]>(`/admin/users?status_filter=${status}`);
  }

  async getPendingUserCount(): Promise<number> {
    const res = await this.request<{ pending_count: number }>('/admin/users/pending-count');
    return res.pending_count;
  }

  async approveUser(userId: number): Promise<AdminUser> {
    return this.request<AdminUser>(`/admin/users/${userId}/approve`, { method: 'POST' });
  }

  async rejectUser(userId: number): Promise<AdminUser> {
    return this.request<AdminUser>(`/admin/users/${userId}/reject`, { method: 'POST' });
  }

  // Revoke / restore access for an already-approved account.
  async disableUser(userId: number): Promise<AdminUser> {
    return this.request<AdminUser>(`/admin/users/${userId}/disable`, { method: 'POST' });
  }

  async enableUser(userId: number): Promise<AdminUser> {
    return this.request<AdminUser>(`/admin/users/${userId}/enable`, { method: 'POST' });
  }

  // What deleting this account would destroy, and what would stop it. Read
  // before showing the confirm dialog — deleting is the one irreversible action
  // on that screen.
  async previewUserDeletion(userId: number): Promise<AdminUserDeletionPreview> {
    return this.request<AdminUserDeletionPreview>(`/admin/users/${userId}/deletion-preview`);
  }

  // `confirmEmail` must be the account's own email, typed back by the admin —
  // the server rejects a mismatch, so a mistyped id can't delete the wrong row.
  async deleteUser(userId: number, confirmEmail: string): Promise<AdminUserDeletionResult> {
    const q = encodeURIComponent(confirmEmail);
    return this.request<AdminUserDeletionResult>(`/admin/users/${userId}?confirm_email=${q}`, {
      method: 'DELETE',
    });
  }

  // Page-style specs (per-user content spec overrides)
  async getPageStyleSpecs(): Promise<PageStyleSpecRow[]> {
    return this.request<PageStyleSpecRow[]>('/page-style-specs');
  }

  async updatePageStyleSpec(
    pageStyle: string,
    payload: PageStyleSpecOverridePayload
  ): Promise<PageStyleSpecRow> {
    return this.request<PageStyleSpecRow>(`/page-style-specs/${pageStyle}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }

  async resetPageStyleSpec(pageStyle: string): Promise<PageStyleSpecRow> {
    return this.request<PageStyleSpecRow>(`/page-style-specs/${pageStyle}`, {
      method: 'DELETE',
    });
  }

  // Page-builder research settings (per-user knobs for the agent)
  async getKeywordScoringSettings(): Promise<KeywordScoringResponse> {
    return this.request<KeywordScoringResponse>('/keyword-scoring-settings');
  }

  async updateKeywordScoringSettings(
    override: Record<string, KeywordScoringValue | null>,
  ): Promise<KeywordScoringResponse> {
    return this.request<KeywordScoringResponse>('/keyword-scoring-settings', {
      method: 'PUT',
      body: JSON.stringify(override),
    });
  }

  async resetKeywordScoringSettings(): Promise<KeywordScoringResponse> {
    return this.request<KeywordScoringResponse>('/keyword-scoring-settings', {
      method: 'DELETE',
    });
  }

  async getResearchSettings(): Promise<ResearchSettingsResponse> {
    return this.request<ResearchSettingsResponse>('/page-builder-research-settings');
  }

  async updateResearchSettings(
    payload: ResearchSettingsOverridePayload,
  ): Promise<ResearchSettingsResponse> {
    return this.request<ResearchSettingsResponse>('/page-builder-research-settings', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }

  async resetResearchSettings(): Promise<ResearchSettingsResponse> {
    return this.request<ResearchSettingsResponse>('/page-builder-research-settings', {
      method: 'DELETE',
    });
  }

  // Projects
  async getProjects(skip = 0, limit = 100): Promise<Project[]> {
    return this.request<Project[]>(`/projects?skip=${skip}&limit=${limit}`);
  }

  async getProject(id: number): Promise<Project> {
    return this.request<Project>(`/projects/${id}`);
  }

  async createProject(data: Partial<Project>): Promise<Project> {
    return this.request<Project>('/projects', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateProject(id: number, data: Partial<Project>): Promise<Project> {
    return this.request<Project>(`/projects/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteProject(id: number): Promise<void> {
    return this.request(`/projects/${id}`, { method: 'DELETE' });
  }

  // Categories
  async getCategories(projectId: number | null = null, skip = 0, limit = 100): Promise<Category[]> {
    let url = `/categories?skip=${skip}&limit=${limit}`;
    if (projectId) url += `&project_id=${projectId}`;
    return this.request<Category[]>(url);
  }

  async getCategory(id: number): Promise<Category> {
    return this.request<Category>(`/categories/${id}`);
  }

  async createCategory(data: Partial<Category>): Promise<Category> {
    return this.request<Category>('/categories', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateCategory(id: number, data: Partial<Category>): Promise<Category> {
    return this.request<Category>(`/categories/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteCategory(id: number): Promise<void> {
    return this.request(`/categories/${id}`, { method: 'DELETE' });
  }

  // Topics
  async getTopics(
    categoryId: number | null = null,
    projectId: number | null = null,
    skip = 0,
    limit = 100,
    onlyActive: boolean = false
  ): Promise<Topic[]> {
    let url = `/topics?skip=${skip}&limit=${limit}&only_active=${onlyActive}`;
    if (categoryId) url += `&category_id=${categoryId}`;
    else if (projectId) url += `&project_id=${projectId}`;
    return this.request<Topic[]>(url);
  }

  async getTopic(id: number): Promise<Topic> {
    return this.request<Topic>(`/topics/${id}`);
  }

  async createTopic(data: Partial<Topic>): Promise<Topic> {
    return this.request<Topic>('/topics', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateTopic(id: number, data: Partial<Topic>): Promise<Topic> {
    return this.request<Topic>(`/topics/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteTopic(id: number): Promise<void> {
    return this.request(`/topics/${id}`, { method: 'DELETE' });
  }

  async clearTopicKeywordMetricRuns(
    topicId: number
  ): Promise<{ deleted_count: number; keyword_count: number }> {
    return this.request(`/topics/${topicId}/clear-keyword-metric-runs`, {
      method: 'POST',
    });
  }

  // TopicKeywords
  async getTopicKeywords(
    topicId: number | null = null,
    keywordId: number | null = null,
    page = 1,
    size = 50,
    sortBy = 'keyword',
    sortOrder = 'asc',
    hasRelevance = false,
    onlyActiveTopics: boolean = false,
    keywordSearch: string | null = null,
    semanticSearch: string | null = null,
    projectId: number | null = null,
    minSemanticSimilarity: number | null = null,
    includeMonthly = true,
    winnableOnly = false,
    gapFilter: SerpGapFilter | null = null,
  ): Promise<TopicKeywordPaginatedResponse> {
    let url = `/topic-keywords?page=${page}&size=${size}`;
    if (sortBy) url += `&sort_by=${sortBy}`;
    if (sortOrder) url += `&sort_order=${sortOrder}`;
    if (hasRelevance) url += `&has_relevance=${hasRelevance}`;
    if (onlyActiveTopics) url += `&only_active_topics=${onlyActiveTopics}`;
    if (topicId) url += `&topic_id=${topicId}`;
    if (keywordId) url += `&keyword_id=${keywordId}`;
    if (keywordSearch) url += `&keyword_search=${encodeURIComponent(keywordSearch)}`;
    if (semanticSearch) url += `&semantic_search=${encodeURIComponent(semanticSearch)}`;
    if (minSemanticSimilarity !== null) url += `&min_sem_similarity=${minSemanticSimilarity}`;
    if (projectId) url += `&project_id=${projectId}`;
    if (!includeMonthly) url += `&include_monthly=false`;
    if (winnableOnly) url += `&winnable_only=true`;
    url += serpGapQuery(gapFilter);
    return this.request<TopicKeywordPaginatedResponse>(url);
  }

  async getTopicKeywordsMonthlyData(keywordIds: number[]): Promise<{ keyword_id: number; monthly_data: MonthlyDataPoint[] }[]> {
    if (keywordIds.length === 0) return [];
    const params = keywordIds.map(id => `keyword_ids=${id}`).join('&');
    return this.request(`/topic-keywords/monthly-data?${params}`);
  }

  async getTopicKeywordAliasClusters(
    topicId: number,
    page = 1,
    size = 100,
  ): Promise<TopicKeywordPaginatedResponse> {
    let url = `/topic-keywords?topic_id=${topicId}&page=${page}&size=${size}&has_aliased_children=true&include_monthly=false`;
    return this.request<TopicKeywordPaginatedResponse>(url);
  }

  async getTopLevelTopicKeywords(
    topicId: number,
    page = 1,
    size = 100,
  ): Promise<TopicKeywordPaginatedResponse> {
    let url = `/topic-keywords?topic_id=${topicId}&page=${page}&size=${size}&is_aliased_child=false&include_monthly=false`;
    return this.request<TopicKeywordPaginatedResponse>(url);
  }

  async deleteTopicKeywordsBulk(ids: number[]): Promise<{ deleted_count: number }> {
    return this.request('/topic-keywords/bulk-delete', {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
  }

  async deleteTopicKeywordsBulkByFilter(params: {
    topic_id?: number | null;
    keyword_search?: string | null;
    semantic_search?: string | null;
    min_sem_similarity?: number | null;
    has_relevance?: boolean;
    only_active_topics?: boolean;
    winnable_only?: boolean;
    gap_filter?: SerpGapFilter | null;
  }): Promise<{ deleted_count: number }> {
    return this.request('/topic-keywords/bulk-delete', {
      method: 'POST',
      body: JSON.stringify({
        delete_all_matching: true,
        topic_id: params.topic_id || undefined,
        keyword_search: params.keyword_search || undefined,
        semantic_search: params.semantic_search || undefined,
        min_sem_similarity: params.min_sem_similarity || undefined,
        winnable_only: params.winnable_only || undefined,
        ...serpGapBody(params.gap_filter),
        // has_relevance: params.has_relevance || false,
        // only_active_topics: params.only_active_topics || false,
      }),
    });
  }

  async createTopicKeyword(data: { topic_id: number; keyword_id: number }): Promise<TopicKeyword> {
    return this.request<TopicKeyword>('/topic-keywords', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async deleteTopicKeyword(id: number): Promise<void> {
    return this.request(`/topic-keywords/${id}`, { method: 'DELETE' });
  }

  // Keywords
  async getKeywords(
    search: string | null = null,
    topicId: number | null = null,
    skip = 0,
    limit = 100
  ): Promise<Keyword[]> {
    let url = `/keywords?skip=${skip}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (topicId) url += `&topic_id=${topicId}`;
    return this.request<Keyword[]>(url);
  }

  async createKeyword(data: { value: string; topic_id: number }): Promise<KeywordCreateResponse> {
    return this.request<KeywordCreateResponse>('/keywords', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // ============= Topic Workspace Endpoints =============

  async getTopicCoverageScore(
    topicId: number,
    relevanceThreshold = 0.8
  ): Promise<CoverageScore> {
    return this.request<CoverageScore>(
      `/topic-keywords/topics/${topicId}/coverage-score?relevance_threshold=${relevanceThreshold}`
    );
  }

  async matchKeywordsAgainstStore(
    topicId: number,
    keywords: string[],
    minSemanticSimilarity = 0.85
  ): Promise<KeywordMatchResponse> {
    return this.request<KeywordMatchResponse>(
      `/topic-keywords/topics/${topicId}/match-keywords`,
      {
        method: 'POST',
        body: JSON.stringify({
          keywords,
          min_sem_similarity: minSemanticSimilarity,
        }),
      }
    );
  }

  // Preview the keywords that could seed a Google ideas run, grouped +
  // pre-selected per the endorsement gate. Read-only; drives the popover.
  // When `selectedKeywordIds` is given (rows checkbox-selected in the list),
  // the preview is limited to those and they're all pre-selected.
  async previewGoogleIdeasSeeds(
    topicId: number,
    selectedKeywordIds?: number[],
  ): Promise<{ candidates: import('../types').GoogleSeedCandidate[] }> {
    const qs =
      selectedKeywordIds && selectedKeywordIds.length
        ? '?' +
          selectedKeywordIds
            .map((id) => `selected_keyword_ids=${id}`)
            .join('&')
        : '';
    return this.request(
      `/topic-keywords/topics/${topicId}/google-ideas/preview${qs}`,
    );
  }

  // Send the explicitly-chosen seed keywords to Google. Selecting a keyword
  // means "(re)send it", so already-sent ones go out fresh.
  async sendGoogleIdeasSeeds(
    topicId: number,
    keywordIds: number[],
  ): Promise<{
    status: string;
    recommendation_id?: number;
    keywords_sent?: number;
    keywords_linked?: number;
    keywords_pending?: number;
    keywords_skipped?: number;
    message?: string;
  }> {
    return this.request(
      `/topic-keywords/topics/${topicId}/fetch-google-ideas`,
      {
        method: 'POST',
        body: JSON.stringify({ keyword_ids: keywordIds }),
      },
    );
  }



  // ============= Topic Labels Endpoints =============

  async getTopicLabels(topicId: number): Promise<TopicLabelsResponse> {
    return this.request<TopicLabelsResponse>(`/topics/${topicId}/labels`);
  }

  async updateTopicLabels(
    topicId: number,
    labels: string[]
  ): Promise<TopicLabelsResponse> {
    return this.request<TopicLabelsResponse>(`/topics/${topicId}/labels`, {
      method: 'PUT',
      body: JSON.stringify({ labels }),
    });
  }

  // ============= SERP Endpoints =============

  async getSerpsByKeyword(keywordId: number): Promise<SERP[]> {
    return this.request<SERP[]>(`/serps/by-keyword/${keywordId}`);
  }

  async getSerpPending(keywordId: number): Promise<{ pending: boolean }> {
    return this.request<{ pending: boolean }>(
      `/serps/by-keyword/${keywordId}/pending`,
    );
  }

  async createSerpRequest(
    keywordId: number,
    force = false,
  ): Promise<SERPRequestResponse> {
    return this.request<SERPRequestResponse>(`/serps/requests`, {
      method: 'POST',
      body: JSON.stringify({ keyword_id: keywordId, force }),
    });
  }

  // One "Fetch SERPs" press over a selection; see POST /serps/requests/bulk.
  async createSerpRequestsBulk(keywordIds: number[]): Promise<SERPBulkRequestResponse> {
    return this.request<SERPBulkRequestResponse>(`/serps/requests/bulk`, {
      method: 'POST',
      body: JSON.stringify({ keyword_ids: keywordIds }),
    });
  }

  // Cancel an in-flight SERP crawl: releases the pending lock so the UI
  // stops spinning immediately (also broadcasts serp_completion to other
  // clients). Returns the now-cleared pending state.
  async cancelSerpRequest(keywordId: number): Promise<{ pending: boolean }> {
    return this.request<{ pending: boolean }>(
      `/serps/by-keyword/${keywordId}/cancel`,
      { method: 'POST' },
    );
  }

  // Sweeps every ranking page for the keyword that still has no facts,
  // whatever state it's in. Returns the pages it will work on.
  async ensureKeywordExtracted(keywordId: number): Promise<EnsureExtractedResponse> {
    return this.request<EnsureExtractedResponse>(
      `/serps/by-keyword/${keywordId}/ensure-extracted`,
      { method: 'POST' },
    );
  }

  // ============= Pages Endpoints =============

  async getSerpWithPages(serpId: number): Promise<SERPDetailWithPages> {
    return this.request<SERPDetailWithPages>(`/pages/serp/${serpId}/with-pages`);
  }

  async getPage(pageId: number): Promise<PageDetail> {
    return this.request<PageDetail>(`/pages/${pageId}`);
  }

  async getManagedSiteComparison(serpId: number): Promise<SERPCompetitionResponse> {
    return this.request<SERPCompetitionResponse>(`/pages/serp/${serpId}/managed-site-comparison`);
  }

  async getPageKeywords(pageId: number): Promise<PageKeywordSerpInfo[]> {
    return this.request<PageKeywordSerpInfo[]>(`/pages/${pageId}/keywords`);
  }

  // Queues a re-extraction; facts arrive over the page_facts_extracted
  // websocket stream, terminated by an event with done=true.
  async extractPageFacts(pageId: number): Promise<PageExtractFactsResponse> {
    return this.request<PageExtractFactsResponse>(`/pages/${pageId}/extract-facts`, {
      method: 'POST',
    });
  }

  async getDomainPages(domainId: number, size = 50): Promise<PagePaginatedResponse> {
    return this.request<PagePaginatedResponse>(`/pages?domain_id=${domainId}&size=${size}`);
  }

  // ============= Managed Sites / Deployment Targets Endpoints =============

  async getManagedSites(skip = 0, limit = 100): Promise<ManagedSite[]> {
    const url = `/managed-sites?skip=${skip}&limit=${limit}`;
    return this.request<ManagedSite[]>(url);
  }

  async createManagedSite(data: ManagedSiteCreate): Promise<ManagedSite> {
    return this.request<ManagedSite>('/managed-sites', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateManagedSite(siteId: number, data: ManagedSiteUpdate): Promise<ManagedSite> {
    return this.request<ManagedSite>(`/managed-sites/${siteId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteManagedSite(siteId: number): Promise<void> {
    return this.request(`/managed-sites/${siteId}`, { method: 'DELETE' });
  }

  async regenerateManagedSiteKey(siteId: number): Promise<ManagedSite> {
    return this.request<ManagedSite>(`/managed-sites/${siteId}/regenerate-key`, {
      method: 'POST',
    });
  }

  // ============= Releases =============

  /** A site's deploy history, newest first. Read-only: a receipt you can revise
   *  is not a receipt, so there is no create/update/delete here. */
  async getReleases(siteId: number, limit = 25): Promise<ReleaseSummary[]> {
    return this.request<ReleaseSummary[]>(`/releases?site_id=${siteId}&limit=${limit}`);
  }

  // ── Search Console (api/search_console.py) ────────────────────────────────

  async getSearchConsoleAuthUrl(siteId: number): Promise<{ url: string }> {
    return this.request(`/search-console/sites/${siteId}/auth-url`);
  }

  async getSearchConsoleProperties(
    siteId: number,
  ): Promise<{ properties: SearchConsoleProperty[]; suggested: string | null }> {
    return this.request(`/search-console/sites/${siteId}/properties`);
  }

  async setSearchConsoleProperty(siteId: number, propertyUrl: string): Promise<SearchConsoleStatus> {
    return this.request(`/search-console/sites/${siteId}/property`, {
      method: 'PUT',
      body: JSON.stringify({ property_url: propertyUrl }),
    });
  }

  async disconnectSearchConsole(siteId: number): Promise<void> {
    await this.request<void>(`/search-console/sites/${siteId}`, { method: 'DELETE' });
  }

  async syncSearchConsole(siteId: number): Promise<{ job_id: string }> {
    return this.request(`/search-console/sites/${siteId}/sync`, { method: 'POST' });
  }

  async getSearchReport(siteId: number): Promise<SearchReport> {
    return this.request(`/search-console/sites/${siteId}/report`);
  }

  async retargetPage(siteId: number, pageId: number, topicKeywordId: number): Promise<{ job_id: string }> {
    return this.request(`/search-console/sites/${siteId}/retarget`, {
      method: 'POST',
      body: JSON.stringify({ page_id: pageId, topic_keyword_id: topicKeywordId }),
    });
  }

  async keepPages(siteId: number, pageIds: number[]): Promise<{ kept: number }> {
    return this.request(`/search-console/sites/${siteId}/keep`, {
      method: 'POST',
      body: JSON.stringify({ page_ids: pageIds }),
    });
  }

  async retirePages(siteId: number, pageIds: number[]): Promise<RetireResult> {
    return this.request(`/search-console/sites/${siteId}/retire`, {
      method: 'POST',
      body: JSON.stringify({ page_ids: pageIds }),
    });
  }

  /** One deploy, page by page. */
  async getRelease(releaseId: number): Promise<ReleaseDetail> {
    return this.request<ReleaseDetail>(`/releases/${releaseId}`);
  }

  // ============= Review Queue =============

  /** Pages that are ready to publish and have not been read yet. */
  async getReviewQueue(siteId?: number): Promise<ReviewQueueResponse> {
    const query = siteId ? `?site_id=${siteId}` : '';
    return this.request<ReviewQueueResponse>(`/review/queue${query}`);
  }

  /**
   * Sign off on a page.
   *
   * `versionId` is the version the reviewer was actually shown. The server
   * refuses with a 409 if the page was rebuilt in the meantime, rather than
   * approving whatever is current — which would sign off on text nobody read.
   */
  async approvePage(pageId: number, versionId: number | null): Promise<ReviewActionResponse> {
    return this.request<ReviewActionResponse>(`/review/pages/${pageId}/approve`, {
      method: 'POST',
      body: JSON.stringify({ version_id: versionId }),
    });
  }

  /** Send a page back to draft with a reason. */
  async rejectPage(pageId: number, note: string): Promise<ReviewActionResponse> {
    return this.request<ReviewActionResponse>(`/review/pages/${pageId}/reject`, {
      method: 'POST',
      body: JSON.stringify({ note }),
    });
  }

  // ============= Deployment Plans Endpoints =============

  async getDeploymentPlans(params: {
    managedSiteId?: number;
    search?: string;
    page?: number;
    size?: number;
  } = {}): Promise<DeploymentPlanPaginatedResponse> {
    const { managedSiteId, search, page = 1, size = 25 } = params;
    let url = `/deployment-plans?page=${page}&size=${size}`;
    if (managedSiteId) url += `&managed_site_id=${managedSiteId}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return this.request<DeploymentPlanPaginatedResponse>(url);
  }

  async getDeploymentPlan(planId: number): Promise<DeploymentPlan> {
    return this.request<DeploymentPlan>(`/deployment-plans/${planId}`);
  }

  async createDeploymentPlan(data: DeploymentPlanCreate): Promise<DeploymentPlan> {
    return this.request<DeploymentPlan>('/deployment-plans', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateDeploymentPlan(planId: number, data: DeploymentPlanUpdate): Promise<DeploymentPlan> {
    return this.request<DeploymentPlan>(`/deployment-plans/${planId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteDeploymentPlan(planId: number): Promise<void> {
    return this.request(`/deployment-plans/${planId}`, { method: 'DELETE' });
  }

  async getDeployValidation(planId: number): Promise<DeploymentValidationResponse> {
    return this.request<DeploymentValidationResponse>(`/deployment-plans/${planId}/deploy-validation`);
  }

  async deployPlan(planId: number): Promise<DeploymentStartResponse> {
    return this.request<DeploymentStartResponse>(`/deployment-plans/${planId}/deploy`, { method: 'POST' });
  }

  // ============= Managed Pages Endpoints =============

  async getManagedPages(params: {
    projectId?: number;
    categoryId?: number;
    topicId?: number;
    managedSiteId?: number;
    deploymentPlanId?: number;
    status?: PageBuildStatus;
    pageStyle?: PageStyle;
    search?: string;
    /** Publish-path prefix, e.g. `bikes/trails`. `''` = filed at the site root. */
    path?: string;
    sortBy?: 'keyword' | 'title' | 'topic' | 'page_style' | 'status' | 'site' | 'plan' | 'created_at';
    sortOrder?: 'asc' | 'desc';
    page?: number;
    size?: number;
  } = {}): Promise<ManagedPagePaginatedResponse> {
    const { projectId, categoryId, topicId, managedSiteId, deploymentPlanId, status, pageStyle, search, path, sortBy, sortOrder, page = 1, size = 25 } = params;
    let url = `/managed-pages?page=${page}&size=${size}`;
    if (projectId) url += `&project_id=${projectId}`;
    if (categoryId) url += `&category_id=${categoryId}`;
    if (topicId) url += `&topic_id=${topicId}`;
    if (managedSiteId) url += `&managed_site_id=${managedSiteId}`;
    if (deploymentPlanId) url += `&deployment_plan_id=${deploymentPlanId}`;
    if (status) url += `&status=${status}`;
    if (pageStyle) url += `&page_style=${pageStyle}`;
    // `!= null`, not truthiness: `''` is the site-root selection.
    if (path != null) url += `&path=${encodeURIComponent(path)}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (sortBy) url += `&sort_by=${sortBy}`;
    if (sortOrder) url += `&sort_order=${sortOrder}`;
    return this.request<ManagedPagePaginatedResponse>(url);
  }

  async getManagedPage(pageId: number): Promise<ManagedPage> {
    return this.request<ManagedPage>(`/managed-pages/${pageId}`);
  }

  async createManagedPage(data: ManagedPageCreate): Promise<ManagedPage> {
    return this.request<ManagedPage>('/managed-pages', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async bulkCreateManagedPages(data: ManagedPageBulkCreate): Promise<ManagedPageBulkCreateResponse> {
    return this.request<ManagedPageBulkCreateResponse>('/managed-pages/bulk', {
      method: 'POST',
      body: JSON.stringify({
        topic_keyword_ids: data.topic_keyword_ids,
        page_style: data.page_style,
        deployment_plan_id: data.deployment_plan_id,
        path_segments: data.path_segments,
      }),
    });
  }

  async bulkCreateManagedPagesByFilter(data: ManagedPageBulkCreateByFilter): Promise<ManagedPageBulkCreateResponse> {
    return this.request<ManagedPageBulkCreateResponse>('/managed-pages/bulk-by-filter', {
      method: 'POST',
      body: JSON.stringify({
        topic_id: data.topic_id,
        page_style: data.page_style,
        deployment_plan_id: data.deployment_plan_id,
        path_segments: data.path_segments,
        keyword_search: data.keyword_search,
        semantic_search: data.semantic_search,
        min_sem_similarity: data.min_sem_similarity,
      }),
    });
  }

  /**
   * Every page on a site with the path it publishes at.
   *
   * The tree is assembled from this client-side — it is a grouping over what
   * the pages say, so it cannot disagree with them.
   */
  async getSiteStructure(siteId: number): Promise<SiteStructure> {
    return this.request<SiteStructure>(`/managed-sites/${siteId}/structure`);
  }

  /**
   * Create the page that IS a section.
   *
   * Opt-in and one at a time. Creating these automatically would mean a
   * near-empty page per section going live, which is a doorway-page factory —
   * and on WordPress an unpublished section makes everything under it 404.
   */
  async createSectionIndex(
    siteId: number,
    pathSegments: string[],
    deploymentPlanId?: number,
  ): Promise<SiteStructurePageOut> {
    return this.request<SiteStructurePageOut>(
      `/managed-sites/${siteId}/structure/index`,
      {
        method: 'POST',
        body: JSON.stringify({
          path_segments: pathSegments,
          deployment_plan_id: deploymentPlanId,
        }),
      },
    );
  }

  /**
   * Re-file part of a site under a different path.
   *
   * Omit `pageIds` to move the whole branch at `fromPath` — the case this
   * exists for. The prefix is rewritten, so the subtree keeps its shape.
   */
  async moveSiteStructure(
    siteId: number,
    fromPath: string[],
    toPath: string[],
    pageIds?: number[],
  ): Promise<SiteStructureMoveResult> {
    return this.request<SiteStructureMoveResult>(
      `/managed-sites/${siteId}/structure/move`,
      {
        method: 'POST',
        body: JSON.stringify({
          from_path: fromPath,
          to_path: toPath,
          page_ids: pageIds,
        }),
      },
    );
  }

  /**
   * Where a page made from this node would publish, before anyone edits it.
   *
   * Served rather than rebuilt here: the create endpoints seed from the same
   * function, so what the dialog shows is what gets stored. Reconstructing the
   * slug rules client-side would be a second implementation to keep in step.
   */
  async getTopicPagePath(topicId: number): Promise<TopicPagePath> {
    return this.request<TopicPagePath>(`/topics/${topicId}/page-path`);
  }

  /**
   * What already exists one level below `prefix` on this site.
   *
   * Scoped to the SITE rather than the subject: two subjects publishing to one
   * site share its structure, and that shared structure is what is being kept
   * consistent.
   */
  async getPathSegments(
    managedSiteId: number,
    prefix: string[] = [],
  ): Promise<PathSegmentSuggestions> {
    const params = new URLSearchParams({ managed_site_id: String(managedSiteId) });
    if (prefix.length) params.set('prefix', prefix.join('/'));
    return this.request<PathSegmentSuggestions>(`/managed-pages/path-segments?${params}`);
  }

  async updateManagedPage(pageId: number, data: ManagedPageUpdate): Promise<ManagedPage> {
    console.log("updateManagedPage, pageId=", pageId, "data=", data)
    return this.request<ManagedPage>(`/managed-pages/${pageId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteManagedPage(pageId: number): Promise<void> {
    return this.request(`/managed-pages/${pageId}`, { method: 'DELETE' });
  }

  async buildManagedPage(pageId: number): Promise<{ job_id?: string; status?: string; message?: string }> {
    return this.request<{ job_id?: string; status?: string; message?: string }>(`/managed-pages/${pageId}/build`, {
      method: 'POST',
    });
  }

  // Request cooperative cancel of an in-flight page build. Returns
  // immediately after stamping ManagedPage.cancel_requested_at; the
  // worker exits at the next iteration / phase boundary and emits a
  // `cancelled` event over the websocket.
  async cancelManagedPageBuild(
    pageId: number,
  ): Promise<{ status?: string; cancel_requested_at?: string; message?: string }> {
    return this.request<{ status?: string; cancel_requested_at?: string; message?: string }>(
      `/managed-pages/${pageId}/cancel`,
      { method: 'POST' },
    );
  }

  // Wipe one page-builder phase's accumulated state so the next Re-run
  // starts fresh instead of appending. For `research` specifically, the
  // default Re-run behavior is to APPEND more turns + facts; click Reset
  // first when you want a clean slate. Per-phase semantics live in the
  // backend's _PHASE_RESET_CONFIG.
  async resetManagedPagePhase(
    pageId: number,
    phase: 'research' | 'angle' | 'outline' | 'write' | 'ground' | 'seo',
  ): Promise<{
    status?: string;
    phase?: string;
    deleted_conversation_messages?: number;
    cleared_cv_fields?: string[];
    cleared_page_fields?: string[];
    message?: string;
  }> {
    return this.request(`/managed-pages/${pageId}/reset-phase`, {
      method: 'POST',
      body: JSON.stringify({ phase }),
    });
  }

  async getBuildState(pageId: number): Promise<BuildStateResponse> {
    return this.request<BuildStateResponse>(`/managed-pages/${pageId}/build-state`);
  }

  // Direct edit of the page-level framing artifact. Pass only the fields
  // you want to change; others are left as-is.
  async updateFraming(
    pageId: number,
    payload: {
      keyword_shape?: string | null;
      subject?: string | null;
      entity?: string | null;
      audience?: string | null;
      intent?: string | null;
      north_star?: string | null;
    },
  ): Promise<{
    keyword_shape?: string | null;
    subject?: string | null;
    entity?: string | null;
    audience?: string | null;
    intent?: string | null;
    north_star?: string | null;
  }> {
    return this.request(`/managed-pages/${pageId}/framing`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }

  // Queue a single-phase re-run. Optional `feedback` is injected into
  // that phase's user prompt for iterative refinement (per-phase chat).
  // Lifecycle events arrive on the websocket channel
  // ("<phase>_started", "<phase>_completed", "failed").
  // Derived from BuildPhase rather than re-listed: 'final' is the one phase
  // with no agent run behind it, and a hand-copied list is a third place to
  // forget when a phase is added.
  async runPhase(
    pageId: number,
    phase: Exclude<BuildPhase, 'final'>,
    feedback?: string,
  ): Promise<{
    job_id?: string;
    status?: string;
    phase?: string;
    with_feedback?: boolean;
    message?: string;
  }> {
    return this.request(`/managed-pages/${pageId}/run-phase`, {
      method: 'POST',
      body: JSON.stringify({ phase, feedback: feedback || null }),
    });
  }

  // Ask the LLM to rewrite the current draft so it satisfies the style
  // spec, clearing the violations shown in the Ground panel. Reuses the
  // ground-phase lifecycle events (ground_started / ground_completed).
  async fixCompliance(pageId: number): Promise<{
    job_id?: string;
    status?: string;
    phase?: string;
    message?: string;
  }> {
    return this.request(`/managed-pages/${pageId}/fix-compliance`, {
      method: 'POST',
    });
  }

  // ============= Research points (Synthesize phase) =============

  async listResearchPoints(
    pageId: number,
    includeDeleted = false,
  ): Promise<ResearchPointListResponse> {
    const qs = includeDeleted ? '?include_deleted=true' : '';
    return this.request<ResearchPointListResponse>(
      `/managed-pages/${pageId}/research-points${qs}`,
    );
  }

  async addResearchPoint(
    pageId: number,
    keyPoint: string,
    sourceUrl?: string,
    sourceTitle?: string,
  ): Promise<ResearchPoint> {
    return this.request<ResearchPoint>(
      `/managed-pages/${pageId}/research-points`,
      {
        method: 'POST',
        body: JSON.stringify({
          key_point: keyPoint,
          source_url: sourceUrl ?? '',
          source_title: sourceTitle ?? null,
        }),
      },
    );
  }

  async updateResearchPoint(
    pageId: number,
    pointId: number,
    payload: { key_point?: string; is_pinned?: boolean },
  ): Promise<ResearchPoint> {
    return this.request<ResearchPoint>(
      `/managed-pages/${pageId}/research-points/${pointId}`,
      { method: 'PATCH', body: JSON.stringify(payload) },
    );
  }

  async deleteResearchPoint(
    pageId: number,
    pointId: number,
  ): Promise<ResearchPoint> {
    return this.request<ResearchPoint>(
      `/managed-pages/${pageId}/research-points/${pointId}`,
      { method: 'DELETE' },
    );
  }

  async bulkDeleteResearchPoints(
    pageId: number,
    pointIds: number[],
  ): Promise<{ deleted: number }> {
    return this.request<{ deleted: number }>(
      `/managed-pages/${pageId}/research-points/bulk-delete`,
      { method: 'POST', body: JSON.stringify({ point_ids: pointIds }) },
    );
  }

  // ============= Angle (Stage 2) =============

  async updatePageAngle(
    pageId: number,
    angle: Angle,
  ): Promise<{ angle: Angle | null }> {
    return this.request<{ angle: Angle | null }>(
      `/managed-pages/${pageId}/angle`,
      { method: 'PUT', body: JSON.stringify({ angle }) },
    );
  }

  // List all stored angle options for the page (the picker reads these).
  async listAngleOptions(pageId: number): Promise<AngleOption[]> {
    return this.request<AngleOption[]>(
      `/managed-pages/${pageId}/angle-options`,
    );
  }

  // Select a different angle option as the one downstream phases use.
  async selectAngleOption(
    pageId: number,
    angleId: number,
  ): Promise<{ angle: Angle | null }> {
    return this.request<{ angle: Angle | null }>(
      `/managed-pages/${pageId}/angle-options/${angleId}/select`,
      { method: 'POST' },
    );
  }

  // ── Header image, resolved from the selected angle's brief ──
  async getHeroImage(pageId: number): Promise<HeroImageState> {
    return this.request<HeroImageState>(`/managed-pages/${pageId}/hero-image`);
  }

  // NB no resolveHeroImage — running the image phase goes through runPhase
  // like every other phase, so there's one route to stamping it running.

  // "I want that other one": generate a specific candidate prompt rather than
  // the selected angle's. Marks the result `user`, so a later phase run won't
  // replace a picture that was chosen deliberately.
  async generateHeroCandidate(pageId: number, prompt: string): Promise<HeroImageState> {
    return this.request<HeroImageState>(`/managed-pages/${pageId}/hero-image/generate`, {
      method: 'POST',
      body: JSON.stringify({ prompt }),
    });
  }

  // Pin a hero by hand (marks it `user`, which resolve won't overwrite), or
  // pass null to clear it and hand the slot back to the angle.
  async setHeroImage(pageId: number, imageId: number | null): Promise<HeroImageState> {
    return this.request<HeroImageState>(`/managed-pages/${pageId}/hero-image`, {
      method: 'PUT',
      body: JSON.stringify({ image_id: imageId }),
    });
  }

  // Force a re-crawl + re-extract of the page's keyword SERP, then re-synthesize.
  async recrawlResearch(
    pageId: number,
  ): Promise<{ job_id?: string; status?: string; message?: string }> {
    return this.request<{ job_id?: string; status?: string; message?: string }>(
      `/managed-pages/${pageId}/recrawl-research`,
      { method: 'POST' },
    );
  }

  async bulkUpdateManagedPages(pageIds: number[], deploymentPlanId: number | null): Promise<BulkPageUpdateResult> {
    return this.request<BulkPageUpdateResult>('/managed-pages/bulk-update', {
      method: 'POST',
      body: JSON.stringify({
        page_ids: pageIds,
        deployment_plan_id: deploymentPlanId,
      }),
    });
  }

  /**
   * Set the build status on a batch of pages in one request.
   *
   * `WAITING_FOR_SYSTEM_ACTION` is what the build daemon selects on, so this is
   * how a selection gets queued. Pages already building are excluded server-side
   * and reported back in `skipped_count` — surface that, or a batch that did
   * less than asked reads as a clean success.
   */
  async bulkSetManagedPageStatus(pageIds: number[], status: PageBuildStatus): Promise<BulkPageUpdateResult> {
    return this.request<BulkPageUpdateResult>('/managed-pages/bulk-update', {
      method: 'POST',
      body: JSON.stringify({
        page_ids: pageIds,
        status,
      }),
    });
  }

  /**
   * Delete a batch of pages in one request.
   *
   * Pages mid-build are left alone and reported in `skipped_count` — deleting
   * a row out from under its worker fails the build on a page that no longer
   * exists.
   */
  async bulkDeleteManagedPages(pageIds: number[]): Promise<BulkPageUpdateResult> {
    return this.request<BulkPageUpdateResult>('/managed-pages/bulk-delete', {
      method: 'POST',
      body: JSON.stringify({ page_ids: pageIds }),
    });
  }

  // ============= LLM Settings Endpoints =============

  async getLLMSettings(): Promise<LLMSettingsListResponse> {
    return this.request<LLMSettingsListResponse>('/llm-settings');
  }

  async getLLMSettingsOptions(): Promise<LLMSettingsOption[]> {
    return this.request<LLMSettingsOption[]>('/llm-settings/options');
  }

  async createLLMSettings(data: LLMSettingsCreate): Promise<LLMSettings> {
    return this.request<LLMSettings>('/llm-settings', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateLLMSettings(id: number, data: LLMSettingsUpdate): Promise<LLMSettings> {
    return this.request<LLMSettings>(`/llm-settings/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteLLMSettings(id: number): Promise<void> {
    return this.request(`/llm-settings/${id}`, { method: 'DELETE' });
  }

  async recalibrateExtractionSettings(id: number): Promise<LLMSettings> {
    return this.request<LLMSettings>(
      `/llm-settings/${id}/recalibrate-extraction`,
      { method: 'POST' },
    );
  }

  async testLLMSettings(
    body: LLMSettingsTestRequest,
  ): Promise<LLMSettingsTestResponse> {
    return this.request<LLMSettingsTestResponse>('/llm-settings/test', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  // ============= LLM Provider Endpoints =============
  // A provider owns the shared connection (interface / base_url / api_key).

  async getLLMProviders(): Promise<LLMProviderListResponse> {
    return this.request<LLMProviderListResponse>('/llm-settings/providers');
  }

  async createLLMProvider(data: LLMProviderCreate): Promise<LLMProvider> {
    return this.request<LLMProvider>('/llm-settings/providers', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateLLMProvider(id: number, data: LLMProviderUpdate): Promise<LLMProvider> {
    return this.request<LLMProvider>(`/llm-settings/providers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async setLLMProviderSystemStatus(id: number, isSystem: boolean): Promise<LLMProvider> {
    return this.request<LLMProvider>(`/llm-settings/providers/${id}/ownership`, {
      method: 'PATCH',
      body: JSON.stringify({ is_system: isSystem }),
    });
  }

  async deleteLLMProvider(id: number): Promise<void> {
    return this.request(`/llm-settings/providers/${id}`, { method: 'DELETE' });
  }

  // ============= User LLM Stage Endpoints =============

  async getStageEnums(): Promise<StageEnumListResponse> {
    return this.request<StageEnumListResponse>('/llm-settings/stages/enum');
  }

  /**
   * Which model currently drives each stage a screen bills against, resolved the
   * way the agents resolve it (profile → DEFAULT → global), with the matching
   * rung reported so the UI can flag inherited defaults.
   *
   * Ask by `surface` ('page_builder') to get that screen's whole stage list —
   * the backend owns which stages a screen uses, so the widget stays right when
   * an agent picks up a new one. `stages` is the ad-hoc escape hatch.
   */
  async resolveStageModels(opts: {
    surface?: string;
    stages?: string[];
  }): Promise<StageModelInfo[]> {
    const params = new URLSearchParams();
    if (opts.surface) params.set('surface', opts.surface);
    if (opts.stages?.length) params.set('stages', opts.stages.join(','));
    const res = await this.request<{ labels: StageModelInfo[] }>(
      `/llm-settings/stages/resolved?${params.toString()}`,
    );
    return res.labels;
  }

  /**
   * The seats of ONE stage: what each runs on now, and what the bench measured.
   *
   * Generic by stage — `UserLLMStage.archetype` is a plain column and the resolver
   * treats it as a refinement within a rung, so any stage whose call context sets one
   * works here. A stage with no seats returns an empty list rather than 404, so the
   * settings page can ask the same question of every stage.
   */
  async listStageSeats(stage: StageEnum): Promise<SeatListResponse> {
    return this.request<SeatListResponse>(
      `/llm-settings/stages/${encodeURIComponent(stage)}/seats`,
    );
  }

  // ============= Admin LLM Settings Endpoints =============

  // ============= LLM Usage Endpoints =============

  // `userScope` is admin-only: a user id, or 'all'. Empty/undefined = your own
  // usage, which is what every non-admin gets and what the panel opens on.
  async getLLMUsageReport(period: 'hour' | 'day' | 'month' | 'year', llmId?: number, periodDate?: string, userScope?: string): Promise<LLMUsageReport> {
    const params = new URLSearchParams({ period });
    if (llmId) params.set('llm_id', String(llmId));
    if (periodDate) params.set('period_date', periodDate);
    if (userScope) params.set('user_id', userScope);
    return this.request<LLMUsageReport>(`/llm-usage/report?${params}`);
  }

  async getLLMUsageTimeseries(period: 'hour' | 'day' | 'month' | 'year', llmId?: number, periodDate?: string, userScope?: string): Promise<LLMUsageTimeseries> {
    const params = new URLSearchParams({ period });
    if (llmId) params.set('llm_id', String(llmId));
    if (periodDate) params.set('period_date', periodDate);
    if (userScope) params.set('user_id', userScope);
    return this.request<LLMUsageTimeseries>(`/llm-usage/timeseries?${params}`);
  }

  async getLLMUsageCalls(start: string, end: string, llmId: number, limit?: number, userScope?: string): Promise<LLMUsageCalls> {
    const params = new URLSearchParams({ start, end, llm_id: String(llmId) });
    if (limit) params.set('limit', String(limit));
    if (userScope) params.set('user_id', userScope);
    return this.request<LLMUsageCalls>(`/llm-usage/calls?${params}`);
  }

  // ============= Recommendation Endpoints =============

  async getRecommendations(params: {
    projectId?: number;
    categoryId?: number;
    topicId?: number;
    status?: RecommendationStatus;
    page?: number;
    size?: number;
  } = {}): Promise<RecommendationPaginatedResponse> {
    const { projectId, categoryId, topicId, status, page = 1, size = 25 } = params;
    let url = `/recommendations?page=${page}&size=${size}`;
    if (projectId) url += `&project_id=${projectId}`;
    if (categoryId) url += `&category_id=${categoryId}`;
    if (topicId) url += `&topic_id=${topicId}`;
    if (status) url += `&status=${status}`;
    return this.request<RecommendationPaginatedResponse>(url);
  }

  async getRecommendation(id: number): Promise<RecommendationDetail> {
    return this.request<RecommendationDetail>(`/recommendations/${id}`);
  }

  async getRecommendationKeywords(
    recommendationId: number,
    page = 1,
    size = 50,
    sortBy?: string,
    sortOrder?: string
  ): Promise<RecTopicKeywordPaginatedResponse> {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (sortBy) params.set('sort_by', sortBy);
    if (sortOrder) params.set('sort_order', sortOrder);
    return this.request<RecTopicKeywordPaginatedResponse>(
      `/recommendations/${recommendationId}/keywords?${params}`
    );
  }

  async approveRecommendationKeywords(
    recommendationId: number,
    recTopicKeywordIds?: number[]
  ): Promise<RecommendationApproveResponse> {
    return this.request<RecommendationApproveResponse>(
      `/recommendations/${recommendationId}/approve`,
      {
        method: 'POST',
        body: JSON.stringify(
          recTopicKeywordIds ? { rec_topic_keyword_ids: recTopicKeywordIds } : {}
        ),
      }
    );
  }

  async dismissRecommendation(
    recommendationId: number,
    recTopicKeywordIds?: number[]
  ): Promise<RecommendationDismissResponse> {
    return this.request<RecommendationDismissResponse>(
      `/recommendations/${recommendationId}/dismiss`,
      {
        method: 'POST',
        body: JSON.stringify(
          recTopicKeywordIds ? { rec_topic_keyword_ids: recTopicKeywordIds } : {}
        ),
      }
    );
  }

  // ============= Unified Discover Feed =============

  async listDiscoveryIdeas(
    topicId: number,
    opts: {
      status?: DiscoveryIdeaStatusFilter;
      sources?: IdeaSource[];
      reviewed?: 'endorsed' | 'rejected' | 'not_reviewed';
      sort_by?: DiscoveryIdeaSort;
      sort_order?: 'asc' | 'desc';
      page?: number;
      size?: number;
    } = {}
  ): Promise<RecTopicKeywordPaginatedResponse> {
    const params = new URLSearchParams();
    if (opts.status) params.set('status', opts.status);
    if (opts.sources) opts.sources.forEach((s) => params.append('sources', s));
    if (opts.reviewed) params.set('reviewed', opts.reviewed);
    if (opts.sort_by) params.set('sort_by', opts.sort_by);
    if (opts.sort_order) params.set('sort_order', opts.sort_order);
    params.set('page', String(opts.page ?? 1));
    params.set('size', String(opts.size ?? 50));
    const qs = params.toString();
    return this.request<RecTopicKeywordPaginatedResponse>(
      `/discovery-ideas/topics/${topicId}${qs ? `?${qs}` : ''}`
    );
  }

  async dismissDiscoveryIdea(rtkId: number, reason?: string): Promise<void> {
    await this.request(`/discovery-ideas/${rtkId}/dismiss`, {
      method: 'POST',
      body: JSON.stringify(reason ? { reason } : {}),
    });
  }

  async acceptDiscoveryIdea(rtkId: number): Promise<DiscoveryIdeaAcceptResponse> {
    return this.request<DiscoveryIdeaAcceptResponse>(
      `/discovery-ideas/${rtkId}/accept`,
      { method: 'POST' }
    );
  }

  // Restore a dismissed idea back to pending (clears dismissed_at).
  async undismissDiscoveryIdea(rtkId: number): Promise<void> {
    await this.request(`/discovery-ideas/${rtkId}/undismiss`, {
      method: 'POST',
    });
  }

  // Manually move a row between endorsed / rejected / pending (the agent's
  // triage axis). 'pending' clears both flags. Does not touch accept/dismiss.
  async reviewDiscoveryIdea(
    rtkId: number,
    state: 'endorsed' | 'rejected' | 'pending',
  ): Promise<void> {
    await this.request(`/discovery-ideas/${rtkId}/review`, {
      method: 'POST',
      body: JSON.stringify({ state }),
    });
  }

  // ── Discover-keywords chat planner ───────────────────────────────────
  // Chat-driven triage of the topic's RecTopicKeyword pool. Each user
  // message kicks off one LLM round-trip; the agent writes endorse /
  // reject / add straight to DB rows during the turn and the discovery
  // ideas list pane streams them in via `discovery_idea_added` events.
  // Chat lifecycle (started / replied / failed / cancelled) flows via
  // `discover_keywords_chat` events.

  async getDiscoverKeywordsChat(
    topicId: number,
  ): Promise<DiscoverKeywordsChatResponse> {
    return this.request<DiscoverKeywordsChatResponse>(
      `/discovery-ideas/topics/${topicId}/chat`,
    );
  }

  async sendDiscoverKeywordsChatMessage(
    topicId: number,
    content: string,
  ): Promise<DiscoverKeywordsChatResponse> {
    return this.request<DiscoverKeywordsChatResponse>(
      `/discovery-ideas/topics/${topicId}/chat/messages`,
      {
        method: 'POST',
        body: JSON.stringify({ content }),
      },
    );
  }

  // Bump the chat's session counter — next chat starts with empty
  // history. Old messages stay in the DB. The discovery pool itself
  // is untouched: fresh chat, same RecTopicKeyword rows.
  async endDiscoverKeywordsChatSession(
    topicId: number,
  ): Promise<DiscoverKeywordsChatResponse> {
    return this.request<DiscoverKeywordsChatResponse>(
      `/discovery-ideas/topics/${topicId}/chat/end-session`,
      { method: 'POST' },
    );
  }

  // Force the chat out of "thinking" — manual fallback when the
  // worker died and the user doesn't want to wait for auto-recover.
  async clearDiscoverKeywordsChatThinking(
    topicId: number,
  ): Promise<DiscoverKeywordsChatResponse> {
    return this.request<DiscoverKeywordsChatResponse>(
      `/discovery-ideas/topics/${topicId}/chat/clear-thinking`,
      { method: 'POST' },
    );
  }

  // Wipe ALL chat history for this topic. The discovery pool is NOT
  // touched.
  async resetDiscoverKeywordsChat(
    topicId: number,
  ): Promise<DiscoverKeywordsChatResponse> {
    return this.request<DiscoverKeywordsChatResponse>(
      `/discovery-ideas/topics/${topicId}/chat`,
      { method: 'DELETE' },
    );
  }

  // Cooperative cancel for the current in-flight chat turn. The
  // worker exits at the top of its next iteration (worst-case stop
  // latency = one LLM turn).
  async cancelDiscoverKeywordsChat(
    topicId: number,
  ): Promise<{ status: string; recommendation_id: number | null }> {
    return this.request(
      `/discovery-ideas/topics/${topicId}/chat/cancel`,
      { method: 'POST' },
    );
  }

  // ── Page-builder concierge chat ──────────────────────────────────────
  // Chat surface on the Page Builder page. The concierge agent
  // orchestrates the existing build phases: each user message can
  // trigger phase re-runs (research / angle / outline / write / ground)
  // that run asynchronously and update the EXISTING phase stepper via
  // the normal page_build / synthesize_research / angle_generated
  // events. The chat lifecycle itself flows via `page_builder_chat`
  // events. POST messages returns immediately with status="thinking".

  async getPageBuilderChat(
    pageId: number,
  ): Promise<PageBuilderChatResponse> {
    return this.request<PageBuilderChatResponse>(
      `/page-builder-chat/pages/${pageId}`,
    );
  }

  async sendPageBuilderChatMessage(
    pageId: number,
    content: string,
  ): Promise<PageBuilderChatResponse> {
    return this.request<PageBuilderChatResponse>(
      `/page-builder-chat/pages/${pageId}/messages`,
      {
        method: 'POST',
        body: JSON.stringify({ content }),
      },
    );
  }

  // Bump the chat's session counter — next chat starts with empty
  // history. Old messages stay in the DB. The page build itself is
  // untouched.
  async endPageBuilderChatSession(
    pageId: number,
  ): Promise<PageBuilderChatResponse> {
    return this.request<PageBuilderChatResponse>(
      `/page-builder-chat/pages/${pageId}/end-session`,
      { method: 'POST' },
    );
  }

  // Force the chat out of "thinking" — manual fallback when the
  // worker died and the user doesn't want to wait for auto-recover.
  async clearPageBuilderChatThinking(
    pageId: number,
  ): Promise<PageBuilderChatResponse> {
    return this.request<PageBuilderChatResponse>(
      `/page-builder-chat/pages/${pageId}/clear-thinking`,
      { method: 'POST' },
    );
  }

  // Wipe ALL chat history for this page. The page build is NOT touched.
  async resetPageBuilderChat(
    pageId: number,
  ): Promise<PageBuilderChatResponse> {
    return this.request<PageBuilderChatResponse>(
      `/page-builder-chat/pages/${pageId}`,
      { method: 'DELETE' },
    );
  }

  // ============= Conversation Endpoints =============

  async getConversation(pageId: number): Promise<Conversation> {
    return this.request<Conversation>(`/managed-pages/${pageId}/conversation`);
  }

  // ============= SEO Analysis Endpoints =============

  async analyzeSEO(data: SEOAnalysisRequest): Promise<SEOAnalysisResponse> {
    return this.request<SEOAnalysisResponse>('/seo-analysis/analyze', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // ============= Content Refinement Endpoints =============

  // Refine now runs in the agent_work RQ queue (the RefineLoop can crawl the
  // web), so this returns a queued-job ack; completion arrives as a
  // `page_refine` websocket event rather than in this response.
  async getContentVersions(
    pageId: number,
    page: number = 1,
    size: number = 20
  ): Promise<ContentVersionListResponse> {
    return this.request<ContentVersionListResponse>(
      `/managed-pages/${pageId}/versions?page=${page}&size=${size}`
    );
  }

  async getContentVersion(pageId: number, versionId: number): Promise<ContentVersionDetail> {
    return this.request<ContentVersionDetail>(`/managed-pages/${pageId}/versions/${versionId}`);
  }

  async getVersionProvenance(
    pageId: number,
    versionId: number
  ): Promise<ProvenanceResponse> {
    return this.request<ProvenanceResponse>(
      `/managed-pages/${pageId}/versions/${versionId}/provenance`
    );
  }

  async getEditableBody(
    pageId: number,
    versionId: number
  ): Promise<EditableBodyResponse> {
    return this.request<EditableBodyResponse>(
      `/managed-pages/${pageId}/versions/${versionId}/editable-body`
    );
  }

  /**
   * The article body as it will be PUBLISHED — the same builder the deployers
   * run, so what is on screen is what lands in the repo or the post.
   *
   * `citations` tries a style without saving it; omit it to render whatever the
   * page's site is set to.
   */
  async previewPageBody(
    pageId: number,
    versionId: number,
    citations?: CitationStyle
  ): Promise<PageBodyPreviewResponse> {
    const query = citations ? `?citations=${encodeURIComponent(citations)}` : '';
    return this.request<PageBodyPreviewResponse>(
      `/managed-pages/${pageId}/versions/${versionId}/preview${query}`
    );
  }

  async compareVersions(
    pageId: number,
    versionAId: number,
    versionBId: number
  ): Promise<ContentVersionCompareResponse> {
    return this.request<ContentVersionCompareResponse>(
      `/managed-pages/${pageId}/versions/compare?version_a_id=${versionAId}&version_b_id=${versionBId}`
    );
  }

  async switchToVersion(pageId: number, versionId: number): Promise<SwitchVersionResponse> {
    return this.request<SwitchVersionResponse>(`/managed-pages/${pageId}/versions/switch`, {
      method: 'POST',
      body: JSON.stringify({ version_id: versionId }),
    });
  }

  async getStageDiff(
    pageId: number,
    fromStage: string,
    toStage: string
  ): Promise<StageDiffResponse> {
    return this.request<StageDiffResponse>(
      `/managed-pages/${pageId}/stage-diff?from_stage=${fromStage}&to_stage=${toStage}`
    );
  }

  async deleteContentVersion(pageId: number, versionId: number): Promise<DeleteVersionResponse> {
    return this.request<DeleteVersionResponse>(`/managed-pages/${pageId}/versions/${versionId}`, {
      method: 'DELETE',
    });
  }

  // ============= WebSocket Endpoints =============

  async getWebSocketToken(): Promise<WebSocketTokenResponse> {
    return this.request<WebSocketTokenResponse>('/auth/ws-token');
  }

  // ============= Browser Plugin Endpoints =============

  async getPersonalAccessTokens(): Promise<PersonalAccessToken[]> {
    return this.request<PersonalAccessToken[]>('/plugin/tokens');
  }

  async createPersonalAccessToken(name?: string): Promise<PersonalAccessTokenCreated> {
    return this.request<PersonalAccessTokenCreated>('/plugin/tokens', {
      method: 'POST',
      body: JSON.stringify({ name: name || null }),
    });
  }

  async renamePersonalAccessToken(tokenId: number, name: string): Promise<PersonalAccessToken> {
    return this.request<PersonalAccessToken>(`/plugin/tokens/${tokenId}`, {
      method: 'PATCH',
      body: JSON.stringify({ name: name.trim() || null }),
    });
  }

  async revokePersonalAccessToken(tokenId: number): Promise<void> {
    return this.request(`/plugin/tokens/${tokenId}`, {
      method: 'DELETE',
    });
  }

  async getPluginDevices(): Promise<PluginDevice[]> {
    return this.request<PluginDevice[]>('/plugin/queued/devices');
  }

  /** Share a queued-extension browser with all users; sharing needs `confirmShared`. */
  async setPluginDeviceSystem(devicePk: number, isSystem: boolean, confirmShared = false): Promise<PluginDevice> {
    return this.request<PluginDevice>(`/plugin/queued/devices/${devicePk}`, {
      method: 'PATCH',
      body: JSON.stringify({ is_system: isSystem, confirm_shared: confirmShared }),
    });
  }

  /** Let a shared queued browser's console take other users' signed-in searches. */
  async setPluginDeviceConsoleForOthers(devicePk: number, on: boolean): Promise<PluginDevice> {
    return this.request<PluginDevice>(`/plugin/queued/devices/${devicePk}`, {
      method: 'PATCH',
      body: JSON.stringify({ console_for_others: on }),
    });
  }

  async getPluginV2Devices(): Promise<PluginV2Device[]> {
    return this.request<PluginV2Device[]>('/plugin/connected/devices');
  }

  /** Sharing needs `confirmShared` — the server refuses it otherwise (see ConfirmShareDialog). */
  async setPluginV2DeviceSystem(
    devicePk: number,
    isSystem: boolean,
    confirmShared = false,
  ): Promise<PluginV2Device> {
    return this.request<PluginV2Device>(`/plugin/connected/devices/${devicePk}`, {
      method: 'PATCH',
      body: JSON.stringify({ is_system: isSystem, confirm_shared: confirmShared }),
    });
  }

  /** Let a shared connected browser's console take other users' signed-in searches. */
  async setPluginV2DeviceConsoleForOthers(devicePk: number, on: boolean): Promise<PluginV2Device> {
    return this.request<PluginV2Device>(`/plugin/connected/devices/${devicePk}`, {
      method: 'PATCH',
      body: JSON.stringify({ console_for_others: on }),
    });
  }

  async getPluginDownloadUrl(kind: ExtensionKind): Promise<{ url: string | null }> {
    return this.request<{ url: string | null }>(`/plugin/download-url?kind=${kind}`);
  }

  async updateAdminSetting(key: string, value: string | null): Promise<AdminSetting> {
    return this.request<AdminSetting>(`/admin/settings/${key}`, {
      method: 'PUT',
      body: JSON.stringify({ value }),
    });
  }

  // Upload one extension's zip to the admin's S3 bucket; returns the setting whose
  // value is the resulting public download URL.
  async uploadPluginZip(file: File, kind: ExtensionKind): Promise<AdminSetting> {
    const form = new FormData();
    form.append('file', file);
    const headers: Record<string, string> = {};
    if (this.token) headers['Authorization'] = `Bearer ${this.token}`;
    const response = await fetch(`${API_BASE_URL}/admin/settings/upload-plugin?kind=${kind}`, {
      method: 'POST',
      headers,
      body: form,
      // Same-session as `request()` — see the note on login.
      credentials: 'include',
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({ detail: 'Upload failed' }));
      throw new Error(typeof err.detail === 'string' ? err.detail : 'Upload failed');
    }
    return response.json();
  }

  // ============= GitHub Integration Endpoints =============

  async getGitHubInstallUrl(): Promise<{ url: string }> {
    return this.request<{ url: string }>('/github/install-url');
  }

  async getGitHubInstallations(): Promise<GitHubInstallation[]> {
    return this.request<GitHubInstallation[]>('/github/installations');
  }

  async claimGitHubInstallation(githubInstallationId: number): Promise<GitHubInstallation> {
    return this.request<GitHubInstallation>(`/github/installations/claim?installation_id=${githubInstallationId}`, {
      method: 'POST',
    });
  }

  async getGitHubInstallation(installationId: number): Promise<GitHubInstallationDetail> {
    return this.request<GitHubInstallationDetail>(`/github/installations/${installationId}`);
  }

  async syncGitHubInstallation(installationId: number): Promise<{ synced_count: number }> {
    return this.request<{ synced_count: number }>(`/github/installations/${installationId}/sync`, {
      method: 'POST',
    });
  }

  async removeGitHubInstallation(installationId: number): Promise<void> {
    return this.request(`/github/installations/${installationId}`, {
      method: 'DELETE',
    });
  }

  async getGitHubRepos(): Promise<GitHubRepo[]> {
    return this.request<GitHubRepo[]>('/github/repos');
  }

  async getSiteGitHubRepos(siteId: number): Promise<ManagedSiteGitHubRepo[]> {
    return this.request<ManagedSiteGitHubRepo[]>(`/github/sites/${siteId}/repos`);
  }

  async linkRepoToSite(siteId: number, data: LinkRepoToSiteRequest): Promise<ManagedSiteGitHubRepo> {
    return this.request<ManagedSiteGitHubRepo>(`/github/sites/${siteId}/repos`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async unlinkRepoFromSite(siteId: number, linkId: number): Promise<void> {
    return this.request(`/github/sites/${siteId}/repos/${linkId}`, {
      method: 'DELETE',
    });
  }

  // ============= Google Ads Endpoints =============

  async getGoogleAdsAuthUrl(): Promise<{ url: string }> {
    return this.request<{ url: string }>('/google-ads/auth-url');
  }

  async getGoogleAdsStatus(): Promise<GoogleAdsStatus> {
    return this.request<GoogleAdsStatus>('/google-ads/status');
  }

  async testGoogleAdsConnection(): Promise<{ ok: boolean; detail: string }> {
    return this.request<{ ok: boolean; detail: string }>('/google-ads/test-connection', {
      method: 'POST',
    });
  }

  async disconnectGoogleAds(): Promise<void> {
    return this.request('/google-ads/disconnect', { method: 'DELETE' });
  }

  async setGoogleAdsHouse(enabled: boolean): Promise<GoogleAdsStatus> {
    return this.request<GoogleAdsStatus>('/google-ads/house', {
      method: 'PUT',
      body: JSON.stringify({ enabled }),
    });
  }

  async getGoogleAdsHouseGrants(): Promise<GoogleAdsHouseGrant[]> {
    return this.request<GoogleAdsHouseGrant[]>('/google-ads/house/grants');
  }

  async setGoogleAdsHouseGrant(
    userId: number,
    granted: boolean
  ): Promise<GoogleAdsHouseGrant> {
    return this.request<GoogleAdsHouseGrant>(`/google-ads/house/grants/${userId}`, {
      method: 'PUT',
      body: JSON.stringify({ granted }),
    });
  }

  // ============= Alias/Map Parent Endpoints =============

  /**
   * Fold keywords — and whatever is already grouped with them — onto one page.
   *
   * Not `bulkSetAliasParent`: that one refuses a row that has children of its
   * own, so merging a group of three into a group of two cannot be expressed
   * as a single call to it. This flattens server-side and re-points the link
   * map in the same request.
   */
  async mergeIntoCluster(
    topicKeywordIds: number[],
    intoId: number
  ): Promise<{ merged_count: number; into_id: number; map_links_repointed: number }> {
    return this.request('/topic-keywords/merge-into-cluster', {
      method: 'POST',
      body: JSON.stringify({ topic_keyword_ids: topicKeywordIds, into_id: intoId }),
    });
  }

  async bulkSetAliasParent(
    tkIds: number[],
    parentId: number | null
  ): Promise<{ updated_count: number }> {
    return this.request<{ updated_count: number }>('/topic-keywords/bulk-set-alias-parent', {
      method: 'POST',
      body: JSON.stringify({
        topic_keyword_ids: tkIds,
        alias_parent_id: parentId,
      }),
    });
  }

  /**
   * Hand a grouping back to the agent.
   *
   * Merging and splitting both mark a row as decided-by-a-human, which is what
   * stops the rebuild undoing them. Releasing that is the only way to let the
   * next rebuild reconsider a pair you grouped by hand.
   */
  async setAliasLocked(tkId: number, locked: boolean): Promise<TopicKeyword> {
    return this.request<TopicKeyword>(`/topic-keywords/${tkId}`, {
      method: 'PUT',
      body: JSON.stringify({ alias_locked: locked }),
    });
  }

  async setMapParent(
    tkId: number,
    parentId: number | null
  ): Promise<TopicKeyword> {
    return this.request<TopicKeyword>(`/topic-keywords/${tkId}`, {
      method: 'PUT',
      body: JSON.stringify({ map_parent_id: parentId }),
    });
  }

  async bulkPinKeywords(
    tkIds: number[],
    pinned: boolean = true
  ): Promise<{ updated_count: number }> {
    return this.request<{ updated_count: number }>('/topic-keywords/bulk-pin', {
      method: 'POST',
      body: JSON.stringify({
        topic_keyword_ids: tkIds,
        pinned,
      }),
    });
  }

  // Move ("cut") or associate ("copy") topic keywords into another topic.
  // cut re-points the rows (pages/clustering follow); copy creates fresh
  // associations. Keywords already in the target topic are skipped.
  async bulkMoveKeywords(
    tkIds: number[],
    targetTopicId: number,
    mode: 'cut' | 'copy',
    onConflict: 'skip' = 'skip'
  ): Promise<{ moved: number; copied: number; skipped: number }> {
    return this.request<{ moved: number; copied: number; skipped: number }>(
      '/topic-keywords/bulk-move',
      {
        method: 'POST',
        body: JSON.stringify({
          topic_keyword_ids: tkIds,
          target_topic_id: targetTopicId,
          mode,
          on_conflict: onConflict,
        }),
      }
    );
  }

  // ============= Trending Keywords =============

  async getTrendingKeywords(params: {
    page?: number;
    size?: number;
    sortBy?: string;
    sortOrder?: string;
    projectId?: number | null;
    scope?: 'worklist' | 'explored' | null;
    seed?: string | null;
    minGrowth?: number | null;
    minVolume?: number | null;
    keywordSearch?: string | null;
    semanticSearch?: string | null;
    minSemSimilarity?: number | null;
    recommendationsOnly?: boolean;
    /** Only keywords whose Ads metrics were pulled this recently. null = any age. */
    fetchedWithinDays?: number | null;
    /** 'unfiled' = not in any subject yet; 'filed' = already placed. */
    filed?: 'unfiled' | 'filed' | null;
    /** 'no' = nothing written yet; 'yes' = a page already exists. */
    hasPage?: 'yes' | 'no' | null;
    /** The open-position filters — see SerpGapFilter. */
    gapFilter?: SerpGapFilter | null;
  } = {}): Promise<TrendingKeywordPaginatedResponse> {
    const { page = 1, size = 50, sortBy = 'growth', sortOrder = 'desc', projectId, scope, seed, minGrowth, minVolume, keywordSearch, semanticSearch, minSemSimilarity, recommendationsOnly, fetchedWithinDays, filed, hasPage, gapFilter } = params;
    let url = `/trending-keywords?page=${page}&size=${size}&sort_by=${sortBy}&sort_order=${sortOrder}`;
    if (projectId) url += `&project_id=${projectId}`;
    if (scope) url += `&scope=${scope}`;
    if (seed) url += `&seed=${encodeURIComponent(seed)}`;
    if (minGrowth != null) url += `&min_growth=${minGrowth}`;
    if (minVolume != null) url += `&min_volume=${minVolume}`;
    if (keywordSearch) url += `&keyword_search=${encodeURIComponent(keywordSearch)}`;
    if (semanticSearch) url += `&semantic_search=${encodeURIComponent(semanticSearch)}`;
    if (minSemSimilarity != null) url += `&min_sem_similarity=${minSemSimilarity}`;
    if (recommendationsOnly) url += `&recommendations_only=true`;
    if (fetchedWithinDays != null) url += `&fetched_within_days=${fetchedWithinDays}`;
    if (filed) url += `&filed=${filed}`;
    if (hasPage) url += `&has_page=${hasPage}`;
    url += serpGapQuery(gapFilter);
    return this.request<TrendingKeywordPaginatedResponse>(url);
  }

  async getExploredSeeds(): Promise<{ seed: string; keyword_count: number }[]> {
    return this.request(`/trending-keywords/explored-seeds`);
  }


  /** The trending feed joined to whatever we have researched about it.
   *
   * Kicks off enrichment for the top few unresearched terms as a side effect —
   * pass `autoEnrich: false` to look without spending Google Ads / GNews quota. */
  async getTrendStories(params: { geo?: string; limit?: number; days?: number; refresh?: boolean; autoEnrich?: boolean; tags?: string[] } = {}): Promise<TrendStoriesResponse> {
    const { geo = 'US', limit = 200, days = 5, refresh = false, autoEnrich = true, tags } = params;
    let url = `/trend-briefs?geo=${encodeURIComponent(geo)}&limit=${limit}&days=${days}`;
    if (tags?.length) url += `&tags=${encodeURIComponent(tags.join(','))}`;
    if (refresh) url += '&refresh=true';
    if (!autoEnrich) url += '&auto_enrich=false';
    return this.request<TrendStoriesResponse>(url);
  }

  /** Research one term on demand. Returns once QUEUED — the result arrives over
   * the websocket as a `trend_brief` event. */
  async requestTrendBrief(term: string, geo = 'US', force = false): Promise<TrendBriefRequestResponse> {
    return this.request<TrendBriefRequestResponse>('/trend-briefs', {
      method: 'POST',
      body: JSON.stringify({ term, geo, force }),
    });
  }

  /** Mint the proposed page, carrying the trend's stories with it as research
   * sources. `topicKeywordId` is the destination — a page cannot exist without
   * one, so it is required rather than optional. */
  async createPageFromProposal(
    proposalId: number,
    body: { topic_keyword_id: number; deployment_plan_id?: number | null; path_segments?: string[] | null },
  ): Promise<CreatePageFromProposalResponse> {
    return this.request<CreatePageFromProposalResponse>(`/trend-proposals/${proposalId}/create`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** What a build will actually be working from — the trend, the room, the
   *  rules, the research and the documents, in one answer. */
  async getBuildContext(pageId: number): Promise<BuildContextResponse> {
    return this.request<BuildContextResponse>(`/managed-pages/${pageId}/build-context`);
  }

  /** Get (or create) the Keyword row behind a bare trending term.
   *
   * A term off Google's feed is a string until somebody decides it is worth
   * tracking, and every downstream flow needs an id. `get_or_create` on the
   * normalised value, so a term that is already tracked adopts the existing row
   * rather than splitting its metrics across a near-duplicate. */
  async trackSpikingTerm(term: string): Promise<TrackSpikingTermResponse> {
    return this.request<TrackSpikingTermResponse>('/spiking-searches/keyword', {
      method: 'POST',
      body: JSON.stringify({ term }),
    });
  }

  /** Write a page about a trending term nobody proposed one for. Same context
   *  as the proposal path, minus an angle nobody argued. */
  async createPageFromTrend(
    briefId: number,
    body: { topic_keyword_id: number; deployment_plan_id?: number | null; path_segments?: string[] | null },
  ): Promise<CreatePageFromProposalResponse> {
    return this.request<CreatePageFromProposalResponse>(`/trend-briefs/${briefId}/page`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** Every story tag, whatever state it is in — including dismissed ones, which
   *  is the only way back from a dismissal. */
  async listTrendTags(): Promise<TrendTag[]> {
    return this.request<TrendTag[]>('/trend-tags');
  }

  /** Put a tag back in the suggestion pile. Undoes a dismissal, and retires an
   *  active tag without declaring it unwanted forever. */
  async restoreTrendTag(tagId: number): Promise<TrendTag> {
    return this.request<TrendTag>(`/trend-tags/${tagId}/restore`, { method: 'POST' });
  }

  /** Add a bucket to the trend vocabulary, or promote one by value. */
  async addTrendTag(body: { value?: string; label?: string; hint?: string }): Promise<TrendTag> {
    return this.request<TrendTag>('/trend-tags', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** Turn a bucket the model asked for into one it can use. */
  async promoteTrendTag(tagId: number, body: { label?: string; hint?: string } = {}): Promise<TrendTag> {
    return this.request<TrendTag>(`/trend-tags/${tagId}/promote`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** Turn a suggestion down — it stops being offered. Reversible with
   *  `restoreTrendTag`. */
  async dismissTrendTag(tagId: number): Promise<void> {
    await this.request<void>(`/trend-tags/${tagId}/dismiss`, { method: 'POST' });
  }

  async dismissTrendProposal(proposalId: number): Promise<void> {
    await this.request<void>(`/trend-proposals/${proposalId}/dismiss`, { method: 'POST' });
  }

  /** Create a subject from researched keywords and set the structure planner
   * going on them, so the workspace opens with a proposed tree rather than
   * empty. */
  async startSubjectFromKeywords(name: string, keywordIds: number[]): Promise<StartSubjectFromKeywordsResponse> {
    return this.request<StartSubjectFromKeywordsResponse>('/trending-keywords/subject', {
      method: 'POST',
      body: JSON.stringify({ name, keyword_ids: keywordIds }),
    });
  }

  // ============= Proxy Settings Endpoints =============

  async getProxies(proxyListId?: number): Promise<ProxySettingsListResponse> {
    const q = proxyListId !== undefined ? `?proxy_list_id=${proxyListId}` : '';
    return this.request<ProxySettingsListResponse>(`/proxy-settings${q}`);
  }

  async addProxy(proxy: ProxyCreateRequest): Promise<ProxySettings> {
    return this.request<ProxySettings>('/proxy-settings', {
      method: 'POST',
      body: JSON.stringify(proxy),
    });
  }

  async bulkAddProxies(proxyListId: number, proxiesText: string): Promise<ProxyBulkAddResponse> {
    return this.request<ProxyBulkAddResponse>('/proxy-settings/bulk', {
      method: 'POST',
      body: JSON.stringify({ proxy_list_id: proxyListId, proxies_text: proxiesText }),
    });
  }

  // ============= Proxy Lists (admin) =============

  async getProxyLists(): Promise<ProxyList[]> {
    return this.request<ProxyList[]>('/proxy-lists');
  }

  async createProxyList(body: ProxyListBody): Promise<ProxyList> {
    return this.request<ProxyList>('/proxy-lists', { method: 'POST', body: JSON.stringify(body) });
  }

  async updateProxyList(id: number, body: ProxyListBody): Promise<ProxyList> {
    return this.request<ProxyList>(`/proxy-lists/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  async deleteProxyList(id: number): Promise<void> {
    return this.request(`/proxy-lists/${id}`, { method: 'DELETE' });
  }

  // ============= Network status =============

  async getNetworkFetchers(): Promise<NetworkFetchersResponse> {
    return this.request<NetworkFetchersResponse>('/network/fetchers');
  }

  /** ADMIN: each fetch adapter — what it can fetch, what it may, what it holds now. */
  async getNetworkAdapters(): Promise<AdaptersResponse> {
    return this.request<AdaptersResponse>('/network/adapters');
  }

  /** ADMIN: what is waiting on the fetch queue, in flight, and the latest failures. */
  async getFetchQueue(): Promise<FetchQueueResponse> {
    return this.request<FetchQueueResponse>('/network/queue');
  }

  /** ADMIN: what fetching knows about bot protection: proxies, sites, tools, warnings. */
  async getProtectionReport(): Promise<ProtectionReport> {
    return this.request<ProtectionReport>('/network/protection');
  }

  /** ADMIN: searches waiting in the queue, and keywords not searched yet, to trace. */
  async getTraceWaiting(): Promise<{ queued: string[]; unsearched: string[] }> {
    return this.request<{ queued: string[]; unsearched: string[] }>('/network/trace/waiting');
  }

  /** ADMIN: a dry run (steps at once) or a real run (a trace id to follow). */
  async startTrace(body: {
    kind: 'keyword' | 'url';
    subject: string;
    mode: 'dry' | 'real';
    top: number;
  }): Promise<TraceStartResponse> {
    return this.request<TraceStartResponse>('/network/trace', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async getTrace(id: string): Promise<TraceRun> {
    return this.request<TraceRun>(`/network/trace/${encodeURIComponent(id)}`);
  }

  /** ADMIN: a traced page's text as stored now (its content, plain text, or parse). */
  async getTracePage(pageId: number, show: TracePageShow): Promise<TracePageText> {
    return this.request<TracePageText>(`/network/trace/page/${pageId}/${show}`);
  }

  async getTraces(): Promise<{ traces: TraceMeta[] }> {
    return this.request<{ traces: TraceMeta[] }>('/network/traces');
  }

  /** ADMIN: per adapter, per hour — tries, successes, time per fetch, how full, how long waited. */
  async getFetchThroughput(hours = 24): Promise<ThroughputResponse> {
    return this.request<ThroughputResponse>(`/network/throughput?hours=${hours}`);
  }

  async getEngineMatrix(): Promise<EngineMatrix> {
    return this.request<EngineMatrix>('/network/engines');
  }

  /** ADMIN: lift a pause on a (fetcher, engine) pair now, so it is tried again. */
  async resetEngineBreaker(fetcher: string, engine: string): Promise<{ ok: boolean }> {
    return this.request<{ ok: boolean }>('/network/engines/breaker/reset', {
      method: 'POST',
      body: JSON.stringify({ fetcher, engine }),
    });
  }

  async getNetworkStatus(): Promise<NetworkStatus> {
    return this.request<NetworkStatus>('/network/status');
  }

  async updateProxy(id: number, fields: ProxyUpdateRequest): Promise<ProxySettings> {
    return this.request<ProxySettings>(`/proxy-settings/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(fields),
    });
  }

  async setProxyEnabled(id: number, isEnabled: boolean): Promise<ProxySettings> {
    return this.updateProxy(id, { is_enabled: isEnabled });
  }

  async testProxy(id: number): Promise<ProxyTestResponse> {
    return this.request<ProxyTestResponse>(`/proxy-settings/${id}/test`, {
      method: 'POST',
    });
  }

  async deleteProxy(id: number): Promise<void> {
    return this.request(`/proxy-settings/${id}`, { method: 'DELETE' });
  }

  // ============= Image Storage Settings =============

  async getImageStorageSettings(): Promise<ImageStorageSettingsListResponse> {
    return this.request<ImageStorageSettingsListResponse>('/image-storage-settings');
  }

  async createImageStorageSettings(
    data: ImageStorageSettingsCreate
  ): Promise<ImageStorageSettings> {
    return this.request<ImageStorageSettings>('/image-storage-settings', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateImageStorageSettings(
    id: number,
    data: ImageStorageSettingsUpdate
  ): Promise<ImageStorageSettings> {
    return this.request<ImageStorageSettings>(`/image-storage-settings/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async testImageStorageSettings(id: number): Promise<ImageStorageTestResponse> {
    return this.request<ImageStorageTestResponse>(
      `/image-storage-settings/${id}/test`,
      { method: 'POST' }
    );
  }

  async deleteImageStorageSettings(id: number): Promise<void> {
    return this.request(`/image-storage-settings/${id}`, { method: 'DELETE' });
  }

  // ============= Network Settings =============

  async getNetworkSettings(): Promise<NetworkSettings> {
    return this.request<NetworkSettings>('/network/settings');
  }

  async updateNetworkSettings(data: NetworkSettingsUpdate): Promise<NetworkSettings> {
    return this.request<NetworkSettings>('/network/settings', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async getAmazonAffiliateSettings(): Promise<AmazonAffiliateSettings> {
    return this.request<AmazonAffiliateSettings>('/amazon-affiliate-settings');
  }

  async listEmailSpyConnections(): Promise<EmailSpyConnection[]> {
    return this.request<EmailSpyConnection[]>('/email-spy-connections');
  }

  async createEmailSpyConnection(data: EmailSpyConnectionCreate): Promise<EmailSpyConnection> {
    return this.request<EmailSpyConnection>('/email-spy-connections', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateEmailSpyConnection(id: number, data: EmailSpyConnectionUpdate): Promise<EmailSpyConnection> {
    return this.request<EmailSpyConnection>(`/email-spy-connections/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  /** Refused (409) once sign-ups were made through it. */
  async deleteEmailSpyConnection(id: number): Promise<void> {
    await this.request<void>(`/email-spy-connections/${id}`, { method: 'DELETE' });
  }

  async testEmailSpyConnection(id: number): Promise<{ ok: boolean; organization_name: string | null }> {
    return this.request(`/email-spy-connections/${id}/test`, { method: 'POST' });
  }

  async getBoardroomEmailSpyConnection(roomId: number): Promise<BoardroomEmailSpyChoice> {
    return this.request<BoardroomEmailSpyChoice>(`/boardroom/${roomId}/email-spy-connection`);
  }

  /** null = use the default connection. */
  async setBoardroomEmailSpyConnection(roomId: number, connectionId: number | null): Promise<BoardroomEmailSpyChoice> {
    return this.request<BoardroomEmailSpyChoice>(`/boardroom/${roomId}/email-spy-connection`, {
      method: 'PUT',
      body: JSON.stringify({ connection_id: connectionId }),
    });
  }

  async startBoardroomEmailSignups(id: number): Promise<BoardroomEmailSignupStart> {
    return this.request<BoardroomEmailSignupStart>(`/boardroom/${id}/email-signups`, { method: 'POST' });
  }

  async retryBoardroomEmailSignups(id: number): Promise<{ started: number }> {
    return this.request<{ started: number }>(`/boardroom/${id}/email-signups/retry`, { method: 'POST' });
  }

  async startBoardroomAppealReads(id: number): Promise<{ started: number; skipped: number }> {
    return this.request<{ started: number; skipped: number }>(`/boardroom/${id}/appeal-reads`, { method: 'POST' });
  }

  async actOnBoardroomEmailSignup(
    id: number,
    signupId: number,
    action: 'retry' | 'done',
  ): Promise<BoardroomEmailSignup> {
    return this.request<BoardroomEmailSignup>(`/boardroom/${id}/email-signups/${signupId}`, {
      method: 'POST',
      body: JSON.stringify({ action }),
    });
  }

  async updateAmazonAffiliateSettings(
    data: AmazonAffiliateSettingsUpdate
  ): Promise<AmazonAffiliateSettings> {
    return this.request<AmazonAffiliateSettings>('/amazon-affiliate-settings', {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async getNetworkRequestReport(period: 'hour' | 'day' | 'month' | 'year', periodDate?: string, downloaderType?: string, userScope?: string): Promise<NetworkRequestReport> {
    const params = new URLSearchParams({ period });
    if (periodDate) params.set('period_date', periodDate);
    if (downloaderType) params.set('downloader_type', downloaderType);
    if (userScope) params.set('user_id', userScope);
    return this.request<NetworkRequestReport>(`/network/requests/report?${params}`);
  }

  async getNetworkRequestTimeseries(period: 'hour' | 'day' | 'month' | 'year', periodDate?: string, downloaderType?: string, userScope?: string): Promise<NetworkRequestTimeseries> {
    const params = new URLSearchParams({ period });
    if (periodDate) params.set('period_date', periodDate);
    if (downloaderType) params.set('downloader_type', downloaderType);
    if (userScope) params.set('user_id', userScope);
    return this.request<NetworkRequestTimeseries>(`/network/requests/timeseries?${params}`);
  }

  async getNetworkRequestRows(start: string, end: string, searchEngine?: string, limit?: number, downloaderType?: string, userScope?: string): Promise<NetworkRequestRowsResponse> {
    const params = new URLSearchParams({ start, end });
    if (searchEngine) params.set('search_engine', searchEngine);
    if (downloaderType) params.set('downloader_type', downloaderType);
    if (limit) params.set('limit', String(limit));
    if (userScope) params.set('user_id', userScope);
    return this.request<NetworkRequestRowsResponse>(`/network/requests/rows?${params}`);
  }

  // ============= Third-party API usage (Google Ads, GNews) =============

  async getApiUsageReport(period: 'hour' | 'day' | 'month' | 'year', periodDate?: string, provider?: string, userScope?: string): Promise<ApiUsageReport> {
    const params = new URLSearchParams({ period });
    if (periodDate) params.set('period_date', periodDate);
    if (provider) params.set('provider', provider);
    if (userScope) params.set('user_id', userScope);
    return this.request<ApiUsageReport>(`/api-usage/report?${params}`);
  }

  async getApiUsageTimeseries(period: 'hour' | 'day' | 'month' | 'year', periodDate?: string, provider?: string, userScope?: string): Promise<ApiUsageTimeseries> {
    const params = new URLSearchParams({ period });
    if (periodDate) params.set('period_date', periodDate);
    if (provider) params.set('provider', provider);
    if (userScope) params.set('user_id', userScope);
    return this.request<ApiUsageTimeseries>(`/api-usage/timeseries?${params}`);
  }

  async getApiUsageCalls(start: string, end: string, provider?: string, operation?: string, limit?: number, userScope?: string): Promise<ApiUsageCallsResponse> {
    const params = new URLSearchParams({ start, end });
    if (provider) params.set('provider', provider);
    if (operation) params.set('operation', operation);
    if (limit) params.set('limit', String(limit));
    if (userScope) params.set('user_id', userScope);
    return this.request<ApiUsageCallsResponse>(`/api-usage/calls?${params}`);
  }

  // ============= Documents =============

  async uploadDocument(
    file: File,
    ids: { project_id?: number; category_id?: number; topic_id?: number; topic_keyword_id?: number }
  ): Promise<DocumentInfo> {
    const formData = new FormData();
    formData.append('file', file);
    if (ids.project_id) formData.append('project_id', String(ids.project_id));
    if (ids.category_id) formData.append('category_id', String(ids.category_id));
    if (ids.topic_id) formData.append('topic_id', String(ids.topic_id));
    if (ids.topic_keyword_id) formData.append('topic_keyword_id', String(ids.topic_keyword_id));

    const url = `${API_BASE_URL}/documents`;
    const headers: Record<string, string> = {};
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }
    // Do NOT set Content-Type; fetch will set multipart boundary automatically
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: formData,
      // Same-session as `request()` — see the note on login.
      credentials: 'include',
    });
    if (response.status === 401) {
      this.setToken(null);
      window.location.href = '/login';
      throw new Error('Unauthorized');
    }
    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Upload failed' }));
      throw new Error(typeof error.detail === 'string' ? error.detail : 'Upload failed');
    }
    return response.json();
  }

  async getDocuments(filters: {
    project_id?: number;
    category_id?: number;
    topic_id?: number;
    topic_keyword_id?: number;
  } = {}): Promise<DocumentInfo[]> {
    const params = new URLSearchParams();
    if (filters.project_id) params.set('project_id', String(filters.project_id));
    if (filters.category_id) params.set('category_id', String(filters.category_id));
    if (filters.topic_id) params.set('topic_id', String(filters.topic_id));
    if (filters.topic_keyword_id) params.set('topic_keyword_id', String(filters.topic_keyword_id));
    const qs = params.toString();
    return this.request<DocumentInfo[]>(`/documents${qs ? '?' + qs : ''}`);
  }

  async createDocumentFromText(data: {
    content: string;
    title: string;
    project_id?: number;
    category_id?: number;
    topic_id?: number;
    topic_keyword_id?: number;
  }): Promise<DocumentInfo> {
    return this.request<DocumentInfo>('/documents/from-text', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async createDocumentFromSerpEntry(data: {
    serp_entry_id: number; topic_keyword_id: number;
  }): Promise<DocumentInfo> {
    return this.request<DocumentInfo>('/documents/from-serp-entry', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async deleteDocument(id: number): Promise<void> {
    return this.request(`/documents/${id}`, { method: 'DELETE' });
  }

  async getDocumentDetail(documentId: number): Promise<DocumentDetail> {
    return this.request<DocumentDetail>(`/documents/${documentId}`);
  }

  async reprocessDocument(documentId: number): Promise<DocumentInfo> {
    return this.request<DocumentInfo>(`/documents/${documentId}/reprocess`, { method: 'POST' });
  }

  async getDocumentFacts(documentId: number): Promise<DocumentFact[]> {
    return this.request<DocumentFact[]>(`/documents/${documentId}/facts`);
  }

  async deleteDocumentFact(documentId: number, factId: number): Promise<void> {
    return this.request(`/documents/${documentId}/facts/${factId}`, { method: 'DELETE' });
  }

  // ============= Images =============

  async getImages(filters: {
    project_id?: number; category_id?: number; topic_id?: number; page_id?: number;
  } = {}): Promise<ImageInfo[]> {
    const params = new URLSearchParams();
    if (filters.project_id) params.set('project_id', String(filters.project_id));
    if (filters.category_id) params.set('category_id', String(filters.category_id));
    if (filters.topic_id) params.set('topic_id', String(filters.topic_id));
    if (filters.page_id) params.set('page_id', String(filters.page_id));
    const qs = params.toString();
    return this.request<ImageInfo[]>(`/images${qs ? '?' + qs : ''}`);
  }

  async createImage(data: {
    title?: string; alt_text?: string; description?: string; image_url?: string; placeholder_key?: string;
    project_id?: number; category_id?: number; topic_id?: number; page_id?: number;
  }): Promise<ImageInfo> {
    return this.request<ImageInfo>('/images', { method: 'POST', body: JSON.stringify(data) });
  }

  async updateImage(imageId: number, data: {
    title?: string; alt_text?: string; description?: string; image_url?: string; placeholder_key?: string;
  }): Promise<ImageInfo> {
    return this.request<ImageInfo>(`/images/${imageId}`, { method: 'PUT', body: JSON.stringify(data) });
  }

  async uploadImage(
    file: File,
    fields: {
      title?: string; alt_text?: string; description?: string;
      project_id?: number; category_id?: number; topic_id?: number; page_id?: number;
    },
  ): Promise<ImageInfo> {
    // Multipart upload — build FormData and let the browser set the
    // Content-Type boundary (so we don't go through request()'s JSON path).
    const form = new FormData();
    form.append('file', file);
    if (fields.title) form.append('title', fields.title);
    if (fields.alt_text) form.append('alt_text', fields.alt_text);
    if (fields.description) form.append('description', fields.description);
    if (fields.project_id) form.append('project_id', String(fields.project_id));
    if (fields.category_id) form.append('category_id', String(fields.category_id));
    if (fields.topic_id) form.append('topic_id', String(fields.topic_id));
    if (fields.page_id) form.append('page_id', String(fields.page_id));

    const headers: Record<string, string> = {};
    if (this.token) headers['Authorization'] = `Bearer ${this.token}`;
    const response = await fetch(`${API_BASE_URL}/images/upload`, {
      method: 'POST',
      headers,
      body: form,
      // Same-session as `request()` — see the note on login.
      credentials: 'include',
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({ detail: 'Upload failed' }));
      throw new Error(typeof err.detail === 'string' ? err.detail : 'Upload failed');
    }
    return response.json();
  }

  async deleteImage(imageId: number, deleteFile = false): Promise<void> {
    const qs = deleteFile ? '?delete_file=true' : '';
    return this.request(`/images/${imageId}${qs}`, { method: 'DELETE' });
  }

  // ============= Growth Agent config / lifecycle =============

  async getGrowthAgentConfig(projectId: number): Promise<GrowthAgentConfig> {
    return this.request<GrowthAgentConfig>(`/projects/${projectId}/growth-agent/config`);
  }

  async updateGrowthAgentConfig(projectId: number, data: GrowthAgentConfigUpdate): Promise<GrowthAgentConfig> {
    return this.request<GrowthAgentConfig>(`/projects/${projectId}/growth-agent/config`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async triggerGrowthAgentRun(projectId: number): Promise<{ message: string }> {
    return this.request<{ message: string }>(`/projects/${projectId}/growth-agent/run`, {
      method: 'POST',
    });
  }

  async stopGrowthAgent(projectId: number): Promise<{ message: string }> {
    return this.request<{ message: string }>(`/projects/${projectId}/growth-agent/stop`, {
      method: 'POST',
    });
  }

  /** Enqueue the AI regrouping of near-duplicate terms in one topic.
   *  202 — the result arrives as a `terms_regrouped` event. */
  async regroupTerms(
    projectId: number,
    topicId: number,
  ): Promise<{ status: string; job_id: string; topic_id: number; message: string }> {
    return this.request(`/projects/${projectId}/growth-agent/regroup-terms`, {
      method: 'POST',
      body: JSON.stringify({ topic_id: topicId }),
    });
  }

  async getProjectHealth(projectId: number): Promise<{
    total_categories: number;
    total_topics: number;
    total_keywords: number;
    total_unique_keywords: number;
    cross_topic_duplicates: number;
    pinned_keywords: number;
    settled_keywords: number;
    topics: Array<{
      topic_id: number;
      topic_name: string;
      category_name: string;
      keyword_count: number;
      pinned_count: number;
      duplicate_keywords: string[];
    }>;
  }> {
    return this.request(`/projects/${projectId}/growth-agent/health`);
  }

  // ============= Autocomplete =============

  async getAutocompleteSuggestions(
    context: string,
    currentValue: string,
    additionalContext?: Record<string, string>,
    count = 5,
    exclude?: string[],
  ): Promise<string[]> {
    const resp = await this.request<AutocompleteResponse>('/autocomplete', {
      method: 'POST',
      body: JSON.stringify({
        context,
        current_value: currentValue,
        additional_context: additionalContext,
        count,
        exclude: exclude?.length ? exclude : undefined,
      }),
    });
    return resp.suggestions;
  }

  /** Name a piece of text the user is writing (the room name from its brief). */
  async suggestTitle(text: string, context = 'boardroom_name'): Promise<string> {
    const resp = await this.request<{ title: string }>('/autocomplete/title', {
      method: 'POST',
      body: JSON.stringify({ context, text }),
    });
    return resp.title;
  }

  // ============= Dashboard =============

  async getDashboardStats(): Promise<DashboardStats> {
    return this.request<DashboardStats>('/dashboard/stats');
  }

  // ============= Growth Agent =============

  async getAgentSessions(projectId: number, limit = 10, offset = 0): Promise<AgentSession[]> {
    return this.request<AgentSession[]>(`/projects/${projectId}/agent-sessions?limit=${limit}&offset=${offset}`);
  }

  async clearAgentSessions(projectId: number): Promise<void> {
    await this.request<void>(`/projects/${projectId}/agent-sessions`, { method: 'DELETE' });
  }

  async resetGrowthAgentRun(projectId: number): Promise<{ message: string }> {
    return this.request<{ message: string }>(`/projects/${projectId}/growth-agent/reset`, { method: 'POST' });
  }

  // ============= Knowledge Briefs =============

  async getKnowledgeBrief(
    scope: KnowledgeAgentScope,
    scopeId: number
  ): Promise<KnowledgeBrief> {
    return this.request<KnowledgeBrief>(
      `/knowledge-briefs/${scope}/${scopeId}`
    );
  }

  async resetKnowledgeBrief(
    scope: KnowledgeAgentScope,
    scopeId: number
  ): Promise<KnowledgeBrief> {
    return this.request<KnowledgeBrief>(
      `/knowledge-briefs/${scope}/${scopeId}/reset`,
      { method: 'POST' }
    );
  }

  async updateKnowledgeBrief(
    briefId: number,
    payload: { bedrock_heuristics?: string | null; deep_knowledge?: string | null }
  ): Promise<KnowledgeBrief> {
    return this.request<KnowledgeBrief>(`/knowledge-briefs/${briefId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }

  async listKnowledgeBriefVersions(
    scope: KnowledgeAgentScope,
    scopeId: number
  ): Promise<KnowledgeBriefVersionListResponse> {
    return this.request<KnowledgeBriefVersionListResponse>(
      `/knowledge-briefs/${scope}/${scopeId}/versions`
    );
  }

  async revertKnowledgeBriefVersion(
    scope: KnowledgeAgentScope,
    scopeId: number,
    versionId: number
  ): Promise<KnowledgeBrief> {
    return this.request<KnowledgeBrief>(
      `/knowledge-briefs/${scope}/${scopeId}/versions/${versionId}/revert`,
      { method: 'POST' }
    );
  }

  async updateKnowledgeProposal(
    proposalId: number,
    payload: {
      text?: string;
      status?: KnowledgeProposalStatus;
      reject_reason?: string | null;
    }
  ): Promise<KnowledgeProposal> {
    return this.request<KnowledgeProposal>(
      `/knowledge-briefs/proposals/${proposalId}`,
      { method: 'PATCH', body: JSON.stringify(payload) }
    );
  }

  /** Write a rule by hand.
   *
   *  Rules could previously only be created by applying the chat planner's
   *  suggestions, so recording something you already knew meant asking an agent
   *  to suggest it first. Typing into the brief's bedrock text is not an
   *  alternative — that field is derived from the rules and gets rebuilt. */
  async createKnowledgeProposal(
    scope: KnowledgeAgentScope,
    scopeId: number,
    payload: {
      text: string;
      proposal_type?: KnowledgeProposalType;
      source_urls?: string[];
    }
  ): Promise<KnowledgeProposal> {
    return this.request<KnowledgeProposal>(
      `/knowledge-briefs/${scope}/${scopeId}/proposals`,
      { method: 'POST', body: JSON.stringify(payload) }
    );
  }

  async deleteKnowledgeProposal(proposalId: number): Promise<void> {
    await this.request<void>(
      `/knowledge-briefs/proposals/${proposalId}`,
      { method: 'DELETE' }
    );
  }

  // ── Knowledge planner ────────────────────────────────────────────────
  // Chat-driven LLM proposal of bedrock-knowledge suggestions attached
  // to a KnowledgeBrief. Backed by the knowledge_plan API router. The
  // plan + brief are 1:1, so every method is keyed by (scope, scopeId)
  // matching the brief's host scope.

  async getKnowledgePlan(
    scope: KnowledgeAgentScope,
    scopeId: number,
  ): Promise<KnowledgePlanResponse> {
    return this.request<KnowledgePlanResponse>(
      `/knowledge-plan/${scope}/${scopeId}`,
    );
  }

  async sendKnowledgePlanMessage(
    scope: KnowledgeAgentScope,
    scopeId: number,
    content: string,
  ): Promise<KnowledgePlanResponse> {
    return this.request<KnowledgePlanResponse>(
      `/knowledge-plan/${scope}/${scopeId}/messages`,
      { method: 'POST', body: JSON.stringify({ content }) },
    );
  }

  async deleteKnowledgeSuggestion(
    scope: KnowledgeAgentScope,
    scopeId: number,
    suggestionId: number,
  ): Promise<KnowledgePlanResponse> {
    return this.request<KnowledgePlanResponse>(
      `/knowledge-plan/${scope}/${scopeId}/suggestions/${suggestionId}`,
      { method: 'DELETE' },
    );
  }

  // Materialize selected suggestions as real KnowledgeProposal rows on
  // the appropriate brief (resolved per-item from target_scope). Omit
  // `suggestionIds` to apply every suggestion in the working set.
  async applyKnowledgePlan(
    scope: KnowledgeAgentScope,
    scopeId: number,
    suggestionIds?: number[],
  ): Promise<KnowledgePlanApplyResponse> {
    return this.request<KnowledgePlanApplyResponse>(
      `/knowledge-plan/${scope}/${scopeId}/apply`,
      {
        method: 'POST',
        body: JSON.stringify(
          suggestionIds !== undefined ? { suggestion_ids: suggestionIds } : {},
        ),
      },
    );
  }

  // Hard reset: wipe chat history AND working suggestions. Next chat
  // starts from a blank panel. Use Reset button only when the user
  // truly wants a fresh start.
  async resetKnowledgePlan(
    scope: KnowledgeAgentScope,
    scopeId: number,
  ): Promise<KnowledgePlanResponse> {
    return this.request<KnowledgePlanResponse>(
      `/knowledge-plan/${scope}/${scopeId}`,
      { method: 'DELETE' },
    );
  }


  // Bump the plan's session counter — next chat starts with empty
  // history. Old messages stay in the DB. Working suggestions are
  // preserved on purpose: fresh chat, same proposals.
  async endKnowledgePlanSession(
    scope: KnowledgeAgentScope,
    scopeId: number,
  ): Promise<KnowledgePlanResponse> {
    return this.request<KnowledgePlanResponse>(
      `/knowledge-plan/${scope}/${scopeId}/end-session`,
      { method: 'POST' },
    );
  }

  // Force the plan out of "thinking" — manual fallback when the worker
  // died and the user doesn't want to wait for the ~5min auto-recover.
  async clearKnowledgePlanThinking(
    scope: KnowledgeAgentScope,
    scopeId: number,
  ): Promise<KnowledgePlanResponse> {
    return this.request<KnowledgePlanResponse>(
      `/knowledge-plan/${scope}/${scopeId}/clear-thinking`,
      { method: 'POST' },
    );
  }

  // ── Project structure planner ────────────────────────────────────────
  // Chat-driven LLM proposal of the project's category / topic / seed
  // keyword tree. Backed by the structure_plan API router. Every method
  // takes an optional `categoryId`: omitted = project-level plan;
  // present = a separate category-scoped session (different working
  // tree, chat history, snapshots). Both scopes coexist per project.

  async getStructurePlan(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan${planScopeQS(categoryId)}`,
    );
  }

  async sendStructurePlanMessage(
    projectId: number,
    content: string,
    categoryId?: number,
    // tier: which planner answers ('quick' default, 'thorough');
    // rebuild: save the current draft as a version and build from scratch.
    opts?: { tier?: 'quick' | 'thorough'; rebuild?: boolean },
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan/messages${planScopeQS(categoryId)}`,
      { method: 'POST', body: JSON.stringify({ content, ...opts }) },
    );
  }

  async deleteStructurePlanNode(
    projectId: number,
    path: (string | number)[],
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan/nodes${planScopeQS(categoryId)}`,
      { method: 'DELETE', body: JSON.stringify({ path }) },
    );
  }

  async acceptStructurePlan(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanAcceptResponse> {
    return this.request<StructurePlanAcceptResponse>(
      `/projects/${projectId}/structure-plan/accept${planScopeQS(categoryId)}`,
      { method: 'POST' },
    );
  }

  async resetStructurePlan(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan${planScopeQS(categoryId)}`,
      { method: 'DELETE' },
    );
  }

  // Forget who the site is for; the planner's next turn interviews again.
  // The draft and the chat are kept.
  async clearSiteBrief(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan/brief${planScopeQS(categoryId)}`,
      { method: 'DELETE' },
    );
  }

  // Bump the plan's session counter — the next chat turn starts with
  // empty history. Old messages stay in the DB (so a future UI can
  // surface past sessions); they just don't reach the LLM anymore.
  // working_tree is preserved on purpose — fresh chat, same proposal.
  async endStructurePlanSession(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan/end-session${planScopeQS(categoryId)}`,
      { method: 'POST' },
    );
  }

  // Force the plan out of "thinking" — manual fallback when a previous
  // request died (worker crashed) and the user doesn't want to wait for
  // the auto-timeout. The auto-recover path on GET handles the same
  // case after ~5 minutes; this is the impatient version.
  async clearStructurePlanThinking(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan/clear-thinking${planScopeQS(categoryId)}`,
      { method: 'POST' },
    );
  }

  // Bottom-up prune of the project's real structure: drops topic-keywords
  // that have no ManagedPage, then orphan topics, then orphan categories.
  // Always project-wide on the prune side — `categoryId` only narrows
  // the post-prune working_tree re-seed for category-scoped sessions.
  async clearUnusedStructure(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanClearUnusedResponse> {
    return this.request<StructurePlanClearUnusedResponse>(
      `/projects/${projectId}/structure-plan/clear-unused${planScopeQS(categoryId)}`,
      { method: 'POST' },
    );
  }

  async mergeDuplicateStructure(
    projectId: number,
  ): Promise<StructurePlanMergeDuplicatesResponse> {
    return this.request<StructurePlanMergeDuplicatesResponse>(
      `/projects/${projectId}/structure-plan/merge-duplicates`,
      { method: 'POST' },
    );
  }

  // ── Structure plan snapshots (point-in-time history) ────────────────
  // Auto-saved before every LLM revision to working_tree, so the user
  // can revert if a revision dropped good ideas.

  async listStructurePlanSnapshots(
    projectId: number,
    categoryId?: number,
  ): Promise<StructurePlanSnapshotSummary[]> {
    return this.request<StructurePlanSnapshotSummary[]>(
      `/projects/${projectId}/structure-plan/snapshots${planScopeQS(categoryId)}`,
    );
  }

  async getStructurePlanSnapshot(
    projectId: number,
    snapshotId: number,
    categoryId?: number,
  ): Promise<StructurePlanSnapshotDetail> {
    return this.request<StructurePlanSnapshotDetail>(
      `/projects/${projectId}/structure-plan/snapshots/${snapshotId}${planScopeQS(categoryId)}`,
    );
  }

  async restoreStructurePlanSnapshot(
    projectId: number,
    snapshotId: number,
    categoryId?: number,
  ): Promise<StructurePlanResponse> {
    return this.request<StructurePlanResponse>(
      `/projects/${projectId}/structure-plan/snapshots/${snapshotId}/restore${planScopeQS(categoryId)}`,
      { method: 'POST' },
    );
  }


  // ============= Boardroom =============
  // The room's projection is deliberately SMALL (personas, run, counts); items
  // are always paged by `after_id`, and mutations return the row they touched,
  // not the whole room. v1's 810 KB detail refetched after every click is the
  // anti-pattern this shape exists to avoid.

  async listBoardrooms(
    params: { limit?: number; offset?: number; q?: string | null } = {},
  ): Promise<BoardroomPage> {
    const qs = new URLSearchParams();
    if (params.limit != null) qs.set('limit', String(params.limit));
    if (params.offset) qs.set('offset', String(params.offset));
    if (params.q) qs.set('q', params.q);
    const suffix = qs.toString();
    return this.request<BoardroomPage>(`/boardroom${suffix ? `?${suffix}` : ''}`);
  }

  async createBoardroom(body: {
    name: string;
    description: string;
    /** Start from a shape that worked before. */
    recipe_id?: number;
    /** What kind of question, when already known: a trend is a topic. */
    room_kind?: string;
  }): Promise<BoardroomDetail> {
    return this.request<BoardroomDetail>('/boardroom', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async getBoardroom(id: number): Promise<BoardroomDetail> {
    return this.request<BoardroomDetail>(`/boardroom/${id}`);
  }

  /** The tray: what the room has spotted and nobody has answered. */
  async getBoardroomNotices(id: number): Promise<{ notices: BoardroomNotice[]; dismissed?: BoardroomDismissedNotice[] }> {
    return this.request(`/boardroom/${id}/notices`);
  }

  /** What the observer noticed and nobody has marked seen. */
  async getBoardroomObservations(id: number): Promise<{ observations: BoardroomObservation[] }> {
    return this.request(`/boardroom/${id}/observations`);
  }

  /** Put a noticing on the board, say it is not interesting, or take that back. */
  async answerBoardroomNotice(
    id: number,
    body: { key: string; choice: 'take' | 'dismiss' | 'restore'; pinned?: boolean },
  ): Promise<{ notices: BoardroomNotice[]; dismissed?: BoardroomDismissedNotice[]; took: number | null }> {
    return this.request(`/boardroom/${id}/notices`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** The one thing the room needs settled, or null. */
  async getBoardroomDecision(id: number): Promise<{ decision: BoardroomDecision | null }> {
    return this.request(`/boardroom/${id}/decision`);
  }

  /** Answer the room's pending decision; the reply carries the next one. */
  async answerBoardroomDecision(
    id: number,
    body: { kind: string; subject: string; choice: string },
  ): Promise<{ answered: Record<string, string>; decision: BoardroomDecision | null }> {
    return this.request(`/boardroom/${id}/decision`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  // --- recipes ---

  /** `subject` ranks them by how close each recipe's own subject is to it,
   *  which is how a shoes room finds the baggy-clothes shape. */
  async listBoardroomRecipes(subject?: string, limit = 20): Promise<BoardroomRecipe[]> {
    const qs = new URLSearchParams({ limit: String(limit) });
    if (subject?.trim()) qs.set('subject', subject.trim());
    return this.request<BoardroomRecipe[]>(`/boardroom/recipes?${qs.toString()}`);
  }

  /** Set an open room up from a saved shape. Adds; never removes. */
  async applyBoardroomRecipe(id: number, recipeId: number): Promise<BoardroomDetail> {
    return this.request<BoardroomDetail>(`/boardroom/${id}/apply-recipe/${recipeId}`, {
      method: 'POST',
    });
  }

  async saveBoardroomAsRecipe(
    id: number,
    body: { name: string; description?: string; family?: string; extends_id?: number },
  ): Promise<BoardroomRecipe> {
    return this.request<BoardroomRecipe>(`/boardroom/${id}/save-as-recipe`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async deleteBoardroomRecipe(recipeId: number): Promise<void> {
    await this.request<void>(`/boardroom/recipes/${recipeId}`, { method: 'DELETE' });
  }

  // --- deliverables ---
  // Every one returns the whole block (rows + catalogue), so a pin or a drag is
  // one request and the board never has to reconcile two responses.

  /** The dashboard, drawn inside the room's lens when one is given. `lensKey`
   *  comes back on the board, so a board pushed without the lens can be told
   *  from one drawn in it. */
  async getBoardroomDeliverables(
    id: number,
    lens: { tags?: string[]; verified?: string | null; sourced?: string | null; by?: string | null } = {},
    lensKey?: string,
  ): Promise<BoardroomDeliverables> {
    const qs = lensQuery(lens);
    if (lensKey && qs.toString()) qs.set('lens_key', lensKey);
    const tail = qs.toString();
    return this.request<BoardroomDeliverables>(`/boardroom/${id}/deliverables${tail ? `?${tail}` : ''}`);
  }

  /** Per card, how many rows of its whole table match the room's filter. */
  async getBoardroomDeliverableMatches(
    id: number,
    q: string,
    lens: { tags?: string[]; verified?: string | null; sourced?: string | null; by?: string | null } = {},
  ): Promise<{ q: string; matches: Record<string, { hits: number; rows: number }> }> {
    const qs = lensQuery(lens);
    qs.set('q', q);
    return this.request(`/boardroom/${id}/deliverables/matches?${qs.toString()}`);
  }

  /** Write a table's "What this means" again now, when its numbers have moved. */
  async rewriteBoardroomSummary(id: number, deliverableId: number): Promise<{ writing: boolean }> {
    return this.request<{ writing: boolean }>(`/boardroom/${id}/deliverables/${deliverableId}/summary`, {
      method: 'POST',
    });
  }

  async addBoardroomDeliverable(
    id: number,
    body: { kind: string; title?: string; active?: boolean; pinned?: boolean; item_id?: number },
  ): Promise<BoardroomDeliverables> {
    return this.request<BoardroomDeliverables>(`/boardroom/${id}/deliverables`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async patchBoardroomDeliverable(
    id: number,
    deliverableId: number,
    body: {
      title?: string;
      active?: boolean;
      pinned?: boolean;
      position?: number;
      size?: 'tile' | 'half' | 'full';
      status?: string;
    },
  ): Promise<BoardroomDeliverables> {
    return this.request<BoardroomDeliverables>(
      `/boardroom/${id}/deliverables/${deliverableId}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    );
  }

  /** Off the board. The row stays dropped, so picking it up again restores its
   *  place rather than starting from nothing. */
  async dropBoardroomDeliverable(
    id: number,
    deliverableId: number,
    forever = false,
  ): Promise<BoardroomDeliverables> {
    return this.request<BoardroomDeliverables>(
      `/boardroom/${id}/deliverables/${deliverableId}${forever ? '?forever=true' : ''}`,
      { method: 'DELETE' },
    );
  }

  // --- the room chat ---
  // Every one of these returns the whole chat, so a caller can `setChat(await …)`
  // without a second request.

  async getBoardroomChat(id: number): Promise<BoardroomChat> {
    return this.request<BoardroomChat>(`/boardroom/${id}/chat`);
  }

  /** `view` is what the person has open, so "this" in the message has a meaning. */
  async sendBoardroomChat(id: number, content: string, view?: string | null): Promise<BoardroomChat> {
    return this.request<BoardroomChat>(`/boardroom/${id}/chat`, {
      method: 'POST',
      body: JSON.stringify({ content, view: view ?? null }),
    });
  }

  /** Say whether a KIND of thing is what this room is about.
   *
   *  Only meaningful on a solution type: one answer moves everything filed
   *  under it, on and off every table and the work queue with it. */
  async setBoardroomRelevance(
    id: number,
    itemId: number,
    relevance: 'core' | 'related',
  ): Promise<BoardroomItem> {
    return this.request<BoardroomItem>(`/boardroom/${id}/items/${itemId}`, {
      method: 'PATCH',
      body: JSON.stringify({ relevance }),
    });
  }

  /** Stop the reply in progress. Unlocks the chat whether or not the worker
   *  could be reached — being locked out of the conversation is the failure
   *  this exists to end. */
  async stopBoardroomChat(id: number): Promise<BoardroomChat> {
    return this.request<BoardroomChat>(`/boardroom/${id}/chat/stop`, { method: 'POST' });
  }

  /** A fresh conversation. The ROOM keeps everything agreed in the old one. */
  async clearBoardroomChat(id: number): Promise<BoardroomChat> {
    return this.request<BoardroomChat>(`/boardroom/${id}/chat/clear`, { method: 'POST' });
  }

  /** Make an idea a subject. Idempotent: a second press returns the first subject. */
  /** Send a story room's angles to Publish: a topic per angle, its searches as
   *  keywords, under the room's subject (made paused when there is none). */
  async publishBoardroomAngles(
    id: number,
    body: { angle_ids: number[]; project_id?: number | null },
  ): Promise<{
    project_id: number;
    project_name: string;
    made: boolean;
    topics: { angle_id: number; topic_id: number; keywords_added: number; already: boolean }[];
  }> {
    return this.request(`/boardroom/${id}/angles/publish`, { method: 'POST', body: JSON.stringify(body) });
  }

  async promoteBoardroomIdea(
    boardroomId: number,
    itemId: number,
    activate = false,
  ): Promise<BoardroomPromoteResult> {
    return this.request<BoardroomPromoteResult>(
      `/boardroom/${boardroomId}/items/${itemId}/promote?activate=${activate}`,
      { method: 'POST' },
    );
  }

  async updateBoardroom(
    id: number,
    body: { name?: string; description?: string; status?: string; room_kind?: string },
  ): Promise<BoardroomDetail> {
    return this.request<BoardroomDetail>(`/boardroom/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  async deleteBoardroom(id: number): Promise<void> {
    await this.request<void>(`/boardroom/${id}`, { method: 'DELETE' });
  }

  /** ADMIN ONLY: delete every item in the room — and, with `frame`, its frame too.
   *  Refused (409) while a dig runs. */
  async clearBoardroomItems(id: number, opts: { frame?: boolean } = {}): Promise<{ deleted: number }> {
    const q = opts.frame ? '?frame=true' : '';
    return this.request<{ deleted: number }>(`/boardroom/${id}/items${q}`, { method: 'DELETE' });
  }

  async listBoardroomItems(
    id: number,
    params: {
      filter?: string | null;
      kind?: string | null;
      status?: string | null;
      tags?: string[] | null;
      verified?: string | null;
      sourced?: string | null;
      by?: string | null;
      lookup?: string | null;
      /** Words in the title or body. */
      q?: string | null;
      /** Only what the sorter has still to do: place on an axis, or read for content. */
      waiting?: SortingWaiting | null;
      after_id?: number | null;
      before_id?: number | null;
      limit?: number;
    } = {},
  ): Promise<BoardroomItemPage> {
    const qs = new URLSearchParams();
    if (params.filter) qs.set('filter', params.filter);
    if (params.kind) qs.set('kind', params.kind);
    if (params.status) qs.set('status', params.status);
    for (const t of params.tags ?? []) qs.append('tag', t);
    if (params.verified) qs.set('verified', params.verified);
    if (params.sourced) qs.set('sourced', params.sourced);
    if (params.by) qs.set('by', params.by);
    if (params.lookup) qs.set('lookup', params.lookup);
    if (params.q?.trim()) qs.set('q', params.q.trim());
    if (params.waiting) qs.set('waiting', params.waiting);
    if (params.after_id != null) qs.set('after_id', String(params.after_id));
    if (params.before_id != null) qs.set('before_id', String(params.before_id));
    if (params.limit != null) qs.set('limit', String(params.limit));
    const suffix = qs.toString();
    return this.request<BoardroomItemPage>(`/boardroom/${id}/items${suffix ? `?${suffix}` : ''}`);
  }

  async createBoardroomItem(
    id: number,
    body: {
      kind: string;
      title: string;
      body?: string | null;
      payload?: Record<string, unknown>;
      parent_id?: number | null;
      link_kind?: string | null;
    },
  ): Promise<BoardroomItem> {
    return this.request<BoardroomItem>(`/boardroom/${id}/items`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async getBoardroomItem(id: number, itemId: number): Promise<BoardroomItemDetail> {
    return this.request<BoardroomItemDetail>(`/boardroom/${id}/items/${itemId}`);
  }

  /** Just the row, for a caller that only needs to know what the item is. */
  async getBoardroomItemRow(id: number, itemId: number): Promise<BoardroomItem> {
    return this.request<BoardroomItem>(`/boardroom/${id}/items/${itemId}?light=1`);
  }

  async updateBoardroomItem(
    id: number,
    itemId: number,
    body: { title?: string; body?: string | null; status?: string },
  ): Promise<BoardroomItem> {
    return this.request<BoardroomItem>(`/boardroom/${id}/items/${itemId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  /** Ask a settled question again: a persona said there was nothing more to
   *  get, and new information is exactly when that stops being true. */
  async reopenBoardroomClosure(
    id: number,
    itemId: number,
    what: string,
    archetype?: string | null,
  ): Promise<{ reopened: number; item_id: number; what: string }> {
    const qs = archetype ? `?archetype=${encodeURIComponent(archetype)}` : '';
    return this.request(
      `/boardroom/${id}/items/${itemId}/closures/${encodeURIComponent(what)}${qs}`,
      { method: 'POST' },
    );
  }

  async addBoardroomTag(
    id: number,
    itemId: number,
    body: { dimension: string; value: string; receipt_item_id?: number | null; note?: string | null },
  ): Promise<BoardroomTag> {
    return this.request<BoardroomTag>(`/boardroom/${id}/items/${itemId}/tags`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async deleteBoardroomTag(id: number, tagId: number): Promise<void> {
    await this.request<void>(`/boardroom/${id}/tags/${tagId}`, { method: 'DELETE' });
  }

  /** Remove one dimension:value from every item in the room. */
  async deleteBoardroomTagValue(
    id: number,
    dimension: string,
    value: string,
  ): Promise<{ deleted: number; item_ids: number[]; dimension: string; value: string }> {
    const qs = new URLSearchParams({ dimension, value });
    return this.request(`/boardroom/${id}/tags?${qs.toString()}`, { method: 'DELETE' });
  }

  async getBoardroomCounts(
    id: number,
    lens: { filter?: string | null; tags?: string[] | null; verified?: string | null; sourced?: string | null; by?: string | null; kind?: string | null } = {},
  ): Promise<BoardroomFacets> {
    const qs = new URLSearchParams();
    if (lens.filter) qs.set('filter', lens.filter);
    for (const t of lens.tags ?? []) qs.append('tag', t);
    if (lens.verified) qs.set('verified', lens.verified);
    if (lens.sourced) qs.set('sourced', lens.sourced);
    if (lens.by) qs.set('by', lens.by);
    if (lens.kind) qs.set('kind', lens.kind);
    const suffix = qs.toString();
    return this.request(`/boardroom/${id}/counts${suffix ? `?${suffix}` : ''}`);
  }

  /** The frame by hand: words and axes. A person's word is never a proposal. */
  async writeBoardroomFrame(id: number, body: { vocab: Record<string, string>; axes: { dimension: string; meaning: string }[]; reason?: string }): Promise<BoardroomFrameBlock> {
    return this.request(`/boardroom/${id}/frame`, { method: 'POST', body: JSON.stringify(body) });
  }
  async useBoardroomFrame(id: number, frameId: number): Promise<BoardroomFrameBlock> {
    return this.request(`/boardroom/${id}/frame/${frameId}/use`, { method: 'POST' });
  }
  async acceptBoardroomFrame(id: number, frameId: number): Promise<BoardroomFrameBlock> {
    return this.request(`/boardroom/${id}/frame/${frameId}/accept`, { method: 'POST' });
  }
  /** Put the columns back as they were before this change. */
  async undoBoardroomColumns(id: number, frameId: number): Promise<BoardroomFrameBlock> {
    return this.request(`/boardroom/${id}/frame/${frameId}/undo-columns`, { method: 'POST' });
  }
  async dismissBoardroomFrame(id: number, frameId: number): Promise<BoardroomFrameBlock> {
    return this.request(`/boardroom/${id}/frame/${frameId}/dismiss`, { method: 'POST' });
  }

  /** Put an earlier answer back up. A NEW version copying the old one, so the
   *  trail stays a line — and the loop goes on answering from there: this is a
   *  choice, not a lock. */
  async useBoardroomAnswer(id: number, answerId: number): Promise<BoardroomAnswerBlock> {
    return this.request(`/boardroom/${id}/answer/${answerId}/use`, { method: 'POST' });
  }
  /** Take a version off the board. The row stays: a dismissed answer is part of
   *  how the room got here, and the live version before it becomes current. */
  /** `reason` is optional; the next answer pass is shown it with the stance. */
  async dismissBoardroomAnswer(id: number, answerId: number, reason?: string): Promise<BoardroomAnswerBlock> {
    return this.request(`/boardroom/${id}/answer/${answerId}/dismiss`, {
      method: 'POST',
      body: JSON.stringify({ reason: reason?.trim() || null }),
    });
  }

  /** THE SPEC SHEET, worked out in one pass over every recorded phrase.
   *  The estimate costs nothing, so the button can say what it is about to do.
   *  Starting it names the columns and stops: they land as a proposal, and the
   *  fitting follows when somebody accepts them. */
  async boardroomSheetEstimate(id: number): Promise<BoardroomSheetPile> {
    return this.request(`/boardroom/${id}/sheet`);
  }
  async startBoardroomSheet(id: number): Promise<BoardroomSheetPile & { started: boolean }> {
    return this.request(`/boardroom/${id}/sheet`, { method: 'POST' });
  }

  /** SPLIT A TYPE that turned out to be several markets. The board's only
   *  filing signal is "under no type at all", so a type doing the work of
   *  five is invisible to it — every product is filed and the room reads as
   *  complete. */
  async startBoardroomSplitType(id: number, typeId: number): Promise<{ started: boolean; products: number }> {
    return this.request(`/boardroom/${id}/subtypes/${typeId}`, { method: 'POST' });
  }

  /** Fit the phrases nobody has recorded against a column yet. The fitting
   *  used to run only on accepting a sheet, so every dig since added phrases
   *  nothing ever read against it. */
  async fitBoardroomSheet(id: number): Promise<BoardroomSheetPile & { started: boolean }> {
    return this.request(`/boardroom/${id}/sheet/fit`, { method: 'POST' });
  }

  /** Re-read EVERY phrase against the sheet, the filed ones included. The
   *  cheap fit skips anything already carrying facts, so a column added by a
   *  later pass is never offered to the phrases settled before it existed. */
  async refitBoardroomSheet(id: number): Promise<BoardroomSheetPile & { started: boolean }> {
    return this.request(`/boardroom/${id}/sheet/refit`, { method: 'POST' });
  }

  /** Put the last split back. Synchronous — it is a handful of link deletes,
   *  and somebody waiting to see their board go back should not watch a
   *  spinner. */
  async undoBoardroomSplitType(id: number, typeId: number): Promise<{
    products_unfiled: number;
    kinds_removed: string[];
    kinds_kept: string[];
  }> {
    return this.request(`/boardroom/${id}/subtypes/${typeId}/undo`, { method: 'POST' });
  }

  /** Refocus the room; empty text clears. Returns the current focus and its history. */
  async setBoardroomFocus(id: number, text: string): Promise<{ focus: BoardroomFocus | null; focus_history: BoardroomFocus[] }> {
    return this.request(`/boardroom/${id}/focus`, { method: 'POST', body: JSON.stringify({ text }) });
  }

  /** Your daily budget for sorting after a dig ends, per room. 0 turns it off. */
  async setBoardroomSortingBudget(id: number, tokens: number): Promise<BoardroomTagging> {
    return this.request(`/boardroom/${id}/sorting-budget`, { method: 'PUT', body: JSON.stringify({ tokens }) });
  }

  /** A name and a sentence for following this lens, for the person to edit. */
  async draftBoardroomLead(id: number, lens: BoardroomLeadLens): Promise<{ title: string; text: string }> {
    return this.request(`/boardroom/${id}/leads/draft`, { method: 'POST', body: JSON.stringify({ lens }) });
  }

  /** Follow a new lead (inside `parent_id` when given). */
  async createBoardroomLead(
    id: number,
    body: { title: string; text: string; lens: BoardroomLeadLens; parent_id?: number | null },
  ): Promise<BoardroomLeadBlock> {
    return this.request(`/boardroom/${id}/leads`, { method: 'POST', body: JSON.stringify(body) });
  }

  /** Follow a lead, or (null) go back to the whole room. */
  async followBoardroomLead(id: number, leadId: number | null): Promise<BoardroomLeadBlock> {
    return this.request(`/boardroom/${id}/leads/follow`, { method: 'POST', body: JSON.stringify({ lead_id: leadId }) });
  }

  async editBoardroomLead(id: number, leadId: number, body: { title?: string; text?: string }): Promise<BoardroomLeadBlock> {
    return this.request(`/boardroom/${id}/leads/${leadId}`, { method: 'PATCH', body: JSON.stringify(body) });
  }

  /** Take a lead (and the ones inside it) off the list. */
  /** The notes this room's seats read every turn; the dropped ones too when asked. */
  async listBoardroomNotes(id: number, dropped = false): Promise<{ notes: AgentNote[] }> {
    return this.request(`/boardroom/${id}/notes${dropped ? '?dropped=true' : ''}`);
  }

  /** Drop a note no seat should read again. It is kept, with the reason. */
  async dropBoardroomNote(id: number, noteId: number, reason: string): Promise<{ notes: AgentNote[] }> {
    return this.request(`/boardroom/${id}/notes/${noteId}/drop`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    });
  }

  async dropBoardroomLead(id: number, leadId: number): Promise<BoardroomLeadBlock> {
    return this.request(`/boardroom/${id}/leads/${leadId}`, { method: 'DELETE' });
  }

  /** The lead becomes the room's focus, and the room stops following it. */
  async boardroomLeadToDirection(
    id: number,
    leadId: number,
  ): Promise<BoardroomLeadBlock & { focus: BoardroomFocus | null; focus_history: BoardroomFocus[] }> {
    return this.request(`/boardroom/${id}/leads/${leadId}/direction`, { method: 'POST' });
  }

  /** Every group of near-copy features in the room. */
  async getBoardroomFeatureTwins(id: number): Promise<BoardroomFeatureTwins> {
    return this.request<BoardroomFeatureTwins>(`/boardroom/${id}/feature-twins`);
  }

  /** An AI read of duplicate groups: which near-copies are the same feature.
   *  A proposal only; nothing is merged. */
  async reviewBoardroomFeatureTwins(
    id: number,
    groups: { keep: { id: number; title: string }; members: { id: number; title: string }[] }[],
  ): Promise<{ verdicts: Record<string, { same: boolean; why: string }>; asked: number; answered: number; failed_batches: number }> {
    return this.request(`/boardroom/${id}/feature-twins/review`, { method: 'POST', body: JSON.stringify({ groups }) });
  }

  /** Many feature merges at once: each group's items into its `into`. */
  async mergeBoardroomGroups(
    id: number,
    groups: { into: number; items: number[] }[],
  ): Promise<{ merged: number; failed: { id: number; error: string }[] }> {
    return this.request(`/boardroom/${id}/merge-groups`, { method: 'POST', body: JSON.stringify({ groups }) });
  }

  /** Fold one item into another of the same kind: they are one thing. */
  async mergeBoardroomItem(id: number, itemId: number, intoId: number): Promise<{ merged: number; into: number }> {
    return this.request(`/boardroom/${id}/items/${itemId}/merge-into/${intoId}`, { method: 'POST' });
  }

  /** Two look-alikes are two things: stop offering them as one. */
  async keepBoardroomItemsApart(id: number, itemId: number, otherId: number): Promise<{ kept_apart: number[] }> {
    return this.request(`/boardroom/${id}/items/${itemId}/distinct-from/${otherId}`, { method: 'POST' });
  }

  /** Everything the board knows about one company, product or solution type. */
  async getBoardroomProfile(id: number, itemId: number): Promise<BoardroomProfile> {
    return this.request<BoardroomProfile>(`/boardroom/${id}/profile/${itemId}`);
  }

  /** A derived report over the whole board, narrowed by the feed's lens. */
  async getBoardroomReport<T>(
    id: number,
    report: string,
    lens: { tags?: string[] | null; verified?: string | null; sourced?: string | null; by?: string | null; a?: string | null; b?: string | null; subject?: string | null } = {},
  ): Promise<T> {
    const qs = new URLSearchParams();
    for (const t of lens.tags ?? []) qs.append('tag', t);
    // WHICH CARD, for a kind that can have several. A `list` card's query lives
    // on the card, so the key alone does not say what to draw.
    if (lens.subject != null) qs.set('subject', lens.subject);
    if (lens.verified) qs.set('verified', lens.verified);
    if (lens.sourced) qs.set('sourced', lens.sourced);
    if (lens.by) qs.set('by', lens.by);
    if (lens.a) qs.set('a', lens.a);
    // Sent even when empty: `b=` asks for plain lists, while leaving it off
    // lets the server choose the axis.
    if (lens.b != null) qs.set('b', lens.b);
    const suffix = qs.toString();
    return this.request<T>(`/boardroom/${id}/reports/${report}${suffix ? `?${suffix}` : ''}`);
  }

  async approveBoardroomTag(id: number, tagId: number): Promise<BoardroomTag> {
    return this.request<BoardroomTag>(`/boardroom/${id}/tags/${tagId}/approve`, { method: 'POST' });
  }

  async listBoardroomArchetypes(): Promise<BoardroomArchetype[]> {
    return this.request<BoardroomArchetype[]>('/boardroom/meta/archetypes');
  }

  async updateBoardroomPersona(
    id: number,
    personaId: number,
    body: { is_active?: boolean; name?: string; model?: string | null },
  ): Promise<BoardroomPersona> {
    return this.request<BoardroomPersona>(`/boardroom/${id}/personas/${personaId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  async removeBoardroomPersona(id: number, personaId: number): Promise<void> {
    await this.request<void>(`/boardroom/${id}/personas/${personaId}`, { method: 'DELETE' });
  }

  async getBoardroomPersonaTranscript(
    id: number,
    personaId: number,
    session?: number | null,
  ): Promise<{ session: number | null; messages: BoardroomTranscriptMessage[] }> {
    const qs = session != null ? `?session=${session}` : '';
    return this.request(`/boardroom/${id}/personas/${personaId}/transcript${qs}`);
  }

  async listBoardroomRuns(id: number, limit = 20): Promise<BoardroomRun[]> {
    return this.request<BoardroomRun[]>(`/boardroom/${id}/runs?limit=${limit}`);
  }

  async startBoardroomRun(
    id: number,
    body: {
      intent: BoardroomRunIntent;
      token_budget: number;
      directive?: string | null;
      focus_archetype?: string | null;
      focus_item_id?: number | null;
      scope?: BoardroomRunScope | null;
    },
  ): Promise<BoardroomRun> {
    return this.request<BoardroomRun>(`/boardroom/${id}/runs`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** Process the results nobody has read yet: a short dig with no new
   *  searches, its budget sized to them by the server. */
  async processBoardroomResults(id: number): Promise<BoardroomRun> {
    return this.request<BoardroomRun>(`/boardroom/${id}/process`, { method: 'POST' });
  }

  async stopBoardroomRun(id: number, runId: number): Promise<BoardroomRun> {
    return this.request<BoardroomRun>(`/boardroom/${id}/runs/${runId}/stop`, { method: 'POST' });
  }

  /** The boardroom feeding this subject, or null. */
  async getRoomForSubject(projectId: number): Promise<LinkedRoom | null> {
    return this.request<LinkedRoom | null>(`/boardroom/for-subject/${projectId}`);
  }

  /** What a section would seed keyword research with — a preview, not an apply. */
  async getSectionSeeds(boardroomId: number, kind: string): Promise<SectionSeeds> {
    return this.request<SectionSeeds>(
      `/boardroom/${boardroomId}/sections/${kind}/seeds`,
    );
  }

  /** Turn chosen terms into keywords on a node. The one place room content is
   *  copied rather than read live — see the endpoint for why. */
  async seedFromSection(
    boardroomId: number,
    kind: string,
    body: { topic_id: number; terms: string[] },
  ): Promise<SeedResult> {
    return this.request<SeedResult>(
      `/boardroom/${boardroomId}/sections/${kind}/seed`,
      { method: 'POST', body: JSON.stringify(body) },
    );
  }

  // ============ Site parsers (data-driven page parsers) ============

  async listParserCandidates(includeDismissed = false): Promise<ParserCandidate[]> {
    return this.request<ParserCandidate[]>(
      `/site-parsers/candidates?include_dismissed=${includeDismissed}`,
    );
  }

  async refreshParserCandidates(): Promise<{ job_id: string; status: string }> {
    return this.request(`/site-parsers/candidates/refresh`, { method: 'POST' });
  }

  async dismissParserCandidate(id: number): Promise<ParserCandidate> {
    return this.request<ParserCandidate>(`/site-parsers/candidates/${id}/dismiss`, {
      method: 'POST',
    });
  }

  async buildParserCandidate(id: number): Promise<BuildCandidateResult> {
    return this.request<BuildCandidateResult>(`/site-parsers/candidates/${id}/build`, {
      method: 'POST',
    });
  }

  async listSiteParsers(): Promise<SiteParser[]> {
    return this.request<SiteParser[]>(`/site-parsers`);
  }

  async getSiteParser(id: number): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(`/site-parsers/${id}`);
  }

  async createSiteParser(spec: any, candidateId?: number): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(`/site-parsers`, {
      method: 'POST',
      body: JSON.stringify({ spec, candidate_id: candidateId ?? null }),
    });
  }

  async updateSiteParserSpec(id: number, spec: any): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(`/site-parsers/${id}/spec`, {
      method: 'PUT',
      body: JSON.stringify({ spec }),
    });
  }

  async captureParserSamples(
    id: number,
    urls: string[],
    source: string,
  ): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(`/site-parsers/${id}/capture-samples`, {
      method: 'POST',
      body: JSON.stringify({ urls, source }),
    });
  }

  async loadStoredParserSamples(id: number, limit = 12): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(
      `/site-parsers/${id}/load-stored-samples?limit=${limit}`,
      { method: 'POST' },
    );
  }

  async recaptureParserSamplesViaBrowser(
    id: number,
    urls?: string[],
  ): Promise<{ queued: number; status: string; note: string }> {
    return this.request(`/site-parsers/${id}/recapture-browser`, {
      method: 'POST',
      body: JSON.stringify({ urls: urls ?? null }),
    });
  }

  async addInlineParserSample(
    id: number,
    url: string,
    html: string,
    source: string,
  ): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(`/site-parsers/${id}/samples/inline`, {
      method: 'POST',
      body: JSON.stringify({ url, html, source }),
    });
  }

  async getSiteParserSampleHtml(
    id: number,
    sampleId: number,
  ): Promise<{ id: number; url: string; source: string; usable_raw: boolean; html: string }> {
    return this.request(`/site-parsers/${id}/samples/${sampleId}/html`);
  }

  async rebuildSiteParser(
    id: number,
    sampleIds?: number[],
  ): Promise<BuildCandidateResult> {
    return this.request<BuildCandidateResult>(`/site-parsers/${id}/rebuild`, {
      method: 'POST',
      body: JSON.stringify({ sample_ids: sampleIds ?? null }),
    });
  }

  async previewSiteParser(
    id: number,
    source?: string,
    opts?: { excludeIds?: number[]; full?: boolean },
  ): Promise<ParserBacktestResult> {
    const qs = source ? `?source=${encodeURIComponent(source)}` : '';
    return this.request<ParserBacktestResult>(`/site-parsers/${id}/preview${qs}`, {
      method: 'POST',
      body: JSON.stringify({
        exclude_ids: opts?.excludeIds ?? [],
        full: opts?.full ?? false,
      }),
    });
  }

  async activateSiteParser(id: number, sources: string[]): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(`/site-parsers/${id}/activate`, {
      method: 'POST',
      body: JSON.stringify({ sources }),
    });
  }

  async quarantineSiteParser(id: number): Promise<SiteParser> {
    return this.request<SiteParser>(`/site-parsers/${id}/quarantine`, { method: 'POST' });
  }

  async disableSiteParser(id: number): Promise<SiteParser> {
    return this.request<SiteParser>(`/site-parsers/${id}/disable`, { method: 'POST' });
  }

  async deleteSiteParser(id: number): Promise<{ deleted: number }> {
    return this.request(`/site-parsers/${id}`, { method: 'DELETE' });
  }

  async getSiteParserChat(id: number): Promise<ParserChat> {
    return this.request<ParserChat>(`/site-parsers/${id}/chat`);
  }

  async sendSiteParserChat(
    id: number,
    content: string,
    source?: string,
  ): Promise<ParserChat> {
    return this.request<ParserChat>(`/site-parsers/${id}/chat`, {
      method: 'POST',
      body: JSON.stringify({ content, source: source ?? null }),
    });
  }

  // Starts a fresh session — hides the transcript, keeps the spec and the old
  // messages (they stay in the DB under the previous session number).
  async clearSiteParserChat(id: number): Promise<ParserChat> {
    return this.request<ParserChat>(`/site-parsers/${id}/chat/clear`, {
      method: 'POST',
    });
  }

  // Sizes what un-parsed URL shapes are costing, for the dashboard nudge.
  async getParserOpportunity(): Promise<ParserOpportunity> {
    return this.request<ParserOpportunity>('/site-parsers/opportunity');
  }

  async listSiteParserSpecVersions(id: number): Promise<SiteParserSpecVersion[]> {
    return this.request<SiteParserSpecVersion[]>(`/site-parsers/${id}/spec/versions`);
  }

  // Rolls the parser back to an earlier spec. Append-only server-side, so this is
  // itself undoable; drops to DRAFT and clears approvals like any spec edit.
  async restoreSiteParserSpecVersion(
    id: number,
    version: number,
  ): Promise<SiteParserDetail> {
    return this.request<SiteParserDetail>(
      `/site-parsers/${id}/spec/versions/${version}/restore`,
      { method: 'POST' },
    );
  }

  // ============= Admin settings (secrets) =============

  async getAdminSetting(key: string): Promise<AdminSetting> {
    return this.request<AdminSetting>(`/admin/settings/${key}`);
  }

  // ============= News Beats =============

  async listNewsBeats(): Promise<NewsBeatSummary[]> {
    return this.request<NewsBeatSummary[]>('/news-beats');
  }

  async createNewsBeat(data: NewsBeatCreate): Promise<NewsBeatDetail> {
    return this.request<NewsBeatDetail>('/news-beats', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async getNewsBeat(beatId: number): Promise<NewsBeatDetail> {
    return this.request<NewsBeatDetail>(`/news-beats/${beatId}`);
  }

  async updateNewsBeat(beatId: number, data: NewsBeatUpdate): Promise<NewsBeatDetail> {
    return this.request<NewsBeatDetail>(`/news-beats/${beatId}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  async deleteNewsBeat(beatId: number): Promise<void> {
    await this.request<null>(`/news-beats/${beatId}`, { method: 'DELETE' });
  }

  // The whole attribute set is replaced in one call — the editor is a small
  // local array, so replace-the-set means the client never tracks server ids.
  async replaceNewsBeatAttributes(
    beatId: number,
    attributes: NewsBeatAttribute[],
  ): Promise<NewsBeatDetail> {
    return this.request<NewsBeatDetail>(`/news-beats/${beatId}/attributes`, {
      method: 'PUT',
      body: JSON.stringify(attributes),
    });
  }

  /** Fetch a fresh pool of articles. On a draft beat this wipes the previous
   *  experiment first — the server returns what it cleared in `message`. */
  async runNewsBeat(
    beatId: number,
    opts: { lookback_minutes?: number } = {},
  ): Promise<{ status: string; briefing_id: number; message: string }> {
    return this.request(`/news-beats/${beatId}/run`, {
      method: 'POST',
      body: JSON.stringify(opts),
    });
  }

  /** Judge the articles a run never reached, keeping what it already wrote.
   *  Unlike re-processing this deletes nothing, so it works on a live beat. */
  async continueNewsBriefing(
    briefingId: number,
  ): Promise<{ status: string; briefing_id: number; message: string }> {
    return this.request(`/news-beats/briefings/${briefingId}/continue`, {
      method: 'POST',
    });
  }

  /** Judge a briefing's EXISTING articles again. No GNews request, no re-tagging. */
  async reprocessNewsBriefing(
    briefingId: number,
  ): Promise<{ status: string; briefing_id: number; message: string }> {
    return this.request(`/news-beats/briefings/${briefingId}/reprocess`, {
      method: 'POST',
    });
  }

  /** What the tagger noticed in one run, with a kept/dropped split per tag. */
  async getNewsBriefingTags(briefingId: number): Promise<NewsBriefingTags> {
    return this.request<NewsBriefingTags>(
      `/news-beats/briefings/${briefingId}/tags`,
    );
  }

  /** Put a live beat back into draft. Deletes nothing; unlocks re-processing
   *  and pauses the cadence. */
  async returnNewsBeatToDraft(beatId: number): Promise<NewsBeatDetail> {
    return this.request<NewsBeatDetail>(`/news-beats/${beatId}/draft`, {
      method: 'POST',
    });
  }

  async getNewsBeatPromotePreview(
    beatId: number,
  ): Promise<NewsBeatPromotePreview> {
    return this.request<NewsBeatPromotePreview>(
      `/news-beats/${beatId}/promote-preview`,
    );
  }

  /** Take a beat out of draft. DELETES every briefing, story and tracked story
   *  it produced — confirm with the preview counts before calling. */
  async promoteNewsBeat(beatId: number, activate = true): Promise<NewsBeatDetail> {
    return this.request<NewsBeatDetail>(`/news-beats/${beatId}/promote`, {
      method: 'POST',
      body: JSON.stringify({ activate }),
    });
  }

  async listNewsBriefings(
    beatId: number,
    limit = 20,
    offset = 0,
  ): Promise<NewsBriefingSummary[]> {
    return this.request<NewsBriefingSummary[]>(
      `/news-beats/${beatId}/briefings?limit=${limit}&offset=${offset}`,
    );
  }

  async getNewsBriefing(briefingId: number): Promise<NewsBriefingDetail> {
    return this.request<NewsBriefingDetail>(`/news-beats/briefings/${briefingId}`);
  }

  async cancelNewsBriefing(briefingId: number): Promise<{ status: string }> {
    return this.request(`/news-beats/briefings/${briefingId}/cancel`, {
      method: 'POST',
    });
  }

  async listNewsThreads(
    beatId: number,
    opts: { status?: string; q?: string } = {},
  ): Promise<NewsStoryThread[]> {
    const params = new URLSearchParams();
    if (opts.status) params.set('status', opts.status);
    if (opts.q) params.set('q', opts.q);
    const qs = params.toString();
    return this.request<NewsStoryThread[]>(
      `/news-beats/${beatId}/threads${qs ? `?${qs}` : ''}`,
    );
  }

  async updateNewsThread(
    threadId: number,
    data: { title?: string; digest?: string; status?: string },
  ): Promise<NewsStoryThread> {
    return this.request<NewsStoryThread>(`/news-beats/threads/${threadId}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  async getGNewsStatus(): Promise<{ configured: boolean }> {
    return this.request<{ configured: boolean }>('/news-beats/gnews-status');
  }

  async getNewsBriefingChat(briefingId: number): Promise<NewsBeatChat> {
    return this.request<NewsBeatChat>(`/news-beats/briefings/${briefingId}/chat`);
  }

  // The beat-scoped conversation. Same transcript the briefing routes above
  // reach — the surface only decides which tools the turn runs with.
  async getNewsBeatChat(
    beatId: number,
    surface: NewsBeatSurface = 'tune',
  ): Promise<NewsBeatChat> {
    return this.request<NewsBeatChat>(
      `/news-beats/${beatId}/chat?surface=${surface}`,
    );
  }

  async sendNewsBeatChatMessage(
    beatId: number,
    content: string,
    surface: NewsBeatSurface = 'tune',
    briefingId?: number | null,
  ): Promise<NewsBeatChat> {
    return this.request<NewsBeatChat>(`/news-beats/${beatId}/chat/messages`, {
      method: 'POST',
      body: JSON.stringify({ content, surface, briefing_id: briefingId ?? null }),
    });
  }

  async getNewsBriefingRunLog(briefingId: number): Promise<NewsRunLog> {
    return this.request<NewsRunLog>(`/news-beats/briefings/${briefingId}/run-log`);
  }

  async getNewsBeatVerdict(
    beatId: number,
    briefingId?: number | null,
  ): Promise<NewsBeatVerdict> {
    const query = briefingId ? `?briefing_id=${briefingId}` : '';
    return this.request<NewsBeatVerdict>(`/news-beats/${beatId}/verdict${query}`);
  }

  async sendNewsBriefingChatMessage(
    briefingId: number,
    content: string,
  ): Promise<NewsBeatChat> {
    return this.request<NewsBeatChat>(
      `/news-beats/briefings/${briefingId}/chat/messages`,
      { method: 'POST', body: JSON.stringify({ content }) },
    );
  }

  // --- Artifacts: share links + brand profiles --------------------------------
  // Sharing is an EXPLICIT act. Links are never minted automatically when a
  // briefing runs, or every briefing ever produced would carry a live public
  // token.
  async listShareLinks(params: {
    kind?: string;
    newsBriefingId?: number;
    managedPageId?: number;
    boardroomId?: number;
    boardroomDeliverableId?: number;
    /** Everything shared from one room: its report and each of its views. */
    inBoardroomId?: number;
    includeRevoked?: boolean;
  } = {}): Promise<ShareLink[]> {
    const qs = new URLSearchParams();
    if (params.kind) qs.set('kind', params.kind);
    if (params.newsBriefingId != null) qs.set('news_briefing_id', String(params.newsBriefingId));
    if (params.managedPageId != null) qs.set('managed_page_id', String(params.managedPageId));
    if (params.boardroomId != null) qs.set('boardroom_id', String(params.boardroomId));
    if (params.boardroomDeliverableId != null) {
      qs.set('boardroom_deliverable_id', String(params.boardroomDeliverableId));
    }
    if (params.inBoardroomId != null) qs.set('in_boardroom_id', String(params.inBoardroomId));
    if (params.includeRevoked) qs.set('include_revoked', 'true');
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.request<ShareLink[]>(`/artifacts/share-links${suffix}`);
  }

  async createShareLink(payload: {
    kind: string;
    news_briefing_id?: number;
    managed_page_id?: number;
    boardroom_id?: number;
    boardroom_deliverable_id?: number;
    recipient?: string;
    visibility?: string;
    expires_at?: string | null;
  }): Promise<ShareLink> {
    return this.request<ShareLink>('/artifacts/share-links', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async updateShareLink(
    linkId: number,
    payload: { recipient?: string; visibility?: string; expires_at?: string | null },
  ): Promise<ShareLink> {
    return this.request<ShareLink>(`/artifacts/share-links/${linkId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }

  async revokeShareLink(linkId: number): Promise<ShareLink> {
    return this.request<ShareLink>(`/artifacts/share-links/${linkId}`, { method: 'DELETE' });
  }

  /** Everything the user has produced, in one vocabulary. Derived server-side —
   *  see jcseo/artifacts/registry.py. */
  async listArtifacts(params: {
    kind?: string;
    state?: string;
    projectId?: number;
    /** Where it came from. */
    subject?: string;
    /** Where it publishes to. */
    site?: string;
    /**
     * Publish-path prefix. `''` is MEANINGFUL — it selects the artifacts that are
     * not on a site at all — so this is checked with `!= null`, not for truth.
     */
    path?: string;
    limit?: number;
  } = {}): Promise<ArtifactListResponse> {
    const qs = new URLSearchParams();
    if (params.kind) qs.set('kind', params.kind);
    if (params.state) qs.set('state', params.state);
    if (params.projectId != null) qs.set('project_id', String(params.projectId));
    if (params.subject) qs.set('subject', params.subject);
    if (params.site) qs.set('site', params.site);
    if (params.path != null) qs.set('path', params.path);
    if (params.limit != null) qs.set('limit', String(params.limit));
    const suffix = qs.toString();
    return this.request<ArtifactListResponse>(`/artifacts${suffix ? `?${suffix}` : ''}`);
  }

  /**
   * Promote pages to READY_TO_DEPLOY — but only the ones that would actually
   * deploy. Asks the same question deploy asks, so a page that can't ship says
   * so now rather than at deploy time. A partial success is the normal outcome.
   */
  async bulkMarkPagesReady(pageIds: number[]): Promise<MarkReadyResponse> {
    return this.request<MarkReadyResponse>('/managed-pages/bulk-mark-ready', {
      method: 'POST',
      body: JSON.stringify({ page_ids: pageIds }),
    });
  }

  async listBrandProfiles(): Promise<BrandProfile[]> {
    return this.request<BrandProfile[]>('/artifacts/brands');
  }

  async createBrandProfile(payload: Partial<BrandProfile> & { name: string }): Promise<BrandProfile> {
    return this.request<BrandProfile>('/artifacts/brands', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async updateBrandProfile(brandId: number, payload: Partial<BrandProfile>): Promise<BrandProfile> {
    return this.request<BrandProfile>(`/artifacts/brands/${brandId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }

  // ============= Link Builder =============
  //
  // Link maps are top-level and user-owned, like brainstorm sessions — they are
  // NOT scoped to a project, because the whole point is a map that spans
  // subjects and sites. So none of these take a projectId.

  async listLinkMaps(): Promise<LinkMap[]> {
    return this.request<LinkMap[]>('/link-maps');
  }

  async getLinkMap(mapId: number): Promise<LinkMap> {
    return this.request<LinkMap>(`/link-maps/${mapId}`);
  }

  async createLinkMap(payload: { name: string; description?: string }): Promise<LinkMap> {
    return this.request<LinkMap>('/link-maps', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async updateLinkMap(mapId: number, payload: LinkMapUpdate): Promise<LinkMap> {
    return this.request<LinkMap>(`/link-maps/${mapId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }

  async deleteLinkMap(mapId: number): Promise<void> {
    return this.request<void>(`/link-maps/${mapId}`, { method: 'DELETE' });
  }

  async addLinkMapScope(
    mapId: number,
    payload: { project_id: number; root_topic_id?: number | null },
  ): Promise<LinkMap> {
    return this.request<LinkMap>(`/link-maps/${mapId}/scopes`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  /** Removes the source AND every link that touched it. Snapshotted
   *  server-side; the response carries what it takes to reverse that. */
  async removeLinkMapScope(
    mapId: number,
    scopeId: number,
  ): Promise<LinkMapScopeRemoved> {
    return this.request<LinkMapScopeRemoved>(
      `/link-maps/${mapId}/scopes/${scopeId}`,
      { method: 'DELETE' },
    );
  }

  /** Put a removed source back, then its links, in that order and in one call.
   *  Not two calls from here: the source must be in scope before the edges are
   *  restored, and a failure between the steps would look like it worked. */
  async undoScopeRemoval(
    mapId: number,
    undo: ScopeUndo,
  ): Promise<UndoScopeRemovalResult> {
    return this.request<UndoScopeRemovalResult>(
      `/link-maps/${mapId}/undo-scope-removal`,
      {
        method: 'POST',
        body: JSON.stringify({
          snapshot_id: undo.snapshot_id,
          project_id: undo.project_id,
          root_topic_id: undo.root_topic_id,
          order: undo.order,
        }),
      },
    );
  }

  /** Subjects that could feed this map, with what each would bring.
   *  Pass `projectId` to expand one subject's node tree — one modal open must
   *  not walk every node of every subject. */
  async listLinkMapCandidates(
    mapId: number,
    projectId?: number,
  ): Promise<LinkMapCandidate[]> {
    const qs = projectId != null ? `?project_id=${projectId}` : '';
    return this.request<LinkMapCandidate[]>(`/link-maps/${mapId}/candidates${qs}`);
  }

  async getLinkMapNodes(mapId: number): Promise<LinkMapNodes> {
    return this.request<LinkMapNodes>(`/link-maps/${mapId}/nodes`);
  }

  /** Both kinds of outgoing link — internal edges AND external placements.
   *  They ship in the same block, so they are fetched and shown together. */
  async listLinkMapEdges(
    mapId: number,
    pageId?: number,
  ): Promise<{ edges: LinkEdge[]; external: ExternalPlacement[] }> {
    const qs = pageId != null ? `?page_id=${pageId}` : '';
    return this.request<{ edges: LinkEdge[]; external: ExternalPlacement[] }>(
      `/link-maps/${mapId}/edges${qs}`,
    );
  }

  /** Draws a link by hand. Always locked — see the endpoint for why.
   *  `bidirectional` draws the return link in the SAME request, so a failure
   *  cannot leave a pair the user asked for silently one-way. */
  async createLinkEdge(
    mapId: number,
    payload: {
      page_id: number;
      linked_page_id: number;
      anchor_text?: string;
      bidirectional?: boolean;
    },
  ): Promise<LinkEdge> {
    return this.request<LinkEdge>(`/link-maps/${mapId}/edges`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async updateLinkEdge(
    mapId: number,
    edgeId: number,
    payload: { locked?: boolean; anchor_text?: string; rel?: string },
  ): Promise<LinkEdge> {
    return this.request<LinkEdge>(`/link-maps/${mapId}/edges/${edgeId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }

  async deleteLinkEdge(mapId: number, edgeId: number): Promise<void> {
    return this.request<void>(`/link-maps/${mapId}/edges/${edgeId}`, { method: 'DELETE' });
  }

  /** Removes EVERY link in the map, including locked and hand-drawn ones.
   *  Snapshots first and returns the id, so the caller can offer Undo. */
  async clearAllLinkEdges(mapId: number): Promise<LinkClearResult> {
    return this.request<LinkClearResult>(`/link-maps/${mapId}/edges`, {
      method: 'DELETE',
    });
  }

  async lockAllLinkEdges(mapId: number): Promise<LinkLockResult> {
    return this.request<LinkLockResult>(`/link-maps/${mapId}/edges/lock-all`, {
      method: 'POST',
    });
  }

  async unlockAllLinkEdges(mapId: number): Promise<LinkLockResult> {
    return this.request<LinkLockResult>(`/link-maps/${mapId}/edges/unlock-all`, {
      method: 'POST',
    });
  }

  /** 202 — listen for `link_map_relinked` over WebSocket. */
  async relinkLinkMap(mapId: number): Promise<{ job_id: string; message: string }> {
    return this.request<{ job_id: string; message: string }>(
      `/link-maps/${mapId}/relink`,
      { method: 'POST' },
    );
  }

  async listLinkMapSnapshots(mapId: number): Promise<LinkMapSnapshot[]> {
    return this.request<LinkMapSnapshot[]>(`/link-maps/${mapId}/snapshots`);
  }

  async restoreLinkMapSnapshot(
    mapId: number,
    snapshotId: number,
  ): Promise<{ restored: number; skipped: number; message: string }> {
    return this.request(`/link-maps/${mapId}/snapshots/${snapshotId}/restore`, {
      method: 'POST',
    });
  }

  /** The map one level up: which sites link to which, and how much. Aggregated
   *  server-side over EVERY edge — `/nodes` is capped and would understate. */
  async getLinkMapSiteGraph(mapId: number): Promise<SiteGraph> {
    return this.request<SiteGraph>(`/link-maps/${mapId}/site-graph`);
  }

  /** The individual links behind one ribbon. Site ids are nullable because
   *  "no site yet" is a real bucket and has to be selectable like any other. */
  async getLinkMapSegment(
    mapId: number,
    fromSiteId: number | null,
    toSiteId: number | null,
  ): Promise<SiteGraphSegment> {
    const qs = new URLSearchParams();
    if (fromSiteId !== null) qs.set('from_site_id', String(fromSiteId));
    if (toSiteId !== null) qs.set('to_site_id', String(toSiteId));
    return this.request<SiteGraphSegment>(
      `/link-maps/${mapId}/site-graph/segment?${qs.toString()}`,
    );
  }

  async listExternalTargets(mapId: number): Promise<ExternalTarget[]> {
    return this.request<ExternalTarget[]>(`/link-maps/${mapId}/external-targets`);
  }

  async createExternalTarget(
    mapId: number,
    payload: ExternalTargetInput,
  ): Promise<ExternalTarget> {
    return this.request<ExternalTarget>(`/link-maps/${mapId}/external-targets`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async updateExternalTarget(
    mapId: number,
    targetId: number,
    payload: Partial<ExternalTargetInput>,
  ): Promise<ExternalTarget> {
    return this.request<ExternalTarget>(
      `/link-maps/${mapId}/external-targets/${targetId}`,
      { method: 'PATCH', body: JSON.stringify(payload) },
    );
  }

  async deleteExternalTarget(mapId: number, targetId: number): Promise<void> {
    return this.request<void>(`/link-maps/${mapId}/external-targets/${targetId}`, {
      method: 'DELETE',
    });
  }

  async placeExternalTarget(
    mapId: number,
    targetId: number,
    payload: { page_ids: number[]; anchor_text?: string },
  ): Promise<PlaceExternalResult> {
    return this.request<PlaceExternalResult>(
      `/link-maps/${mapId}/external-targets/${targetId}/place`,
      { method: 'POST', body: JSON.stringify(payload) },
    );
  }

  async unplaceExternalTarget(
    mapId: number,
    targetId: number,
    payload: { page_ids: number[] },
  ): Promise<PlaceExternalResult> {
    return this.request<PlaceExternalResult>(
      `/link-maps/${mapId}/external-targets/${targetId}/unplace`,
      { method: 'POST', body: JSON.stringify(payload) },
    );
  }

  async deleteBrandProfile(brandId: number): Promise<void> {
    return this.request<void>(`/artifacts/brands/${brandId}`, { method: 'DELETE' });
  }

  // --- Site scaffold (the Hugo site designer) ------------------------------

  async getSiteScaffold(siteId: number): Promise<SiteScaffold> {
    return this.request<SiteScaffold>(`/site-scaffold/sites/${siteId}`);
  }

  async updateSiteScaffoldSpec(siteId: number, spec: any): Promise<SiteScaffold> {
    return this.request<SiteScaffold>(`/site-scaffold/sites/${siteId}/spec`, {
      method: 'PUT',
      body: JSON.stringify({ spec }),
    });
  }

  /** Render the SAVED spec. A pure server-side compile — no LLM, no writes. */
  async getSiteScaffoldPreview(
    siteId: number,
    kind: string,
    scheme: string = 'auto',
    path: string = '',
    /** Scope the preview to one deployment plan, and to what it will publish. */
    scope: { planId?: number | null; readyOnly?: boolean } = {},
  ): Promise<SiteScaffoldPreview> {
    const params = new URLSearchParams({ kind, scheme, path });
    if (scope.planId) params.set('plan_id', String(scope.planId));
    if (scope.readyOnly) params.set('ready_only', 'true');
    return this.request(`/site-scaffold/sites/${siteId}/preview?${params.toString()}`);
  }

  async previewSiteScaffoldSpec(
    siteId: number,
    spec: any,
    kind: string,
    scheme: string = 'auto',
    path: string = '',
  ): Promise<SiteScaffoldPreview> {
    return this.request(`/site-scaffold/sites/${siteId}/preview`, {
      method: 'POST',
      body: JSON.stringify({ spec, kind, scheme, path }),
    });
  }

  async getSiteScaffoldPublishPlan(siteId: number): Promise<SiteScaffoldPublishPlan> {
    return this.request<SiteScaffoldPublishPlan>(
      `/site-scaffold/sites/${siteId}/publish-plan`,
    );
  }

  /**
   * Run a REAL `hugo` build of the design and hand back the page it produced.
   *
   * Queued, not awaited: the API image carries no build stack on purpose, so
   * this runs on a worker and the result arrives as a `site_scaffold_build`
   * event.
   */
  async buildSiteScaffold(
    siteId: number,
    path = '',
  ): Promise<{ status: string; site_id: number }> {
    const query = path ? `?path=${encodeURIComponent(path)}` : '';
    return this.request(`/site-scaffold/sites/${siteId}/build${query}`, {
      method: 'POST',
    });
  }

  async publishSiteScaffold(
    siteId: number,
    overwrite = false,
  ): Promise<{ status: string; site_id: number }> {
    return this.request(`/site-scaffold/sites/${siteId}/publish`, {
      method: 'POST',
      body: JSON.stringify({ overwrite }),
    });
  }

  async listSiteScaffoldVersions(siteId: number): Promise<SiteScaffoldSpecVersion[]> {
    return this.request<SiteScaffoldSpecVersion[]>(
      `/site-scaffold/sites/${siteId}/versions`,
    );
  }

  async restoreSiteScaffoldVersion(
    siteId: number,
    version: number,
  ): Promise<SiteScaffold> {
    return this.request<SiteScaffold>(
      `/site-scaffold/sites/${siteId}/versions/${version}/restore`,
      { method: 'POST' },
    );
  }

  async getSiteScaffoldChat(siteId: number): Promise<SiteScaffoldChat> {
    return this.request<SiteScaffoldChat>(`/site-scaffold/sites/${siteId}/chat`);
  }

  async sendSiteScaffoldChat(siteId: number, content: string): Promise<SiteScaffoldChat> {
    return this.request<SiteScaffoldChat>(`/site-scaffold/sites/${siteId}/chat`, {
      method: 'POST',
      body: JSON.stringify({ content }),
    });
  }

  /** Seed a first, unattended design pass — the "Design it for me" button. */
  async startSiteScaffoldDesignPass(siteId: number): Promise<SiteScaffoldChat> {
    return this.request<SiteScaffoldChat>(
      `/site-scaffold/sites/${siteId}/chat/design-it`,
      { method: 'POST' },
    );
  }

  async clearSiteScaffoldChat(siteId: number): Promise<SiteScaffoldChat> {
    return this.request<SiteScaffoldChat>(`/site-scaffold/sites/${siteId}/chat/clear`, {
      method: 'POST',
    });
  }

  /** Start over: resets the DESIGN as well as the conversation. The outgoing
   *  design is snapshotted first, so it stays one click away in the versions
   *  list. */
  async resetSiteScaffold(siteId: number): Promise<SiteScaffold> {
    return this.request<SiteScaffold>(`/site-scaffold/sites/${siteId}/reset`, {
      method: 'POST',
    });
  }

  async setSiteScaffoldBrand(
    siteId: number,
    brandProfileId: number | null,
    apply: boolean,
  ): Promise<SiteScaffold> {
    return this.request<SiteScaffold>(`/site-scaffold/sites/${siteId}/brand`, {
      method: 'POST',
      body: JSON.stringify({ brand_profile_id: brandProfileId, apply }),
    });
  }

  // =========================================================================
  // Watch: standing monitors on competitors, products, industries, own brand.
  //
  // Gated on Product.BOARDROOM server-side, so a boardroom holder needs nothing
  // else. Every one of these 404s rather than 403s for somebody else's row —
  // `verify_watch_*_access` filters by user rather than checking afterwards.
  // =========================================================================

  /** What can be watched and what can be reported. Phase-gated server-side, so
   *  the setup screen never offers a probe nothing can run yet. */
  async getWatchCatalogue(subjectKind?: WatchSubjectKind): Promise<WatchCatalogue> {
    const qs = subjectKind ? `?subject_kind=${subjectKind}` : '';
    return this.request<WatchCatalogue>(`/watch/catalogue${qs}`);
  }

  async getWatchSubjects(): Promise<WatchSubject[]> {
    return this.request<WatchSubject[]>('/watch/subjects');
  }

  async getWatchSubject(subjectId: number): Promise<WatchSubject> {
    return this.request<WatchSubject>(`/watch/subjects/${subjectId}`);
  }

  /** What the last two weeks say about this watch's settings.
   *
   *  A request of its own, not a field on the subject: it reads runs, events and
   *  observations across every check, and the subject page is opened far more
   *  often than anybody reads a diagnosis. */
  /** The same reading across every watch on the account.
   *
   *  The one thing a per-subject verdict cannot say: which watch is drowning out
   *  the others. */
  async getWatchAccountVerdict(windowDays?: number): Promise<WatchVerdict> {
    const query = windowDays ? `?window_days=${windowDays}` : '';
    return this.request<WatchVerdict>(`/watch/verdict${query}`);
  }

  async getWatchVerdict(subjectId: number, windowDays?: number): Promise<WatchVerdict> {
    const query = windowDays ? `?window_days=${windowDays}` : '';
    return this.request<WatchVerdict>(`/watch/subjects/${subjectId}/verdict${query}`);
  }

  async createWatchSubject(body: {
    kind?: WatchSubjectKind;
    name: string;
    home_url?: string | null;
    description?: string | null;
    aliases?: string[];
    probes?: string[];
    activate?: boolean;
  }): Promise<WatchSubject> {
    return this.request<WatchSubject>('/watch/subjects', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async patchWatchSubject(
    subjectId: number,
    body: Partial<{
      name: string;
      home_url: string | null;
      description: string | null;
      guidance: string | null;
      aliases: string[];
      is_active: boolean;
      alert_email: boolean;
      muted_kinds: string[];
      /** REPLACES the whole set, it does not merge — send every override you want kept.
       *  A `null` value is how an override is removed: the server drops non-numbers, so a
       *  key sent as null simply is not in the stored map afterwards. */
      thresholds: Record<string, number | null>;
    }>,
  ): Promise<WatchSubject> {
    return this.request<WatchSubject>(`/watch/subjects/${subjectId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  async deleteWatchSubject(subjectId: number): Promise<void> {
    await this.request<void>(`/watch/subjects/${subjectId}`, { method: 'DELETE' });
  }

  /** Enrol in the schedule. Refused when nothing is active — a LIVE subject with
   *  no probe would look like it was working and capture nothing. */
  async watchSubjectGoLive(subjectId: number): Promise<WatchSubject> {
    return this.request<WatchSubject>(`/watch/subjects/${subjectId}/go-live`, { method: 'POST' });
  }

  async watchSubjectToDraft(subjectId: number): Promise<WatchSubject> {
    return this.request<WatchSubject>(`/watch/subjects/${subjectId}/draft`, { method: 'POST' });
  }

  async addWatchMember(subjectId: number, memberId: number): Promise<WatchSubjectMember[]> {
    return this.request<WatchSubjectMember[]>(`/watch/subjects/${subjectId}/members`, {
      method: 'POST',
      body: JSON.stringify({ member_id: memberId }),
    });
  }

  async removeWatchMember(subjectId: number, memberId: number): Promise<void> {
    await this.request<void>(`/watch/subjects/${subjectId}/members/${memberId}`, {
      method: 'DELETE',
    });
  }

  async getWatchProbes(subjectId: number): Promise<WatchProbe[]> {
    return this.request<WatchProbe[]>(`/watch/subjects/${subjectId}/probes`);
  }

  async createWatchProbe(
    subjectId: number,
    body: {
      kind: string;
      target?: string;
      label?: string;
      config?: Record<string, unknown>;
      interval_minutes?: number;
      activate?: boolean;
    },
  ): Promise<WatchProbe> {
    return this.request<WatchProbe>(`/watch/subjects/${subjectId}/probes`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  /** A rank check's searches as words, in its order. */
  async getWatchProbeKeywords(probeId: number): Promise<{ id: number; value: string }[]> {
    return this.request<{ id: number; value: string }[]>(`/watch/probes/${probeId}/keywords`);
  }

  /** The search engines a rank check can be set to search on. */
  async getWatchEngines(): Promise<{ engines: string[] }> {
    return this.request<{ engines: string[] }>('/watch/engines');
  }

  async patchWatchProbe(
    probeId: number,
    body: Partial<{
      label: string;
      config: Record<string, unknown>;
      /** A rank check's searches, as typed; the server stores them as keyword ids. */
      keywords: string[];
      interval_minutes: number;
      is_active: boolean;
      thresholds: Record<string, number>;
      /** Clears a self-pause AND the failure count, so the next single failure
       *  does not immediately re-pause it. */
      unpause: boolean;
    }>,
  ): Promise<WatchProbe> {
    return this.request<WatchProbe>(`/watch/probes/${probeId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  async deleteWatchProbe(probeId: number): Promise<void> {
    await this.request<void>(`/watch/probes/${probeId}`, { method: 'DELETE' });
  }

  /** Check now. Goes through the same enqueue the scheduler uses, and does NOT
   *  shift the cadence. */
  async runWatchProbe(probeId: number): Promise<WatchRun> {
    return this.request<WatchRun>(`/watch/probes/${probeId}/run`, { method: 'POST' });
  }

  async getWatchRuns(probeId: number, limit = 20): Promise<WatchRun[]> {
    return this.request<WatchRun[]>(`/watch/probes/${probeId}/runs?limit=${limit}`);
  }

  async getWatchRun(runId: number): Promise<WatchRun> {
    return this.request<WatchRun>(`/watch/runs/${runId}`);
  }

  async cancelWatchRun(runId: number): Promise<WatchRun> {
    return this.request<WatchRun>(`/watch/runs/${runId}/cancel`, { method: 'POST' });
  }

  async getWatchObservations(
    probeId: number,
    opts: { targetKey?: string; limit?: number } = {},
  ): Promise<WatchObservation[]> {
    const params = new URLSearchParams();
    if (opts.targetKey) params.set('target_key', opts.targetKey);
    if (opts.limit) params.set('limit', String(opts.limit));
    const qs = params.toString();
    return this.request<WatchObservation[]>(
      `/watch/probes/${probeId}/observations${qs ? `?${qs}` : ''}`,
    );
  }

  /** Every page one check found added and removed, by section. */
  async getWatchRunPages(runId: number): Promise<WatchRunPages> {
    return this.request<WatchRunPages>(`/watch/runs/${runId}/pages`);
  }

  /** Every search one rank check read, against the reading before it. */
  async getWatchRunSearches(runId: number): Promise<WatchRunSearches> {
    return this.request<WatchRunSearches>(`/watch/runs/${runId}/searches`);
  }

  /** Every check a watched subject ran, newest first. */
  async getWatchTimeline(subjectId: number): Promise<WatchTimeline> {
    return this.request<WatchTimeline>(`/watch/subjects/${subjectId}/timeline`);
  }

  async getWatchFeed(
    opts: {
      subjectId?: number;
      family?: string;
      tier?: string;
      unreadOnly?: boolean;
      includeDismissed?: boolean;
      limit?: number;
      beforeId?: number | null;
    } = {},
  ): Promise<WatchFeedPage> {
    const params = new URLSearchParams();
    if (opts.subjectId != null) params.set('subject_id', String(opts.subjectId));
    if (opts.family) params.set('family', opts.family);
    if (opts.tier) params.set('tier', opts.tier);
    if (opts.unreadOnly) params.set('unread_only', 'true');
    if (opts.includeDismissed) params.set('include_dismissed', 'true');
    if (opts.limit) params.set('limit', String(opts.limit));
    if (opts.beforeId != null) params.set('before_id', String(opts.beforeId));
    const qs = params.toString();
    return this.request<WatchFeedPage>(`/watch/feed${qs ? `?${qs}` : ''}`);
  }

  async getWatchUnread(): Promise<WatchUnread> {
    return this.request<WatchUnread>('/watch/unread');
  }

  /** Mark read. Send `before` for "mark all" so an event arriving between the
   *  render and the click is not swallowed. */
  async markWatchSeen(body: { ids?: number[]; before?: string }): Promise<{
    marked: number;
    unread: number;
  }> {
    return this.request<{ marked: number; unread: number }>('/watch/events/seen', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  async dismissWatchEvent(eventId: number): Promise<WatchEvent> {
    return this.request<WatchEvent>(`/watch/events/${eventId}/dismiss`, { method: 'POST' });
  }

  async getWatchPreferences(): Promise<WatchPreferences> {
    return this.request<WatchPreferences>('/watch/preferences');
  }

  async patchWatchPreferences(
    body: Partial<WatchPreferences>,
  ): Promise<WatchPreferences> {
    return this.request<WatchPreferences>('/watch/preferences', {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  }

  // --- the boardroom seam -------------------------------------------------

  /** Track a company from its card. Idempotent — a second press hands back the
   *  watch the first one made. 409s with a sentence pointing at the dig when the
   *  room has no url for it yet. */
  /** Search what people search about one company, and pin its brand report. */
  /** Every tag category in the room: meaning, coverage and values by count. */
  async getBoardroomTags(boardroomId: number): Promise<BoardroomTagList> {
    return this.request<BoardroomTagList>(`/boardroom/${boardroomId}/tags`);
  }

  /** Add an axis, or starting values to one. Merged; returns the Tags panel. */
  async writeBoardroomAxis(boardroomId: number, axis: BoardroomAxisWrite): Promise<BoardroomTagList> {
    return this.request<BoardroomTagList>(`/boardroom/${boardroomId}/axes`, { method: 'POST', body: JSON.stringify(axis) });
  }

  /** The items the sorter skipped on one axis, with its reason for each. */
  async getBoardroomAxisSkipped(boardroomId: number, dimension: string): Promise<BoardroomAxisSkipped> {
    return this.request<BoardroomAxisSkipped>(
      `/boardroom/${boardroomId}/tags/skipped?dimension=${encodeURIComponent(dimension)}`,
    );
  }

  /** Recalculate: sort the room now rather than at the next dig. */
  async sortBoardroomNow(boardroomId: number): Promise<BoardroomTagging> {
    return this.request<BoardroomTagging>(`/boardroom/${boardroomId}/sort`, { method: 'POST' });
  }

  /** Keep the room's taxonomy library. Empty clears it. */
  async writeBoardroomTaxonomy(boardroomId: number, text: string): Promise<{ taxonomy: string }> {
    return this.request(`/boardroom/${boardroomId}/taxonomy`, { method: 'PUT', body: JSON.stringify({ text }) });
  }

  /** What an item is filed under, who filed each, in which dig, from what. */
  /** The latest dig aimed at one item or one table, or null if none. */
  async getBoardroomLatestDig(
    boardroomId: number,
    aim: { itemId?: number; table?: string; runId?: number },
  ): Promise<BoardroomReconRun | null> {
    const q = new URLSearchParams();
    if (aim.runId != null) q.set('run_id', String(aim.runId));
    if (aim.itemId != null) q.set('item_id', String(aim.itemId));
    if (aim.table) q.set('table', aim.table);
    return this.request<BoardroomReconRun | null>(`/boardroom/${boardroomId}/runs/latest?${q}`);
  }

  /** Everything one dig found, grouped by kind. */
  async getBoardroomRunFindings(boardroomId: number, runId: number): Promise<BoardroomRunFindings> {
    return this.request<BoardroomRunFindings>(`/boardroom/${boardroomId}/runs/${runId}/findings`);
  }

  async getBoardroomItemFilings(boardroomId: number, itemId: number): Promise<BoardroomFilings> {
    return this.request<BoardroomFilings>(`/boardroom/${boardroomId}/items/${itemId}/filings`);
  }

  /** Re-check this company's brand searches weekly, with alerts. */
  async watchBoardroomBrandSearches(boardroomId: number, itemId: number): Promise<BoardroomBrandWatch> {
    return this.request<BoardroomBrandWatch>(`/boardroom/${boardroomId}/items/${itemId}/brand-searches/watch`, {
      method: 'POST',
    });
  }

  async startBoardroomBrandSearches(
    boardroomId: number,
    itemId: number,
    body: { side?: 'ours' | 'theirs' } = {},
  ): Promise<BoardroomBrandStart> {
    return this.request<BoardroomBrandStart>(
      `/boardroom/${boardroomId}/items/${itemId}/brand-searches`,
      { method: 'POST', body: JSON.stringify(body) },
    );
  }

  /** Write the brand report up for a marketing or executive team (one model call). */
  async writeBoardroomBrandReport(boardroomId: number, itemId: number): Promise<BoardroomBrand> {
    return this.request<BoardroomBrand>(
      `/boardroom/${boardroomId}/items/${itemId}/brand-searches/write-up`,
      { method: 'POST' },
    );
  }

  /** Find more searches about one company: Google's related searches that
   *  carry its name, all its products, more rivals. */
  async widenBoardroomBrandSearches(boardroomId: number, itemId: number): Promise<BoardroomBrandStart> {
    return this.request<BoardroomBrandStart>(
      `/boardroom/${boardroomId}/items/${itemId}/brand-searches/widen`,
      { method: 'POST' },
    );
  }

  /** Which side the reader is on: "ours" reads findings as threats, "theirs" as openings. */
  async setBoardroomBrandSide(
    boardroomId: number,
    itemId: number,
    side: 'ours' | 'theirs',
  ): Promise<BoardroomBrand> {
    return this.request<BoardroomBrand>(
      `/boardroom/${boardroomId}/items/${itemId}/brand-searches`,
      { method: 'PATCH', body: JSON.stringify({ side }) },
    );
  }

  async trackBoardroomCompany(
    boardroomId: number,
    itemId: number,
    body: { url?: string | null; activate?: boolean } = {},
  ): Promise<WatchTrackResult> {
    return this.request<WatchTrackResult>(
      `/boardroom/${boardroomId}/items/${itemId}/watch`,
      { method: 'POST', body: JSON.stringify(body) },
    );
  }

  /** Watch the market a room is about, with its companies as members. */
  async trackBoardroomMarket(
    boardroomId: number,
    body: { activate?: boolean } = {},
  ): Promise<WatchTrackResult> {
    return this.request<WatchTrackResult>(`/boardroom/${boardroomId}/watch`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }
}

// Build the `?category_id=N` suffix for the structure-plan endpoints.
// Returns "" when undefined (project-level scope) so the same code
// path works for both the project and category panels.
function planScopeQS(categoryId?: number): string {
  return categoryId != null ? `?category_id=${categoryId}` : '';
}

export const api = new ApiService();
export default api;
